import $store from '@/store'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import { isNumber, isNumber2, isString } from '@/utils/validate'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'

import {
  getCacheListByKey,
  getFilterCacheList,
  getObjectByCache,
  getSpecificBasicDataFromCache, resolveCustomJobTypeValue,
  resolveSpecificField2Value, resolveSpecificField2ValueIgnoreCase
} from './basicDataCache'
import { resolveLocalCacheSpecificField2Value, resolveLocalCacheSpecificField2ValueIgnoreCase } from './localDataCache'

import * as NumberUtils from './NumberUtils'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as FileState from '@/class/cargo/model/parameters/FileState'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as CreditHistoryActionConstants from '@/class/cargo/model/parameters/CreditHistoryActionConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { basicCacheKeys, localCacheKeyPrefix } from '@/utils/cacheConfig'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { cacheKeys } from '@/utils/basicDataCache'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { ManifestGoodsInfoConstants } from '@/class/cargo/model/parameters/ManifestGoodsInfoConstants'
import * as StuffyType from '@/class/cargo/model/parameters/StuffyType'
import lang from '@/lang'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as PriceFclDataType from '@/class/cargo/model/parameters/PriceFclDataType'
import * as SpecialPriceSaleState from '@/class/cargo/model/parameters/SpecialPriceSaleState'
import StrUtils from '@/utils/StrUtils'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { User } from '@/class/model/sys/User'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import i18n from '@/lang'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import * as EdiState from '@/class/cargo/model/parameters/EdiState'
import * as commonUtil from '@/utils/commonUtil'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import {
  CREDITDATETYPE_DAY2,
  CREDITDATETYPE_HALFMONTH,
  CREDITDATETYPE_MONTH,
  CREDITDATETYPE_MONTH2,
  CREDITDATETYPE_WEEK
} from '@/class/cargo/model/parameters/ContractConstants'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import {
  BUSINESS_MODELS,
  MASTER_WAYBILL_AVAILABLE,
  MASTER_WAYBILL_SOURCE, SUFFY_TYPES
} from '@/class/cargo/model/parameters/AirExportConstants'
import {
  INSURANCE_AGENT,
  INSURANCE_COMPANY,
  INSURANCE_TYPE, ISSUING_LIABILITY_STATUS,
  ISSUING_STATUS, QUESTIONNAIRE_STATUS
} from '@/class/cargo/model/parameters/InsuranceConstants'
import { CABIN_UNIT_NAMES, PRODUCT_NAMES, PROVISIONING_STATUS } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as JyWarehouseConstants from '@/class/cargo/model/parameters/JyWarehouseConstants'
import { la } from 'pinyin/data/dict-zi-web'
import { IE_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import BigNumber from 'bignumber.js'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { multiply } from '@/utils/commonUtil'
import { FIELD_MULTI_TEXT } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getClaimJumpUrl } from '@/api/external/insureInfo'
import {
  ALL_BIG_BAG_GOODS_TYPE,
  ALL_FULFILLMENT_LABEL,
  BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD,
  BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL,
  BOOKING_ERROR_CODES,
  CONTAINER_DATA_TYPE_POITEMS,
  BOOKING_SEND_METHODS,
  CHARGE_CONFIRM_STATE_AR,
  CHARGE_CONFIRM_STATE_AP,
  COMMON_LOBS,
  CONTAINER_DATA_TYPE_JOB,
  FBA_IE_LOBS,
  INSTRUCTION_EXECUTE_RESULTS,
  INSTRUCTION_SOURCES,
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
  JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL,
  JOB_BOOKING_STATE_VALID_FAIL,
  JOB_BOOKING_STATES_NEW,
  NORMAL_LOBS,
  TRANSPORT_MODES,
  PLATFORM_INSTRUCTION_CODE_JUMP_PAGE,
  LOCATION_STATE_LIST,
  SE,
  SI,
  AE,
  AI,
  RE,
  RI,
  JDY_SEND_STATUS,
  POL_TYPE_SEAPORT,
  PORT_TYPE_SEAPORT,
  PORT_TYPE_AIRPORT,
  CARGO_READY_TIME_TYPE_RANGE,
  CARGO_READY_TIME_RANGES,
  PRICE_JOB_STATES,
  OPEN_PRICE_WARNINGS,
  DOCUMENT_TEMPLATE_TYPE
} from '@/class/cargo/model/parameters/SystemConstants'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import { PUSH_STATES } from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import store from '@/store'
import { COUNTRY_TYPE, LOGIC_APPLIED, PAYMENT_METHOD } from '@/class/cargo/model/parameters/CheckRuleConstants'
import { SYNC_RECALL_STATE } from '@/class/cargo/model/parameters/ChargeConstants'
import { VIRTUAL_BILL_TYPES } from '@/class/cargo/model/parameters/VirtualBillType'
import { BOOKING_TERMS_SEA, getBookingTypeOfSeaByCode } from '@/class/cargo/model/parameters/BookingTerm'
import Model from '@/class/cargo/model/utils/Model'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

class ColumnUtils {
  // private static let INSTANCE:ColumnUtils = null;
  // private let resourceManager:IResourceManager = ResourceManager.getInstance();
  // private let dateFormatter:DateFormatter = new DateFormatter();
  // private let LOGGER:ILogger = Log.getLogger("ColumnUtils");

  // eslint-disable-next-line no-useless-constructor

  constructor() {

  }

  /**
   * 是否包含某个字段
   */
  static ObjectHasOwnProperty(item, fieldName) {
    return Object.prototype.hasOwnProperty.call(item, fieldName)
  }

  // 客户自出单
  static getCustomerSelfReleaseFunction(value) {
    return value === 1 ? i18n.t('Message.Yes') : i18n.t('Message.No')
  }

  static getPayableChargeLockedPerson(item) {
    if (!item) return ''
    const payableChargeLockedPerson = item.payableChargeLockedPerson ||
      item.payableChargeLockPerson ||
      item.payableChargeLockedBy ||
      item.payableChargeLockUser ||
      ''
    const userId = Number(payableChargeLockedPerson || 0)
    if (userId > 0) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', userId, 'chineseName') || payableChargeLockedPerson
    }
    return payableChargeLockedPerson
  }

  /**
   * 跨tenant委托历史状态（自行判断是委托方还是接收方）
   */
  static crossTenantHisStateCommonFun(item, value) {
    let result = ''
    if (item != null && ColumnUtils.ObjectHasOwnProperty(item, 'relatedJob') && ColumnUtils.ObjectHasOwnProperty(item, 'trustFromJob')) {
      if (item.relatedJob) {
        result = ColumnUtils.crossTenantHisStateFunc(item, 'relatedJob', value)
      } else if (item.trustFromJob) {
        result = ColumnUtils.crossTenantHisStateReceiverFunc(item, 'trustFromJob', value)
      }
    }
    return result
  }

  /**
   * 跨tenant委托历史状态(委托方)
   */
  static crossTenantHisStateFunc(item, fieldName, value) {
    if (item === null || !ColumnUtils.ObjectHasOwnProperty(item, fieldName) || value === null) return ''
    const result = SystemConstants.getCommonState(value, SystemConstants.CROSS_TENANT_HISTORY_STATES)
    return result ? result.chineseName : ''
  }

  /**
   * 跨tenant委托历史状态(接收方)
   */
  static crossTenantHisStateReceiverFunc(item, fieldName, value) {
    if (item === null || !ColumnUtils.ObjectHasOwnProperty(item, fieldName) || value === null) return ''
    const result = SystemConstants.getCommonState(value, SystemConstants.CROSS_TENANT_HISTORY_STATES_RECEIVER)
    return result ? result.chineseName : ''
  }

  /**
   * 订舱性质
   */
  static bookingTermLabelFunction(item, value) {
    if (!ColumnUtils.ObjectHasOwnProperty(item, 'bookingTerm')) return ''
    const bookingTerm = item.lob === 'SE' ? BookingTerm.getBookingTypeOfSeaByCode(value) : BookingTerm.getBookingTypeByCode(value)
    return !bookingTerm ? '' : ($store.getters.language === 'zh' ? bookingTerm.chineseName : bookingTerm.englishName)
  }

  /**
   * 约价性质
   */
  static priceNatureLabelFunction(value) {
    const bookingTerm = BookingTerm.getBookingTypeOfSeaByCode(value)
    return !bookingTerm ? '' : ($store.getters.language === 'zh' ? bookingTerm.chineseName : bookingTerm.englishName)
  }

  /**
   * 处理有效期
   *
   */

  static validityPeriodLabelFunction(item) {
    if (item) {
      if (item.validityStart && item.validityEnd) {
        return ColumnUtils.formateDateToString(item.validityStart, 'yyyy-MM-dd') + ' ' + i18n.t('CargoMsg.Cargo_To') + ' ' + ColumnUtils.formateDateToString(item.validityEnd, 'yyyy-MM-dd')
      } else if (item.validityStart) {
        return ColumnUtils.formateDateToString(item.validityStart, 'yyyy-MM-dd') + ' ' + i18n.t('CargoMsg.Cargo_FROM')
      } else if (item.validityEnd) {
        return i18n.t('CargoMsg.Cargo_To') + ' ' + ColumnUtils.formateDateToString(item.validityEnd, 'yyyy-MM-dd')
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  /**
   * 舱保处理
   * @param item
   * @returns {*|string}
   */
  static cabinGuaranteeRemarkLabelFunction(item) {
    if (item) {
      if (!item.cabinGuarantee) {
        return i18n.t('CargoMsg.Cargo_None')
      } else {
        return i18n.t('CargoMsg.Cargo_HaveHas') + '(' + item.cabinQuantity + ' ' + CommonState.getNameByCode(SeaExportConstants.CABIN_UNIT_NAMES, item.cabinUnit) + ')'
      }
    } else {
      return ''
    }
  }

  /**
   * 适用品名
   */
  static applicableProductsLabelFunction(value) {
    if (value) {
      return CommonState.getNameByCode(SeaExportConstants.PRODUCT_NAMES, value)
    } else {
      return ''
    }
  }

  /**
   * 订舱性质
   */
  static bookingTermSILabelFunction(item, value) {
    if (value === null) return ''
    const bookingTerm = BookingTerm.getBookingTypeOfSeaByCode(value)
    return bookingTerm === null ? '' : ($store.getters.language === 'zh' ? bookingTerm.chineseName : bookingTerm.englishName)
  }
  /**
   * 配舱状态
   */
  static bookingStateLabelFunction(value) {
    return CommonState.getNameByCode(AirExportConstants.BOOKING_STATES, value)
  }
  /**
   * 约价性质
   * @param item
   * @param value
   * @returns {String|string}
   */
  static bookingTermLabelFunction2(value) {
    const type = value
    let str = ''
    if (type === 'SB') { str = i18n.t('Message.SelfBooking') }
    if (type === 'DB') { str = i18n.t('Message.CommissionedBooking') }
    if (type === 'CB') { str = i18n.t('Message.CustomerSelfBooking') }
    if (type === 'OS') { str = i18n.t('Message.OwnContractPrice') }
    if (type === 'CS') { str = i18n.t('Message.CustomerOffer') }
    if (type === 'DB') { str = i18n.t('Message.CommissionedBooking') }
    if (type === 'AS') { str = i18n.t('Message.OverseasAgentContractPrice') }
    if (type === 'NS') { str = i18n.t('Message.UncommittedPrice') }
    if (type === 'BC') { str = i18n.t('Message.BuyerLCL') }
    if (type === 'PS') { str = i18n.t('Message.PeerAgreementPrice') }
    return str
  }

  /**
   * 显示勾选
   */
  static checkLabelFunc(item, value) {
    const str = value
    if (str === 'true' || str === '1') { return '√' }
    return ''
  }

  /**
   * 出单方式
   */
  static mblOnlyLabelFunction(value) {
    if (value === null) return ''
    return value ? i18n.t('Message.DirectBusiness') : i18n.t('Message.SplittingBusiness')
  }

  /**
   * 箱量描述
   */
  static containerDescLabelFunc(desc) {
    if (!desc) return ''
    return desc ? desc.split('\n').join(',') : ''
  }

  /**
   * 格式化箱型箱量描述
   * 将 "1*40GP\n1*45GP\n1*20GP" 格式转换为 "40GP X1,45GP X1,20GP X1"
   */
  static formatContainerDescFunc(desc) {
    if (!desc) return ''
    return desc
      .split('\n')
      .map(item => {
        const [count, type] = item.split('*')
        return `${type} X${count}`
      })
      .join(',')
  }

  /**
   * 本地服务
   */
  static loadingTermLabelFunction(value) {
    const stuffyType = StuffyType.getStuffyTypeByCode(value)
    return stuffyType ? stuffyType.chineseName : ''
  }

  /**
   * 本地服务
   */
  static loadingTermNewLabelFunction(item, value) {
    if (!item) return ''
    let loadingTerm = ''
    if (item.warehousing) {
      loadingTerm = i18n.t('Message.InnerPacking')
    }
    if (item.landTransportation) {
      loadingTerm = loadingTerm + i18n.t('Message.DoorPointPacking')
    }
    if (item.selfDeliver) {
      loadingTerm = loadingTerm + i18n.t('Message.SelfPullingAndSelfSending')
    }
    if (item.otherService) {
      if (item.otherRemark) {
        loadingTerm = loadingTerm + i18n.t('SeaExport.Other') + '(' + item.otherRemark + '),'
      } else {
        loadingTerm = loadingTerm + i18n.t('SeaExport.Other') + ','
      }
    }
    if (item.customs) {
      loadingTerm = loadingTerm + i18n.t('Message.DeclareAtCustoms')
    }
    if (item.heating) {
      loadingTerm = loadingTerm + i18n.t('Message.Fumigation')
    }
    if (item.comercialInspectation) {
      loadingTerm = loadingTerm + i18n.t('Message.CommodityInspection')
    }
    if (item.ams) {
      loadingTerm = loadingTerm + 'AMS/ENS,'
    }
    if (item.booking) {
      loadingTerm = loadingTerm + i18n.t('Message.BookingSpace')
    }
    if (loadingTerm !== '') {
      loadingTerm = loadingTerm.substring(0, loadingTerm.length - 1)
    }
    return loadingTerm
  }

  static loadingPortOfDestinationServicesLabelFunction(item) {
    if (!item) return ''
    const term = []
    if (item.destPortCustomsClearance) {
      term.push(i18n.t('SeaExport.PortOfDestinationCustomsClearance'))
    }
    if (item.usCustomsClearance) {
      term.push(i18n.t('queryJob.UsCustomsClearance'))
    }
    if (item.dischargingPortDoor) {
      term.push(i18n.t('SeaExport.DispatchVehiclesAtDestination'))
    }
    return term.join(',')
  }

  /**
   * MBL提单方式
   */
  static MBLBlTypeLabelFunc(cacheKey, releaseType) {
    let str = ''
    if (releaseType === null) return str
    if (releaseType === 1) {
      str = 'ORIGINAL'
    }
    if (releaseType === 2) {
      str = 'SURRENDERED'
    }
    if (releaseType === 3) {
      str = 'SEA WAYBILL'
    }
    if (str !== '') return str
    const lookupResult = getFilterCacheList(cacheKey, (item) => {
      return item.blType === BlModeType.MBL.code && item.serialNumber === Number(releaseType)
    })
    if (lookupResult.length > 0) {
      str = lookupResult[0]['name']
    }
    return str
  }

  /**
   * HBL提单方式
   */
  static HBLBlTypeLabelFunc(cacheKey, releaseType) {
    let str = ''
    if (releaseType === null) return str
    if (releaseType === 1) {
      str = 'ORIGINAL'
    }
    if (releaseType === 2) {
      str = 'SURRENDERED'
    }
    if (releaseType === 3) {
      str = 'SEA WAYBILL'
    }
    if (str !== '') return str
    const lookupResult = getFilterCacheList(cacheKey, (item) => {
      return item.blType === BlModeType.HBL.code && item.serialNumber === releaseType
    })
    if (lookupResult.length > 0) {
      str = lookupResult[0]['name']
    }
    return str
  }

  /**
   * HBL提单方式
   */
  static getBlModeSerialNumberByName(name) {
    const lookupResult = getFilterCacheList(TYPE_NAMES.basic_data_BlMode, (item) => {
      return item.blType === BlModeType.HBL.code && (item.localName === name || item.name === name)
    })
    let serialNumber = 1
    if (lookupResult.length > 0) {
      serialNumber = lookupResult[0]['serialNumber']
    }
    return serialNumber
  }

  static getHBLBillReleaseTypeByCode(type, code) {
    if (!code) {
      return ''
    }
    if (code === 1) {
      return i18n.t('SeaExport.OriginalNormal')
    } else if (code === 2) {
      return i18n.t('SeaExport.TelexRelease')
    } else if (code === 3) {
      return 'SEA WAYBILL'
    } else {
      const r = getFilterCacheList(TYPE_NAMES.basic_data_BlMode, (item) => {
        return item.blType === type && (item.serialNumber === code)
      })
      if (r && r.length > 0) {
        return r[0]['name']
      }
      return ''
    }
  }
  static getBlModeList(code) {
    // HBL提单方式
    const dataProvider = []
    const code1 = {}
    code1.code = 1
    code1.chineseName = 'ORIGINAL'
    code1.englishName = 'ORIGINAL'
    const code2 = {}
    code2.code = 2
    code2.chineseName = 'SURRENDERED'
    code2.englishName = 'SURRENDERED'
    const code3 = {}
    code3.code = 3
    code3.chineseName = 'SEA WAYBILL'
    code3.englishName = 'SEA WAYBILL'
    dataProvider.push(code1)
    dataProvider.push(code2)
    dataProvider.push(code3)
    const hblMode = getFilterCacheList(TYPE_NAMES.basic_data_BlMode, (item) => {
      return item.blType === code
    })
    for (const blMode of hblMode) {
      dataProvider.push({ code: blMode.serialNumber, chineseName: blMode.localName, englishName: blMode.name })
    }
    let searchField = new AdvancedSearchField()
    searchField.itemType = 'select'
    searchField.action = 2
    searchField.multiple = 1
    searchField.defaultValue = []
    searchField.itemLabel = 'CargoMsg.Cargo_BLMode'
    searchField.itemName = 'cargoDoc.RELEASE_TYPE'
    if (code === BlModeType.HBL.code) {
      searchField.itemLabel = 'CargoMsg.Cargo_HBLMode'
    }
    searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
    searchField.dataProvider = dataProvider
    const defaultSearchFields = []
    defaultSearchFields.push(searchField.formatObj2Json())

    // 提单种类
    const billTypes = BillType.BILL_TYPE_VALUES.map(item => {
      return { code: item.serialNumber, chineseName: item.localName, englishName: item.name }
    })

    // HBL提单种类
    searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.ADD_ACTION
    searchField.itemType = 'select'
    searchField.multiple = 1
    searchField.itemCondition = []
    searchField.defaultConditionVal = ''
    searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
    searchField.itemName = 'job.TYPE_HBL'
    searchField.itemLabel = 'SeaExport.HBLBlProperty'
    searchField.itemValue = []
    searchField.defaultSelected = 0
    searchField.selected = 0
    searchField.dropdownDataRef = ''
    searchField.lock = false
    searchField.defaultValue = []
    searchField.dataProvider = billTypes
    defaultSearchFields.push(searchField.formatObj2Json())

    // 主票业务编号
    searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.ADD_ACTION
    searchField.itemType = 'multiText'
    searchField.multiple = 0
    searchField.itemCondition = []
    searchField.defaultConditionVal = ''
    searchField.fieldType = 'FIELD_MULTI_TEXT'
    searchField.itemName = 'job.LCL_MASTER_NO'
    searchField.itemLabel = 'SeaExport.MasterBusinessNo'
    searchField.itemValue = []
    searchField.defaultSelected = 0
    searchField.selected = 0
    searchField.dropdownDataRef = ''
    searchField.lock = false
    searchField.defaultValue = []
    searchField.dataProvider = billTypes
    defaultSearchFields.push(searchField.formatObj2Json())

    return defaultSearchFields
  }
  /**
   * MBL提单种类
   * @param typeMBL
   * @returns {string}
   */
  static typeMBLLabelFunc(typeMBL) {
    let str = ''
    if (typeMBL === '') return str
    if ($store.getters.language === 'zh') {
      if (typeMBL === 1 || typeMBL === 0) {
        str = BillType.NORMAL_BILL_TYPE.chineseName
      } else if (typeMBL === 2) {
        str = BillType.SPLIT_BILL_TYPE.chineseName
      } else if (typeMBL === 3) {
        str = BillType.MERGE_BILL_TYPE.chineseName
      }
    } else {
      if (typeMBL === 1 || typeMBL === 0) {
        str = BillType.NORMAL_BILL_TYPE.englishName
      } else if (typeMBL === 2) {
        str = BillType.SPLIT_BILL_TYPE.englishName
      } else if (typeMBL === 3) {
        str = BillType.MERGE_BILL_TYPE.englishName
      }
    }
    return str
  }

  /**
   * 形式分单方式
   */
  static formalHblReleaseTypeLabelFunc(value) {
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, SystemConstants.RELEASE_TYPE)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }

  /**
   * 形式分单种类
   */
  static formalHblTypeLabelFunc(value) {
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, VIRTUAL_BILL_TYPES)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }
  /**
   * 提单状态
   * @param cfmState
   * @returns {string}
   */
  static cfmStatusLabelFunc(cfmState) {
    if (cfmState === '' || cfmState === null) return ''
    const cfm = CargoDocCfmState.getCargoDocCfmStateByCode(cfmState)
    return cfm ? ($store.getters.language === 'zh' ? cfm.chineseName : cfm.englishName) : ''
  }
  /**
   * 提单签发状态
   * @param cfmState
   * @returns {string}
   */
  static bliStatusLabelFunc(cfmState) {
    if (cfmState === '' || cfmState === null) return ''
    const cfm = CargoDocCfmState.getCargoDocBliStateByCode(cfmState)
    return cfm ? ($store.getters.language === 'zh' ? cfm.chineseName : cfm.englishName) : ''
  }

  /**
   * 放单状态
   * @param releaseState
   * @returns {string}
   */
  static releaseStateLabelFunc(releaseState) {
    if (releaseState === '' || releaseState === null) return ''
    const release = ReleaseState.getReleaseStateByCode(releaseState)
    return release ? ($store.getters.language === 'zh' ? release.chineseName : release.englishName) : ''
  }

  /**
   * HBL提单种类
   * @param typeHBL
   * @returns {string}
   */
  static typeHBLLabelFunc(typeHBL) {
    let str = ''
    if (typeHBL === '') return str
    if ($store.getters.language === 'zh') {
      if (typeHBL === 1 || typeHBL === 0) {
        str = BillType.NORMAL_BILL_TYPE.chineseName
      } else if (typeHBL === 2) {
        str = BillType.SPLIT_BILL_TYPE.chineseName
      } else if (typeHBL === 3) {
        str = BillType.MERGE_BILL_TYPE.chineseName
      }
    } else {
      if (typeHBL === 1 || typeHBL === 0) {
        str = BillType.NORMAL_BILL_TYPE.englishName
      } else if (typeHBL === 2) {
        str = BillType.SPLIT_BILL_TYPE.englishName
      } else if (typeHBL === 3) {
        str = BillType.MERGE_BILL_TYPE.englishName
      }
    }
    return str
  }

  /**
   * 业务类型
   */
  static jobBussStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.LOBS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 邮件对象
   */
  static emailAccountLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.MAIL_ACCOUNT_TYPE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 收付款类型
   */
  static receiptPaymentTypeLabelFunc(value) {
    const state = SystemConstants.getCommonState(Number(value), ClearingConstants.AMOUNT_RECEIVE_TYPES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * FBA多个目的地配送方式
   */
  static multipleFbaDestinationDistribution(cacheKey, sourceField = '', sourceValue) {
    const targetField = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    if (!sourceValue) {
      return ''
    }
    const labels = []
    for (const value of sourceValue.split(',')) {
      const numberVal = Number(value)
      const label = resolveLocalCacheSpecificField2Value(cacheKey, sourceField, numberVal, targetField)
      labels.push(label)
    }
    return labels.join(',')
  }

  /**
   * FBA业务类型
   */
  static fbaJobBussStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.FBA_LOBS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 费用方案业务类型
   */
  static chargeSchemeJobBussStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_SCHEME_LOBS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 财务审核箱号处理
   * @param value
   */
  static getJoinContainerNo(value) {
    if (value && value.indexOf(',') > -1) {
      const containerNoArr = value.split(',')
      const containerNoNewArr = []
      for (const containerNoStr of containerNoArr) {
        if (containerNoStr && containerNoStr.trim()) {
          containerNoNewArr.push(containerNoStr)
        }
      }
      console.log('containerNoNewArr', containerNoNewArr.join())
      return containerNoNewArr.join()
    }
    return value
  }

  /**
   * 航线处理
   */
  static resolveAirline(value) {
    if (!value) return ''
    // 将逗号分隔的字符串拆分为数组
    const codes = value.split(',')
    // 对每个 code 查询对应的 name
    const names = codes.map(code =>
      ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', code, 'name')
    )
    // 过滤掉可能的空值并拼接
    return names.filter(Boolean).join(',')
  }
  /**
   * column对应值的缓存转换
   */
  static resolveColumnLabel(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject) {
    const isZh = $store.getters.language === 'zh'
    if (!isZh) {
      if (targetField === 'zhName') {
        targetField = 'enName'
      } else if (targetField === 'chineseName') {
        if ([TYPE_NAMES.basic_data_Packing, TYPE_NAMES.basic_data_Country].includes(cacheKey)) { // 包装,国家英文字段
          targetField = 'name'
        } else {
          targetField = 'englishName'
        }
      } else if (targetField === 'name') {
        if ([TYPE_NAMES.basic_data_Region].includes(cacheKey)) { // 区域英文字段
          targetField = 'nameEnglish'
        }
      }
    }
    const func = cacheKey && cacheKey.startsWith(localCacheKeyPrefix) ? resolveLocalCacheSpecificField2Value : resolveSpecificField2Value
    let label = func(cacheKey, sourceField, sourceValue, targetField, isNeedObject)
    // 若取到的值为空，则交换中英文字段，重新取值
    if (!label) {
      const fields = ['zhName', 'chineseName', 'englishName', 'enName']
      const index = fields.indexOf(targetField)
      if (index >= 0) {
        targetField = fields[3 - index]
      }
      if (isNeedObject) {
        label = func(cacheKey, sourceField, sourceValue, targetField, isNeedObject)
      } else {
        label = func(cacheKey, sourceField, sourceValue, targetField)
      }
    }
    return label
  }

  // 自定义业务类型特殊处理
  static resolveCutomJobTypeLabel(cacheKey, sourceField = '', sourceValue, targetField, lob, isFba) {
    const isZh = $store.getters.language === 'zh'
    if (!isZh) {
      if (targetField === 'name') {
        targetField = 'englishName'
      }
    }
    const func = resolveCustomJobTypeValue
    let label = func(cacheKey, sourceField, sourceValue, targetField, lob, isFba)
    // 若取到的值为空，则交换中英文字段，重新取值
    if (!label) {
      const fields = ['zhName', 'chineseName', 'englishName', 'enName']
      const index = fields.indexOf(targetField)
      if (index >= 0) {
        targetField = fields[3 - index]
      }
      label = func(cacheKey, sourceField, sourceValue, targetField)
    }
    return label
  }

  /**
   * column对应值的缓存转换
   */
  static resolveColumnLabelChargeItemLanguage(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject) {
    let label = ''
    const isZh = $store.getters.language === 'zh'
    if (isZh) {
      label = ColumnUtils.resolveColumnLabel(cacheKey, sourceField, sourceValue, targetField, isNeedObject)
    } else {
      // 新增费用项语言配置逻辑
      const chargeItem = getObjectByCache(cacheKey, sourceField, sourceValue)
      if (!chargeItem) {
        return label
      }
      const uuid = chargeItem.uuid
      label = chargeItem.enName
      const chargeItemLanguages = getFilterCacheList(TYPE_NAMES.basic_data_ChargeItemLanguage, (chargeItem) => {
        return chargeItem.chargeItemUuid === uuid
      })
      const office = $store.getters.currentOffice
      chargeItemLanguages.forEach(chargeItemLanguage => {
        if (office.region && office.region === chargeItemLanguage.regionCode) {
          label = chargeItemLanguage.chargeLanguage
        }
      })
    }
    return label
  }

  /**
   * column对应值的缓存转换（忽略大小写）
   */
  static resolveColumnLabelIgnoreCase(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject, compareFirstPart, methodParams) {
    const isZh = $store.getters.language === 'zh'
    if (targetField === 'zhName' && !isZh) {
      targetField = 'enName'
    } else if (targetField === 'chineseName' && !isZh) {
      targetField = 'englishName'
    }
    const func = cacheKey && cacheKey.startsWith(localCacheKeyPrefix) ? resolveLocalCacheSpecificField2ValueIgnoreCase : resolveSpecificField2ValueIgnoreCase
    let label = func(cacheKey, sourceField, sourceValue, targetField, isNeedObject, compareFirstPart, methodParams)
    // 若取到的值为空，则交换中英文字段，重新取值
    if (!label) {
      const fields = ['zhName', 'chineseName', 'englishName', 'enName']
      const index = fields.indexOf(targetField)
      if (index >= 0) {
        targetField = fields[3 - index]
      }
      label = func(cacheKey, sourceField, sourceValue, targetField, isNeedObject, compareFirstPart, methodParams)
    }
    return label
  }

  /**
   * 运输条款 转换（忽略大小写）
   */
  static resolveColumnLabelFreightTerm(cacheKey, sourceField = '', sourceValue, targetField) {
    if (sourceValue === undefined) {
      return ''
    }
    sourceValue = sourceValue.toUpperCase()
    sourceValue = sourceValue.replace(/\s+TO\s+/g, '-')
    sourceValue = sourceValue.replace(/\s*-\s*/g, '-')
    sourceValue = sourceValue.replace(/\s*\/\s*/g, '-')

    const result = getSpecificBasicDataFromCache(cacheKey)
    // console.log('sourceValue', sourceValue, sourceField, targetField)
    let targetValue = ''
    if (sourceField && targetField) {
      const entity = result.find(item => {
        if (item[sourceField]) {
          let targetValue = item[sourceField]
          targetValue = targetValue.toUpperCase()
          targetValue = targetValue.replace(/\s+TO\s+/g, '-')
          targetValue = targetValue.replace(/\s*-\s*/g, '-')
          targetValue = targetValue.replace(/\s*\/\s*/g, '-')
          return sourceValue == targetValue
        }
        return false
      })
      if (entity) {
        targetValue = entity[targetField] || ''
      }
    }
    // console.log(cacheKey, 'targetValue', targetValue)
    return targetValue
  }

  /**
   * column对应值的缓存转换，原始版支持code转换成name，V2版支持code转换成name、nameEnglish（中英切換）
   */
  static resolveColumnLabelV2(cacheKey, sourceField = '', sourceValue, targetField) {
    const isZh = $store.getters.language === 'zh'
    if (targetField === 'zhName' && !isZh) {
      targetField = 'enName'
    } else if (targetField === 'chineseName' && !isZh) {
      targetField = 'englishName'
    } else if (targetField === 'name' && !isZh) {
      targetField = 'nameEnglish'
    }
    const func = cacheKey && cacheKey.startsWith(localCacheKeyPrefix) ? resolveLocalCacheSpecificField2Value : resolveSpecificField2Value
    let label = func(cacheKey, sourceField, sourceValue, targetField)
    // 若取到的值为空，则交换中英文字段，重新取值
    if (!label) {
      const fields = ['zhName', 'chineseName', 'name', 'nameEnglish', 'englishName', 'enName']
      const index = fields.indexOf(targetField)
      if (index >= 0) {
        targetField = fields[3 - index]
      }
      label = func(cacheKey, sourceField, sourceValue, targetField)
    }
    return label
  }

  /**
   * column对应值的缓存转换(多选)
   */
  static resolveMultipleColumnLabel(cacheKey, sourceField = '', sourceValue, targetField) {
    const isZh = $store.getters.language === 'zh'
    if (targetField === 'zhName' && !isZh) {
      targetField = 'enName'
    } else if (targetField === 'chineseName' && !isZh) {
      targetField = 'englishName'
    }
    const func = cacheKey && cacheKey.startsWith(localCacheKeyPrefix) ? resolveLocalCacheSpecificField2Value : resolveSpecificField2Value
    if (sourceValue === null || sourceValue === undefined) {
      return ''
    }
    const labels = []
    for (const value of sourceValue.toString().split(',')) {
      let label = func(cacheKey, sourceField, value, targetField)
      // 若取到的值为空，则交换中英文字段，重新取值
      if (!label) {
        const fields = ['zhName', 'chineseName', 'englishName', 'enName']
        const index = fields.indexOf(targetField)
        if (index >= 0) {
          targetField = fields[3 - index]
        }
        label = func(cacheKey, sourceField, value, targetField)
      }
      labels.push(label)
    }
    return labels.join(',')
  }

  /**
   * 自定义数据 column对应值的缓存转换(多选)
   */
  static resolveMultipleColumnLabelByCustom(customArray, sourceField = '', sourceValue, targetField) {
    // 如果 customArray 或 sourceValue 为空，直接返回空字符串
    if (!customArray || !sourceValue || !sourceField || !targetField) {
      return ''
    }
    // 将 sourceValue 转换为数组（如果已经是数组则直接使用）
    const sourceValues = Array.isArray(sourceValue) ? sourceValue : sourceValue.toString().split(',')

    // 创建一个映射对象，用于快速查找
    const customMap = customArray.reduce((map, item) => {
      if (item[sourceField]) {
        map[item[sourceField]] = item[targetField] || ''
      }
      return map
    }, {})

    // 根据 sourceValues 查找对应的 targetField 值
    const labels = sourceValues.map(value => customMap[value] || '').filter(label => label)

    // 返回逗号分隔的字符串
    return labels.join(',')
  }

  // 签约状态
  static contractStatusLabFun(value) {
    const isZh = $store.getters.language === 'zh'
    let result
    if (Number(value) === 1) {
      result = SeaExportConstants.CONTRACT_STATE_OUT_OF_DATE
    } else if (Number(value) === 2) {
      result = SeaExportConstants.CONTRACT_STATE_SIGNED
    } else {
      result = SeaExportConstants.CONTRACT_STATE_NO
    }
    return isZh ? result.chineseName : result.englishName
  }

  static getBasicDataCacheList(cacheKey, filterCallback = null) {
    const lookupResult = getFilterCacheList(cacheKey, filterCallback)
    return lookupResult
  }

  static chargeMeasureLabelFun(val) {
    if (!val) { return '' }
    const txt = val
    const cache = ChargeMeasure.CHARGE_MEASURES
    for (var item of cache) {
      if (item.code === txt) {
        if ($store.getters.language === 'zh') {
          return item.chineseName
        } else {
          return item.englishName
        }
      }
    }
    return txt
  }
  /**
   * 揽货性质
   */
  static cargoSourceLabelFunction(type) {
    const cargoSource = CargoSource.getCargoSourceByCode(type)
    return cargoSource === null ? '' : $store.getters.language === 'zh' ? cargoSource.chineseName : cargoSource.englishName
  }

  /**
   * 发送状态
   */
  static sendStatusJdyLabelFunction(value) {
    const state = SystemConstants.getCommonState(Number(value), SystemConstants.JDY_SEND_STATUS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static actionLabelFunction(value) {
    const state = SystemConstants.getCommonState(Number(value), SystemConstants.DOCUMENT_TEMPLATE_TYPE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 税务性质
   */
  static taxNatureLabelFunction(value) {
    const state = SystemConstants.getCommonState(Number(value), SystemConstants.TAX_NATURES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 受控状态
   */
  static controlledLabelFunction(value) {
    let controlled = 'CONTROLLED'
    let notControlled = 'NOT CONTROLLED'
    if ($store.getters.language === 'zh') {
      controlled = '受控'
      notControlled = '不受控'
    }
    return value ? controlled : notControlled
  }

  /**
   * Boolean类型labelFunction
   */
  static booleanLabelFunction(value) {
    let yes = 'YES'
    let no = 'NO'
    if ($store.getters.language === 'zh') {
      yes = '是'
      no = '否'
    }

    return value ? yes : no
  }

  // 业务锁定状态
  static booleanLockedStatusLabelFunc(value) {
    const isZh = $store.getters.language === 'zh'
    if (value) {
      return isZh ? '已锁定' : 'Locked'
    }
    return isZh ? '未锁定' : 'Not Locked'
  }
  /**
   * Boolean类型labelFunction
   */
  static booleanLabelFunctionWitNull(value) {
    if (value !== 0 && value !== 1) {
      return ''
    }
    let yes = 'YES'
    let no = 'NO'
    if ($store.getters.language === 'zh') {
      yes = '是'
      no = '否'
    }

    return value ? yes : no
  }

  /**
   * 账单复核状态处理
   */
  static billingReviewLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, BillingConstants.BILLING_REVIEW)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 综合物流订单类型
   */
  static ieTypesLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ContainerLoadType.IE_TYPES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 应收应付
   */
  static paymentMethodFunc(value) {
    const state = SystemConstants.getCommonState(value, CheckRuleConstants.PAYMENT_METHOD)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 国内国外
   */
  static countryTypeFunc(value) {
    const state = SystemConstants.getCommonState(value, CheckRuleConstants.COUNTRY_TYPE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订单状态
   */
  static jobStateLabelFunc(value) {
    return ColumnUtils.getJobStateCN(value)
  }

  /**
   * 获取Job状态【包含锁单】
   */
  static getJobStateForBlock(job) {
    if (!job) return $store.getters.language === 'zh' ? '状态未知' : 'Status unknown'
    if (JobUtils.isBlockJob(job)) {
      return i18n.t('Message.Locked')
    }
    return this.getJobStateCN(job.jobState)
  }

  /**
   * 费用解锁申请状态标记（unlockApplyStatus：0=审批中 1=解锁中，空/其他不显示）
   */
  static unlockApplyStatusTag(value) {
    const status = value === null || value === undefined || value === '' ? null : Number(value)
    let text = ''
    let color = ''
    let background = ''
    let border = ''
    if (status === 0) {
      text = i18n.t('SeaExport.UnlockApplyApproving')
      color = '#E6A23C'
      background = '#FDF6EC'
      border = '#F5DAB1'
    } else if (status === 1) {
      text = i18n.t('SeaExport.UnlockApplyUnlocking')
      color = '#409EFF'
      background = '#ECF5FF'
      border = '#B3D8FF'
    } else {
      return ''
    }
    return `<span style="display:inline-block;margin-left:4px;padding:0 6px;font-size:12px;line-height:18px;border-radius:3px;vertical-align:middle;color:${color};background:${background};border:1px solid ${border};">${text}</span>`
  }

  static getJobStateCN(state) {
    const isZh = $store.getters.language === 'zh'
    if (state === 0) {
      return isZh ? SystemConstants.STATE_OPERATING.chineseName : SystemConstants.STATE_VERIFYING.englishName
    } else if (state === 1) {
      return isZh ? SystemConstants.STATE_COMMITED.chineseName : SystemConstants.STATE_COMMITED.englishName
    } else if (state === 2) {
      return isZh ? SystemConstants.STATE_VERIFIED.chineseName : SystemConstants.STATE_VERIFIED.englishName
    } else if (state === 3) {
      return isZh ? SystemConstants.STATE_SHUT_OUT.chineseName : SystemConstants.STATE_SHUT_OUT.englishName
    } else if (state === -1) {
      return isZh ? SystemConstants.STATE_VERIFYING.chineseName : SystemConstants.STATE_VERIFYING.englishName
    } else if (state === 11) {
      return isZh ? SystemConstants.STATE_PRE_COMMIT.chineseName : SystemConstants.STATE_PRE_COMMIT.englishName
    } else if (state === 12) {
      return isZh ? SystemConstants.STATE_REJECT.chineseName : SystemConstants.STATE_REJECT.englishName
    } else if (state === 13) {
      return isZh ? SystemConstants.STATE_COMMITTING.chineseName : SystemConstants.STATE_COMMITTING.englishName
    }
    return isZh ? '状态未知' : 'Status unknown'
  }
  // 申请放单状态
  static getApplicationReleaseStatus(state) {
    const isZh = $store.getters.language === 'zh'
    if (state === 0) {
      return isZh ? CheckRuleConstants.LOGIC_NOT_APPLIED.chineseName : CheckRuleConstants.LOGIC_NOT_APPLIED.englishName
    } else if (state === 1) {
      return isZh ? CheckRuleConstants.LOGIC_APPLIED.chineseName : CheckRuleConstants.LOGIC_APPLIED.englishName
    }
  }

  static getPreverifyStateCN(state) {
    const isZh = $store.getters.language === 'zh'
    if (state === 0) {
      return ''
    } else if (state === 1) {
      return isZh ? SystemConstants.VERIFYING_PENDING.chineseName : SystemConstants.VERIFYING_PENDING.englishName
    } else if (state === 2) {
      return isZh ? SystemConstants.VERIFYING_AUDITED.chineseName : SystemConstants.VERIFYING_AUDITED.englishName
    } else if (state === 3) {
      return isZh ? SystemConstants.VERIFYING_REJECT.chineseName : SystemConstants.VERIFYING_REJECT.englishName
    } else if (state === 4) {
      return isZh ? SystemConstants.VERIFYING_LOCK.chineseName : SystemConstants.VERIFYING_LOCK.englishName
    } else if (state === 5) {
      return isZh ? SystemConstants.VERIFYING_REVIEW_THROUGH.chineseName : SystemConstants.VERIFYING_REVIEW_THROUGH.englishName
    } else if (state === 6) {
      return isZh ? SystemConstants.VERIFYING_REVIEW_REFUSAL.chineseName : SystemConstants.VERIFYING_REVIEW_REFUSAL.englishName
    }
    return isZh ? '状态未知' : 'Status unknown'
  }

  /**
   * 格式化保留一位小数
   */
  static number1ColumnLabelFunc(value) {
    return ColumnUtils.formatNumber(value.toString(), 1)
  }

  /**
   * @private
   * @param isReturnZero 格式化是否返回0
   * @param isReturnSpace 格式化是否返回空字符
   * @param isRound 是否进行四舍五入，NumberUtils.formatNumber方法不进行四舍五入，默认否
   */
  static formatNumber(data, precision, isReturnSpace = false, isRound = true, isReturnZero = false) {
    let num = NaN
    if (!data || data === 'NaN') data = 0
    if (isNumber(data)) {
      num = Number(data)
    } else if (isString(data)) {
      num = parseFloat(String(data).replace(/,/g, ''))
    }

    // 如果为0或者非数字，需要返回空字符的情况
    if ((num === 0 || isNaN(num)) && isReturnSpace) {
      return ''
    }

    // 如果为0或者非数字，需要返回0的情况
    if ((num === 0 || isNaN(num)) && isReturnZero) {
      return 0
    }

    // if (num !== 0 && !isNaN(num)) {
    // 如果为0,或者'' ，返回格式 0.00 或0.000
    if (!isNaN(num)) {
      return NumberUtils.formatNumber(num, precision, isRound)
    }
    // return ''
  }

  /**
   * @private
   * 3位小数【0 =》 0.000】
   */
  static returnThreeZeroFormatNumber(value) {
    let result = ColumnUtils.number3ColumnLabelFunc(value)
    if (!result) {
      result = '0.000'
    }
    return result
  }

  /**
   * @private
   * 2位小数【0 =》 0.00】
   */
  static returnTwoZeroFormatNumber(value) {
    let result = ColumnUtils.number2ColumnLabelFunc(value)
    if (!result) {
      result = '0.00'
    }
    return result
  }

  /**
   * 省略小数点后多余的0
   * @param value
   * @param precision
   * @param isRound
   * @param isReturnZero
   * @returns {number}
   */
  static numberOmitZeroColumnLabelFunc(value, precision = 0, isRound = true, isReturnZero = false) {
    return Number(ColumnUtils.formatNumber(value, precision, false, isRound, isReturnZero))
  }
  /**
   * 格式化保留整数
   * @param isRound 是否进行四舍五入，此方法就是不进行四舍五入，故默认否
   */
  static numberColumnLabelFunc(value, precision = 0, isRound = true, isReturnZero = false) {
    return ColumnUtils.formatNumber(value, precision, false, isRound, isReturnZero)
  }

  /**
   * 格式化保留整数
   * @param isRound 是否进行四舍五入，此方法就是不进行四舍五入，故默认否
   */
  static numberColumnLabelFuncWithRange(value, precision = 0, isRound = true, isReturnZero = false, max, min = 0) {
    if (value && value > 0) {
      if (max && max > 0 && value > max) {
        value = max
      }
    } else {
      return min
    }
    return ColumnUtils.formatNumber(value, precision, false, isRound, isReturnZero)
  }

  /**
   * 格式化保留二位小数
   */
  static number2ColumnLabelFunc(value) {
    return ColumnUtils.formatNumber(value, 2)
  }

  /**
   * 格式化保留三位小数
   */
  static number3ColumnLabelFunc(value) {
    return ColumnUtils.formatNumber(value.toString(), 3)
  }

  static realProfitFunc(value) {
    let result = ColumnUtils.number2ColumnLabelFunc(value)
    if (!result) {
      result = '0.00'
    }
    return result
  }

  /**
   * 利润需要四舍五入
   *  CARGO-9609H5财务审核界面，查询页签的利润与业务里面的利润不符
   * @param value
   * @returns {string|number|*|string|undefined}
   */
  static realProfit2Func(value) {
    let result = ColumnUtils.formatNumber(value, 2, false, true)
    if (!result) {
      result = '0.00'
    }
    return result
  }

  /**
   * 四舍五入(CARGO-4977：如果formatNumber，16.49 转成了16.48)
   */
  static roundHalfUp(data, precision = 2, defaultVal = '') {
    let num = NaN
    if (isNumber(data)) {
      num = Number(data)
    } else if (isString(data)) {
      num = parseFloat(String(data).replace(/,/g, ''))
    }

    if (num !== 0 && !isNaN(num)) {
      return NumberUtils.roundHalfUp(num, precision).toFixed(precision)
    }
    return defaultVal
  }

  /**
   * 操作模式 .. 只有空出空进业务有操作类型
   */
  static operateTypeLabelFunc(data, column) {
    let text = ''
    if (data && Object.prototype.hasOwnProperty.call(data, column)) {
      let state
      if (Object.prototype.hasOwnProperty.call(data, 'lob')) {
        // 只有空出空进业务有操作类型
        if (data['lob'] === 'AI') {
          state = CommonState.getStateByCode(ImportConstants._cargoTypeAirInputList, data[column] ? Number(data[column]) : data[column])
        } else if (data['lob'] === 'AE') {
          state = CommonState.getStateByCode(AirExportConstants.BUSINESS_MODELS, data[column] ? Number(data[column]) : data[column])
        }
      }
      text = !state ? '' : ($store.getters.language === 'zh' ? state.chineseName : state.englishName)
    }
    return text
  }

  /**
   * 审核状态
   */
  static manageAuditStatusLabelFunction(type) {
    let text = ''

    type = String(type)
    switch (type) {
      case '0':
        text = i18n.t('CargoMsg.Cargo_NotReviewed')
        break
      case '1':
        text = i18n.t('CargoMsg.Cargo_PendingPrice')
        break
      case '2':
        text = i18n.t('Pricing.Agreed')
        break
      case '3':
        text = i18n.t('CargoMsg.Cargo_Denied')
        break
    }
    return text
  }

  /**
   * 海运整拼类型
   */
  static containerLoadTypeLabelFunction(data, column) {
    const fieldName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    // console.log('containerLoadTypeLabelFunction data[column]', data[column])
    if (Object.prototype.hasOwnProperty.call(data, column)) {
      if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'SI')) {
        const state = CommonState.getStateByCode(ImportConstants._cargoTypeInputList, data[column])
        return !state ? '' : state[fieldName]
      } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'IE') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'IE') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'IE')) {
        const state = CommonState.getStateByCode(ContainerLoadType.IE_TYPES, data[column])
        return !state ? '' : state[fieldName]
      } else {
        const loadType = ContainerLoadType.getContainerLoadTypeByCode(data[column])
        return !loadType ? '' : loadType[fieldName]
      }
    }
    return ''
  }

  /**
   * 货物性质
   */
  static containerLoadTypeLabelFunction2(data, column) {
    if (data.hasOwnProperty(column)) {
      if ((data.hasOwnProperty('lob') && data['lob'] === 'SI') || (data.hasOwnProperty('LOB') && data['LOB'] === 'SI')) {
        var containerLoadType = data[column]
        if (containerLoadType === 'FCL') {
          return lang.t('CargoMsg.Cargo_FCL')
        } else if (containerLoadType === 'LCL') {
          return i18n.t('Pricing.LCL')
        } else if (containerLoadType === 'CON') {
          return i18n.t('Message.SetSpell')
        } else if (containerLoadType === 'POJ') {
          return lang.t('CargoMsg.Cargo_Item')
        } else if (containerLoadType === 'ECL') {
          return lang.t('CargoMsg.Cargo_CoLoadConsol')
        } else {
          return i18n.t('Message.PersonalBelongings')
        }
      } else {
        var loadType = ContainerLoadType.getContainerLoadTypeByCode(data[column ])
        return loadType == null ? '' : loadType.chineseName
      }
    }
    return ''
  }
  /**
   * 操作模式
   */
  static operateTypeLabelFunc2(data, column) {
    var text = ''
    if ((data.hasOwnProperty('lob') && data['lob'] === 'AI') || (data.hasOwnProperty('LOB') && data['LOB'] === 'AI') || (data.hasOwnProperty('jobLob') && data['jobLob'] === 'AI')) {
      var type = data[column]
      if (type == 0) {
        return i18n.t('Message.OneMasterAndManyPoints')
      } else if (type == 1) {
        return lang.t('CargoMsg.Cargo_DirectBusiness')
      } else {
        return i18n.t('Message.OneMasterAndOneMinute')
      }
    } else if (data && data.hasOwnProperty(column) && data[column] !== '') {
      var state = CommonState.getStateByCode(AirExportConstants.BUSINESS_MODELS, parseInt(data[column]))
      text = !state ? '' : state.chineseName
    }
    return text
  }
  /**
   * 收支类型/支付类型
   * @param value
   */
  static chargeReceivableLabelFun(value) {
    return value ? lang.t('CargoMsg.Cargo_Receivable') : lang.t('CargoMsg.Cargo_Dues')
  }

  /**
   * 账单确认状态
   * @param value
   */
  static billingStateLabelFun(value) {
    const state = BillingConstants.getCommonState(value, BillingConstants.BILLING_STATES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 国外账单 确认状态 显示列
   * @param value
   */
  static OverseaBillingStateLabelFun(value) {
    const state = !value || value === 0 ? BillingConstants.getCommonState(0, BillingConstants.BILLING_STATES) : BillingConstants.getCommonState(1, BillingConstants.BILLING_STATES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 发票状态
   * @param value
   */
  static invoiceStateLabelFun(value) {
    const state = BillingConstants.getCommonState(value, BillingConstants.BILLING_INVOICE_STATES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 发票状态
   * @param value
   */
  static getInvoiceState(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.INVOICE_STATUS)
    return !state ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 核销状态
   * @param value
   */
  static clearingStateLabFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.CLEARING_STATES_ALL)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  对账-核销状态
   * @param value
   */
  static clearingBillStateLabFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.CLEARING_STATES_ALL_BILL)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 核销状态
   * @param value
   */
  static realClearingStateLabFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.RECEIVABLE_FINANCE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 应收核销状态
   * @param value
   */
  static writeOffStateLabFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.RECEIVABLE_WRITEOFF)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 核销匹配状态
   * @param value
   */
  static writeoffMatchStatusLabFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.WRITEOFF_MATCH_STATUSES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 费用状态
   * @param value
   */
  static chargeStateLabFun(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.CHARGE_STATES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 放单申请状态-未申请、未申请
   */
  static requestReleaseLabFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.REQUEST_RELEASE_STATE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 费用确认状态
   * @param value
   */
  static chargeConfirmStateLabFun(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.CONFIRM_STATES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static getCompanyName(companyId) {
    const companys = this.getBasicDataCacheList(cacheKeys.basic_data_Company, item => item.cmpIdx === companyId)
    const company = companys ? companys[0] : null
    if (company) {
      if ($store.getters.language === 'zh') {
        if (company.chineseName && company.chineseName.trim() === '') {
          return company.englishName || ''
        }
        return company.chineseName || ''
      } else {
        return company.englishName || ''
      }
    }
    return ''
  }

  /**
   * 开票方式
   * @param value
   */
  static invoiceModeLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BILLINGS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 复核状态
   */
  static actAmountApproveLabelFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.ACT_AMOUNT_APPROVE_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static actAmountApproveLabelFun2(value) {
    let yes = 'Approved'
    let no = 'Non Approve'
    if ($store.getters.language === 'zh') {
      yes = '已复核'
      no = '未复核'
    }
    return value ? yes : no
  }

  /**
   * 作废状态
   */
  static actAmountStateLabelFun(value) {
    if (value === -1) {
      return '√'
    }
    return ''
  }

  /**
   * 发票池-百望发票种类编码
   */
  static invoicePoolTypeCodeLabelFunc(value) {
    if (value === null || value === undefined || value === '') {
      return ''
    }
    return ColumnUtils.showTypeLabelFunc(value, SystemConstants.INVOICE_POOL_INVOICE_TYPE_CODES)
  }

  /**
   * 发票种类
   */
  static electronicInvoiceColumnFunc(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.INVOICE_CATEGORY)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 红冲状态
   */
  static invoiceOffsetLabelFun(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.OFFSET_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 打印状态
   */
  static printedStatelabelFunc(value) {
    let yes = 'YES'
    let no = 'NO'
    if ($store.getters.language === 'zh') {
      yes = '已打印'
      no = '未打印'
    }
    return value ? yes : no
  }

  /**
   * 作废状态
   */
  static revokedState(value) {
    let yes = 'YES'
    let no = 'NO'
    if ($store.getters.language === 'zh') {
      yes = '已作废'
      no = '未作废'
    }
    return value ? yes : no
  }

  /**
   * 导出状态
   */
  static exportStateLabelFunc(value) {
    let yes = 'YES'
    let no = 'NO'
    if ($store.getters.language === 'zh') {
      yes = '已导出'
      no = '未导出'
    }
    return value ? yes : no
  }

  /**
   * 发票类型
   */
  static invoiceTypeFunc(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.INVOICE_TYPES_FEI)
    return state === null ? i18n.t('Message.UnknownType') : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 开票方式
   */
  static invoiceMergeTypeFunc(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.MERGE_TYPES)
    return state === null ? '类型未知' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 国内/国外
   */
  static overseaLabelFunc(value) {
    let yes = 'Overseas'
    let no = 'Domestic'
    if ($store.getters.language === 'zh') {
      yes = '国外'
      no = '国内'
    }
    return value ? yes : no
  }

  /**
   * 开票方式(单票/月结开票)
   */
  static invoiceModeLableFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BILLINGS)
    return state === null ? i18n.t('CargoMsg.Cargo_NotSet') : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  发票状态
   */
  static invoicePrintedLableFun(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.PRINTED_TYPES)
    return state === null ? '未设置' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  红冲/被红冲
   */
  static redPunchLableFun(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.OFFSET_STATES)
    return state === null ? '未设置' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 时间格式化
   */
  static formateDateToString(datetime, fmt) {
    if (!datetime) return ''
    const date = new Date(typeof datetime === 'string' ? datetime.replace(/-/g, '/') : datetime)
    // 无效日期
    if (isNaN(date.getTime())) {
      return ''
    }
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }

  /**
   * yyyy-MM-dd
   */
  static dateLabelFunc(value) {
    return this.formateDateToString(value, 'yyyy-MM-dd')
  }

  /**
   * yyyy-MM-dd
   */
  static dateRangeLabelFunc(beginDate, endDate) {
    return this.dateLabelFunc(beginDate) +
        i18n.t('CargoMsg.Cargo_To') + this.dateLabelFunc(endDate)
  }

  /**
   * yyyy-MM-dd hh:mm:ss
   */
  static dateTimeLabelFunc(value) {
    return this.formateDateToString(value, 'yyyy-MM-dd hh:mm:ss')
  }

  /**
   * yyyy-MM-dd hh:mm
   */
  static dateMinutesLabelFunc(value) {
    return this.formateDateToString(value, 'yyyy-MM-dd hh:mm')
  }

  /**
   * yyyyMMddhhmmss
   */
  static dateTimeFunc(value) {
    return this.formateDateToString(value, 'yyyyMMddhhmmss')
  }

  /**
   * yyyyMM
   */
  static dateMonthFunc(value) {
    return this.formateDateToString(value, 'yyyyMM')
  }

  /**
   * 结算单位类型
   */
  static partnerTypeLabelFunction(value, lob = '', fba = false) {
    let text = ''
    switch (value) {
      case 'customerId':
        text = i18n.t('Payment.customer')
        break
      case 'customer':
        text = i18n.t('Payment.customer')
        break
      case 'carrierId':
        text = i18n.t('Payment.carrier')
        break
      case 'carrier':
        text = i18n.t('Payment.carrier')
        break
      case 'bookingAgent':
        if (lob === 'SE' && fba === false) {
          text = i18n.t('queryJob.bookingAgent')
        } else {
          text = `${i18n.t('queryJob.bookingAgent')}/${i18n.t('SeaExport.BillExchangeAgent')}`
        }
        break
      case 'destinationAgent':
        text = `${i18n.t('SeaExport.DestinationAgent1')}/${i18n.t('queryJob.destinationAgent')}`
        break
      case 'customsBroker':
        text = i18n.t('SeaExport.CustomsBroker')
        break
      case 'carrierAgent':
        text = i18n.t('SeaExport.CarrierAgent')
        break
      case 'overseaAgent':
        text = i18n.t('SeaExport.DestinationAgent')
        break
      case 'warehouse':
        text = i18n.t('SeaExport.Warehouse')
        break
      case 'trucking':
        text = i18n.t('SeaExport.Haulage')
        break
      case 'forwardingAgent':
        text = i18n.t('RailwayExport.forwardingAgent')
        break
      case 'terminalCompany':
        text = i18n.t('Message.TerminalCompany')
        break
      case 'nominatedAgent':
        text = i18n.t('SeaExport.NominatedAgent')
        break
      case 'exchangeAgent':
        if (lob === 'SE' && fba === false) {
          text = i18n.t('SeaExport.BillExchangeAgent')
        }
        break
      case 'shipperId':
        text = i18n.t('Message.Shipper')
        break
      case 'consigneeId':
        text = i18n.t('Message.Consignee')
        break
      case 'notifyId':
        text = i18n.t('Message.Notify')
        break
    }
    return text
  }

  /**
   * 单位
   */
  static measureLabelFunction(value) {
    const measure = ChargeMeasure.getChargeMeasureByCode(value)
    return measure === null ? '未设置' : $store.getters.language === 'zh' ? measure.chineseName : measure.englishName
  }

  /**
   * 单位
   */
  static measureLabelFunction1(value) {
    const measure = ChargeMeasure.getChargeMeasureByCode(value)
    return measure === null ? '' : $store.getters.language === 'zh' ? measure.chineseName : measure.englishName
  }

  /**
   * 箱种
   */
  static eqSizeLabelFun(value) {
    const eqSize = EQSize.getEQSizeByCode(value)
    return eqSize === null ? '' : eqSize.name
  }

  /**
   * 据业务类型，文件类型获取文件名称
   * @param lob
   * @param code
   */
  static getFileTypeNameByCodeLob(lob, code) {
    let val = ''
    const lookupResult = getFilterCacheList(cacheKeys.basic_data_TransmitFileType, (item) => {
      return item.code === code && item.lob === lob
    })
    if (lookupResult.length > 0) {
      val = $store.getters.language === 'zh' ? lookupResult[0].name : (lookupResult[0].englishName || lookupResult[0].name)
    }
    return val
  }

  /**
   * 单证状态
   * @param value
   * @returns {string}
   */
  static fileStateLabelFunc(value) {
    const state = FileState.getFileStateByCode(value)
    if (state === null) return i18n.t('Message.UnKnownStatus')
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 获取Job状态
   */
  static getJobState(job) {
    if (!job) return ''
    const value = job.jobState
    if (JobUtils.isBlockJob(job)) {
      return i18n.t('Message.Locked')
    } else {
      const fieldName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
      if (value === 0) {
        return SystemConstants.STATE_OPERATING[fieldName]
      } else if (value === 1) {
        return SystemConstants.STATE_COMMITED[fieldName]
      } else if (value === 2) {
        return SystemConstants.STATE_VERIFIED[fieldName]
      } else if (value === 3) {
        return SystemConstants.STATE_SHUT_OUT[fieldName]
      } else if (value === -1) {
        return SystemConstants.STATE_VERIFYING[fieldName]
      } else if (value === 11) {
        return SystemConstants.STATE_PRE_COMMIT[fieldName]
      } else if (value === 12) {
        return SystemConstants.STATE_REJECT[fieldName]
      } else if (value === 13) {
        return SystemConstants.STATE_COMMITTING[fieldName]
      }
    }
    return i18n.t('Message.UnKnownStatus')
  }

  /**
   * 获取Job改单状态
   */
  static getJobChangeState(job) {
    if (!job) return ''
    var value = job.changeState
    var labelName = ''
    if (value === Number(SystemConstants.CHANGE_DEFAULT.code)) {
      // 无
      labelName = SystemConstants.CHANGE_DEFAULT.chineseName
    } else if (value === Number(SystemConstants.CHANGE_CANNOTCHANGE.code)) {
      // 不可改单
      labelName = SystemConstants.CHANGE_CANNOTCHANGE.chineseName
    } else if (value === Number(SystemConstants.CHANGE_CANCHANGE.code)) {
      // 可改单
      labelName = SystemConstants.CHANGE_CANCHANGE.chineseName
    } else if (value === Number(SystemConstants.CHANGE_COMMIT.code)) {
      // 改单提交
      labelName = SystemConstants.CHANGE_COMMIT.chineseName
    } else if (value === Number(SystemConstants.CHANGE_AUDIT.code)) {
      // 改单审核
      labelName = SystemConstants.CHANGE_AUDIT.chineseName
    }
    return labelName === '' ? '' : '(' + labelName + ')'
  }

  /**
   * 获取Job改单状态
   */
  static getJobChangeState2(job) {
    if (!job) return ''
    var value = job.changeState
    var labelName = ''
    if (value === Number(SystemConstants.CHANGE_DEFAULT.code)) {
      // 无
      labelName = SystemConstants.CHANGE_DEFAULT.chineseName
    } else if (value === Number(SystemConstants.CHANGE_CANNOTCHANGE.code)) {
      // 不可改单
      labelName = SystemConstants.CHANGE_CANNOTCHANGE.chineseName
    } else if (value === Number(SystemConstants.CHANGE_CANCHANGE.code)) {
      // 可改单
      labelName = SystemConstants.CHANGE_CANCHANGE.chineseName
    } else if (value === Number(SystemConstants.CHANGE_COMMIT.code)) {
      // 改单提交
      labelName = SystemConstants.CHANGE_COMMIT.chineseName
    } else if (value === Number(SystemConstants.CHANGE_AUDIT.code)) {
      // 改单审核
      labelName = SystemConstants.CHANGE_AUDIT.chineseName
    }
    return labelName === '' ? '' : labelName
  }
  /**
   * 包装类型
   */
  static packingCodeLabelFun(code) {
    let val = ''
    const lookupResult = getFilterCacheList(cacheKeys.basic_data_Packing, (item) => {
      return item.code === code
    })
    if (lookupResult.length > 0) {
      val = lookupResult[0].chineseName + '[' + lookupResult[0].name + ']'
    }
    return val
  }

  static truckingOrderLableFun(code) {
    const state = CommonState.getStateByCode(SeaExportConstants.TRUCKING_ORDER_STATUS, code)
    if (!state) {
      return i18n.t('Message.UnKnownStatus')
    }
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static costStatusLableFun(data, fieldName) {
    // 默认设置未确认
    let state = CommonState.getStateByCode(SeaExportConstants.COST_STATUS, SeaExportConstants.COST_STATUS_NO_CONFIRM.code)
    if (data[fieldName] === '1') {
      state = CommonState.getStateByCode(SeaExportConstants.COST_STATUS, SeaExportConstants.COST_STATUS_CONFIRM.code)
    } else if (data[fieldName] === '2') {
      state = CommonState.getStateByCode(SeaExportConstants.COST_STATUS, SeaExportConstants.COST_STATUS_RETURNED.code)
    } else if (data.auditUrl) {
      state = CommonState.getStateByCode(SeaExportConstants.COST_STATUS, SeaExportConstants.COST_STATUS_WAIT_CONFIRM.code)
    }
    if (!state) {
      return i18n.t('Message.UnKnownStatus')
    }
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static containerUsageFiledLabelFunction(data, fieldName) {
    if (fieldName === 'eqSize') {
      const eqSize = EQSize.getEQSizeByCode(data.container[fieldName])
      return eqSize === null ? '' : eqSize.name
    } else {
      return data.container[fieldName]
    }
  }

  /**
   * 付款申请
   */
  static billPaymentStateLabelFunc(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.BILL_PAYMENT_STATES)
    return state === null ? '未设置' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 付款申请
   */
  static billPaymentStateLabelFuncNullStr(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.BILL_PAYMENT_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 付款申请【业务】【财务】【财务部】审批状态
   * @param value
   */
  static billPaymentApproveStateLabelFunc(value) {
    const state = ChargeConstants.getCommonState(value, ClearingConstants.BILL_PAYMENT_APPROVE_STATE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static portAutoKeyLabelFunc(value, lob) {
    let portName = ''
    if (lob === SE.code || lob === SI.code) {
      portName = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7')
    } else if (lob === AE.code || lob === AI.code) {
      portName = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'auto_8')
    } else if (lob === RE.code || lob === RI.code) {
      portName = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', value, 'auto_railway')
    }
    return (!StrUtils.isEmpty(portName)) ? portName : value
  }

  /**
   * 付款申请审批结果
   * @param data
   */
  static billPaymentApprovalResultsLabelFunc(data) {
    if (data.approveStateDesc) {
      return data.approveStateDesc
    }
    const state = ChargeConstants.getCommonState(data.approveState, ClearingConstants.BILL_PAYMENT_APPROVAL_RESULTS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 付款申请审批节点
   * @param value
   */
  static billPaymentApprovalNodeLabelFunc(value) {
    const state = ChargeConstants.getCommonState(value, ClearingConstants.BILL_PAYMENT_APPROVE_NODE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 收支方式
   */
  static amountReceiveTypeLabelFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.AMOUNT_RECEIVE_TYPES)
    return state === null ? '未设置' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 结算单位合同状态
   */
  static settlementUnitContractStatusLabelFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.SETTLEMENT_CONTRACT_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 标记状态
   */
  static markingStateLabelFun(value) {
    return value ? i18n.t('Message.Marked') : i18n.t('Message.Unmark')
  }

  static departmentByJobNoLabelFunc(val) {
    return this.getDepartmentNameByJobNo(val)
  }

  static getDepartmentNameByJobNo(jobNoPrefix) {
    let department = null
    const departments = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
      return item.officeUuid === $store.getters.currentOfficeUuid
    })
    if (jobNoPrefix) {
      for (const dep of departments) {
        if (dep.jobNoPrefix === jobNoPrefix) {
          department = dep
          break
        }
      }
    }
    let name = ''
    if (department) { name = $store.getters.language === 'zh' ? department.chineseName : department.englishName }
    return name
  }

  static departmentLabelNewFunc(value) {
    const departments = getFilterCacheList(cacheKeys.basic_data_Department_All, (item) => {
      return item.departmentId === value
    })
    let name = ''
    if (departments && departments.length > 0) { name = $store.getters.language === 'zh' ? departments[0].chineseName : departments[0].englishName }
    return name
  }
  /**
   * 如果为0，返回格式化几位的0s
   *  @param isRound 是否进行四舍五入，此方法就是不进行四舍五入，故默认否
   */
  static formatNumberReturnZero(data, precision, isRound = true) {
    let returnZero = '0.'
    for (let i = 0; i < precision; i++) {
      returnZero += '0'
    }
    let num
    if (typeof data === 'number') {
      num = data
    } else if (typeof data === 'string') {
      num = parseFloat(String(data).replace(/,/g, ''))
    }
    if (num !== 0 && !isNaN(num)) {
      return NumberUtils.formatNumber(num, precision, isRound)
    }
    return returnZero
  }
  /**
   * 关联属性的提取
   */
  static propertyLabelFunc(data, field) {
    if (!data.hasOwnProperty(field)) { return '' }
    return this.getData(data, field)
  }
  /**
   * 处理.
   */
  static getData(data, value) {
    let result
    if (value.indexOf('.') !== -1) {
      const complexNames = value.split('.')
      let currentRef = data
      if (complexNames && currentRef) {
        for (let i = 0; i < complexNames.length; i++) {
          if (currentRef) {
            currentRef = currentRef[complexNames[i]]
          }
        }
      }
      result = currentRef
    } else {
      if (data != null && data.hasOwnProperty(value)) {
        result = data[value]
      }
    }
    return result
  }
  /**
   * 文件大小
   */
  static fileSizeLabelFun(value) {
    if (!value && isNaN(value)) return ''
    const size = value
    if (size > 1024 * 1024) { return NumberUtils.formatNumber(size / (1024 * 1024), 1) + 'MB' } else if (size > 1024) { return NumberUtils.formatNumber(size / 1024, 1) + 'KB' } else if (!isNaN(size)) { return size + 'B' }
    return ''
  }

  /**
   * ediStatus labelFunction
   */
  static ediStateFunction(value) {
    if (!value && isNaN(value)) value = 0
    const obj = ManifestGoodsInfoConstants.getStateByCode(value)
    if (!obj) return ''
    return $store.getters.language === 'zh' ? obj.chineseName : obj.englishName
  }

  /**
   * 账单类型
   */
  static billingTypeLabFun(value) {
    const state = SystemConstants.getCommonState(value, BillingConstants.BILLING_TYPE)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 账单类型
   */
  static creditHistoryActionFun(value) {
    const state = SystemConstants.getCommonState(value, CreditHistoryActionConstants.LOG_ACTION)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 根据业务类型获取页面跳转路由
   * @param params 行数据
   * @param lobField业务类型字段名称
   * @param jobNoField业务编号字段名称
   * @returns {{component: string}}
   */
  static routeNameByJobLobFun(params, lobField, jobNoField, isPre = false) {
    const render = {
      component: 'RouterAndPrintRenderer'
    }
    const { env, token, currentDeptId, tenantId } = $store.getters
    let url = ''
    if (env === 'dev') {
      url = 'http://stage.cargoware.com/ssoForward'
    } else
    if (env === 'prod') {
      url = 'http://cargoware.hi-strong.com/ssoForward'
    } else {
      url = `http://${env}.cargoware.com/ssoForward`
    }
    const curRow = params.data
    // 远程订舱
    if (isPre && curRow.jobState === SystemConstants.PENDING && curRow.preverifyState === SystemConstants.VERIFYING_LOCK.code) {
      if (['SE', 'AE', 'RE', 'RI'].includes(curRow[lobField])) {
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'RemoteBooking',
          routeTitle: i18n.t('route.remoteBooking'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_RemoteBooking']
        }
        return render
      }
    }
    switch (params.data[lobField]) {
      case 'SE':
        // 订舱预审
        if (isPre && curRow.jobState === SystemConstants.PENDING && curRow.preverifyState === SystemConstants.VERIFYING_PENDING.code) {
          render.params = {
            data: params.data,
            field: jobNoField,
            useRoute: true,
            usePrint: false,
            routeName: 'BookingVerify',
            routeTitle: i18n.t('route.preBooking'),
            routeParamKeys: { jobNo: jobNoField },
            routePermissions: ['module_fmVerify']
          }
          break
        }
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'SeaBooking',
          routeTitle: i18n.t('route.bookingNew'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_fmBookingNew']
        }
        break
      case 'SI':
        // 预报
        if (isPre && curRow.jobState === SystemConstants.PENDING && (curRow.preverifyState === SystemConstants.VERIFYING_LOCK.code || curRow.preverifyState === SystemConstants.VERIFYING_PENDING.code)) {
          render.params = {
            data: params.data,
            field: jobNoField,
            useRoute: true,
            usePrint: false,
            routeName: 'SiPrediction',
            routeTitle: i18n.t('route.prediction'),
            routeParamKeys: { jobNo: jobNoField },
            routePermissions: ['module_SIPREALERT']
          }
          break
        }
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'SiBooking',
          routeTitle: i18n.t('route.seaImportBooking'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_SIBOOKING']
        }
        break
      case 'AE':
        // 订单预审
        if (isPre && curRow.jobState === SystemConstants.PENDING && curRow.preverifyState === SystemConstants.VERIFYING_PENDING.code) {
          render.params = {
            data: params.data,
            field: jobNoField,
            useRoute: true,
            usePrint: false,
            routeName: 'AeBookingVerify',
            routeTitle: i18n.t('route.preOrder'),
            routeParamKeys: { jobNo: jobNoField },
            routePermissions: ['module_AEPreVerify']
          }
          break
        }
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'AeBooking',
          routeTitle: i18n.t('route.airExportBooking'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_AEBooking']
        }
        break
      case 'AI':
        // 预报
        if (isPre && curRow.jobState === SystemConstants.PENDING && (curRow.preverifyState === SystemConstants.VERIFYING_LOCK.code || curRow.preverifyState === SystemConstants.VERIFYING_PENDING.code)) {
          render.params = {
            data: params.data,
            field: jobNoField,
            useRoute: true,
            usePrint: false,
            routeName: 'AiOrder',
            routeTitle: i18n.t('route.prediction'),
            routeParamKeys: { jobNo: jobNoField },
            routePermissions: ['module_Order']
          }
          break
        }
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'AiBooking',
          routeTitle: i18n.t('route.airImportBooking'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_AIBooking']
        }
        break
      case 'RE':
      case 'RI':
        // 订舱预审
        if (isPre && curRow.jobState === SystemConstants.PENDING && curRow.preverifyState === SystemConstants.VERIFYING_PENDING.code) {
          render.params = {
            data: params.data,
            field: jobNoField,
            useRoute: true,
            usePrint: false,
            routeName: 'ReBookingVerify',
            routeTitle: i18n.t('route.preBooking'),
            routeParamKeys: { jobNo: jobNoField },
            routePermissions: ['module_RailwayBookingVerify']
          }
          break
        }
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'ReBooking',
          routeTitle: i18n.t('route.railwayExport'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_RailwayExport']
        }
        break
      case 'IE':
        render.params = {
          data: params.data,
          field: jobNoField,
          useRoute: true,
          usePrint: false,
          routeName: 'IEBooking',
          routeTitle: i18n.t('route.integratedJob'),
          routeParamKeys: { jobNo: jobNoField },
          routePermissions: ['module_IEBooking']
        }
        break
    }
    return render
  }

  /**
   * 根据业务类型获取页面跳转路由
   * @param params 行数据
   * @param lobField业务类型字段名称
   * @param jobNoField业务编号字段名称
   * @returns {{component: string}}
   */
  static routeNameByJobLobAndInstructionFun(params, lobField, jobNoField, isPre = false, tenantInstructions, instructionClick) {
    const render = this.routeNameByJobLobFun(params, lobField, jobNoField, isPre)
    if (tenantInstructions && tenantInstructions.length > 0 &&
        params.data.instructionUuids && params.data.instructionUuids.length > 0) {
      const jumpInstructions = tenantInstructions.filter(tenantInstruction =>
        params.data.instructionUuids.indexOf(tenantInstruction.uuid) > -1 &&
        tenantInstruction.platformInstructionCode === PLATFORM_INSTRUCTION_CODE_JUMP_PAGE.code &&
        tenantInstruction.instructionRuleJson.clickJobNoJumpPage)
      if (jumpInstructions && jumpInstructions.length === 1) {
        render.params.jumpInstruction = jumpInstructions[0]
        render.params.instructionClick = instructionClick
      }
    }
    return render
  }
  /**
   * 路由跳转老系统
   * @param params 行数据
   * @param displayField 显示名称
   * @param module 跳转的模块（老系统）
   * @returns {{component: string}}
   */
  static routerToOldCargo(params, displayField, module) {
    const render = {
      component: 'RouterAndPrintRenderer'
    }
    const { env, token, currentDeptId, tenantId } = $store.getters
    let url = ''
    if (env === 'dev') {
      url = 'http://stage.cargoware.com/ssoForward'
    } else
    if (env === 'prod') {
      url = 'http://cargoware.hi-strong.com/ssoForward'
    } else {
      url = `http://${env}.cargoware.com/ssoForward`
    }
    console.log('url', url)
    render.params = {
      data: params.data,
      field: displayField,
      useRoute: true,
      usePrint: false,
      directMode: true,
      directUrl: url,
      // 链接跳转参数
      directParams: {
        sessionId: token, branchId: tenantId, departmentId: currentDeptId, language: 'zh', module: module, reportId: null
      }
    }
    return render
  }

  /**
   * 是否
   */
  static yesOrNoFun(value) {
    return value ? '✔' : ''
  }

  //   //Add by Deep Lau 2016-04-14
  static cleaningModeLable(s) {
    let result = ''
    if (s === 1) { result = lang.t('CargoMsg.Cargo_Monthly') } else {
      result = lang.t('CargoMsg.Cargo_SettlementByBill')
    }
    return result
  }
  static soNoDataTipFunction(item) {
    if (item && (item['SO_NO'] == null || item['SO_NO'] === 'null')) {
      return ''
    }
    return item['SO_NO']
  }

  /**
   * 箱量描述
   */
  static containerDescLabelFuncForChargeSearch(value) {
    if (value) {
      return value.split('\n').join(',')
    } else {
      return null
    }
  }

  static cargoSourceLabelFunctionForChargeSearch(item, column) {
    const cargoSourceCode = ColumnUtils.propertyLabelFunc(item, column)
    const cargoSource = CargoSource.getCargoSourceByCode(cargoSourceCode)
    return cargoSource == null ? '' : cargoSource.chineseName
  }

  static vesselVoyageLabelFunc(item) {
    var label = ''
    if ((item['VESSEL']) && (item['VESSEL']).trim().length > 0) { label += item['VESSEL'] }
    if (label.length > 0) { label += ' ' }
    if ((item['VOYAGE_FLIGHT']) && (item['VOYAGE_FLIGHT']).trim().length > 0) { label += item['VOYAGE_FLIGHT'] }
    return label
  }
  // 港口
  static portLabelFunc(data, value) {
    if (!value) return ''
    if (data && value && ((Object.prototype.hasOwnProperty.call(data, 'lob') && ([SystemConstants.SI.code, SystemConstants.SE.code, SystemConstants.IE.code].includes(data.lob))) || (Object.prototype.hasOwnProperty.call(data, 'LOB') && ([SystemConstants.SI.code, SystemConstants.SE.code, SystemConstants.IE.code].includes(data.LOB))))) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'englishName')
    } else if (data && value && ((Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === SystemConstants.AI.code || data.lob === SystemConstants.AE.code)) || (Object.prototype.hasOwnProperty.call(data, 'LOB') && (data.LOB === SystemConstants.AI.code || data.LOB === SystemConstants.AE.code)))) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'englishName')
    }
    return ''
  }
  // CARGO-49762 财务综合查询模块港口显示列需兼容个性化配置
  static portLabelFuncByFinance(data, value) {
    if (!value) return ''
    if (data && value && ((Object.prototype.hasOwnProperty.call(data, 'lob') && ([SystemConstants.SI.code, SystemConstants.SE.code, SystemConstants.IE.code].includes(data.lob))) || (Object.prototype.hasOwnProperty.call(data, 'LOB') && ([SystemConstants.SI.code, SystemConstants.SE.code, SystemConstants.IE.code].includes(data.LOB))))) {
      return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7')
    } else if (data && value && ((Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === SystemConstants.AI.code || data.lob === SystemConstants.AE.code)) || (Object.prototype.hasOwnProperty.call(data, 'LOB') && (data.LOB === SystemConstants.AI.code || data.LOB === SystemConstants.AE.code)))) {
      return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'auto_8')
    }
    return ''
  }

  // 卸货港(海运/综合)
  static portLabelFuncBySeaAndComprehensive(data, value) {
    if (!value) return ''
    if (data && value && ((Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === SystemConstants.SI.code || data.lob === SystemConstants.SE.code || data.lob === SystemConstants.IE.code)) || (Object.prototype.hasOwnProperty.call(data, 'LOB') && (data.LOB === SystemConstants.SI.code || data.LOB === SystemConstants.SE.code || data.LOB === SystemConstants.IE.code)))) {
      // return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'englishName')
      return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7')
    } else {
      return ''
    }
  }
  //  MAWB NO
  static mawbNoLabelFun(value, control = false) {
    if (!value) return ''
    if (control) {
      if (value.length === 11) {
        return value.substr(0, 3) + '-' + value.substr(3)
      } else {
        return value
      }
    }
    if (value.length === 11) {
      return value.substr(0, 3) + '-' + value.substr(3, 4) + ' ' + value.substr(7)
    } else {
      return value
    }
  }
  //  客户级别
  static companyCustomerTypeLabelFunc(customerTypeId) {
    if (!isNumber2(customerTypeId)) {
      return ''
    }
    const customerTypes = this.getBasicDataCacheList(cacheKeys.basic_data_CustomerType, item => item.typeId === Number(customerTypeId))
    const customerType = customerTypes ? customerTypes[0] : null
    if (customerType) {
      if ($store.getters.language === 'zh') {
        return customerType.chineseName || ''
      } else {
        return customerType.englishName || ''
      }
    }
    return ''
  }
  // 报关方式
  static customClaimLabelFunc(value) {
    const state = AirExportConstants.CUSTOM_CLAIMS[Number(value)]
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 报关类型
  static customClaim2LabelFunc(value) {
    // const state = AirExportConstants.CUSTOM_CLAIMS2[Number(value)]
    const state = getObjectByCache(basicCacheKeys.basic_data_CustomsDeclarationType, 'customsDeclarationTypeId', Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.name || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 付款方式
  static paymentMethodLabelFunc(code = '') {
    if (!code) return ''
    const paymentMethod = getObjectByCache(cacheKeys.basic_data_PaymentMethod, 'code', code)
    if (paymentMethod) {
      if ($store.getters.language === 'zh') {
        return paymentMethod.chineseName || ''
      } else {
        return paymentMethod.englishName || ''
      }
    }
    return ''
  }
  // 运输类型
  static transportTypeLabelFunc(code = '') {
    if (!code) return ''
    const transportType = getObjectByCache(cacheKeys.basic_data_TransportationType, 'code', code)
    if (transportType) {
      if ($store.getters.language === 'zh') {
        return transportType.chineseName || ''
      } else {
        return transportType.englishName || ''
      }
    }
    return ''
  }
  // 航空公司
  static companyShortNameLabelFun(cmpIdx = 0) {
    if (!cmpIdx) return ''
    const companys = this.getBasicDataCacheList(cacheKeys.basic_data_Company, item => item.cmpIdx === Number(cmpIdx))
    const company = companys ? companys[0] : null
    if (company) {
      return company.shortName || ''
    }
    return ''
  }
  // 航线产品
  static getAirLineProductLabelFunc(value, list) {
    if (list && list.length > 0) {
      const state = SystemConstants.getCommonStateByProp('uuid', value, list)
      if (state) {
        return state.name
      }
    }
    return ''
  }
  // 获取空运港口
  static getAirportName(code = '') {
    if (!code) return ''
    const ports = this.getBasicDataCacheList(cacheKeys.basic_data_Airport, item => item.code === code)
    const port = ports ? ports[0] : null
    if (port) {
      if ($store.getters.language === 'zh') {
        return port.chineseName || ''
      } else {
        return port.englishName || ''
      }
    }
    return ''
  }
  // 报关状态
  static customsStateLabFun(declareCustomsState = 0) {
    const state = CommonState.getStateByCode(SystemConstants.DECLARE_CUSTOMS_STATE, declareCustomsState)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 协议类型
  static protocolTypeLabFunc(protocolType = '') {
    const state = CommonState.getStateByCode(AirExportConstants.PROTOCOL_TYPES, protocolType)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return $store.getters.language === 'zh' ? '无' : 'Nothing'
  }
  // 自定义业务类型
  static customJobTypeLabelFunc(code = '') {
    if (!code) return ''
    const customJobTypes = this.getBasicDataCacheList(cacheKeys.basic_data_CutomJobType, item => item.code === code)
    const customJobType = customJobTypes ? customJobTypes[0] : null
    if (customJobType) {
      if ($store.getters.language === 'zh') {
        return customJobType.name || ''
      } else {
        return customJobType.englishName || ''
      }
    }
    return ''
  }
  // 自定义业务类型 中文名称取本地名称
  static customJobTypeLabelFunc2(code = '') {
    if (!code) return ''
    const customJobTypes = this.getBasicDataCacheList(cacheKeys.basic_data_CutomJobType, item => item.code === code)
    const customJobType = customJobTypes ? customJobTypes[0] : null
    if (customJobType) {
      if ($store.getters.language === 'zh') {
        return customJobType.localName || ''
      } else {
        return customJobType.englishName || ''
      }
    }
    return ''
  }
  // 主单号如果是11为就显示为：***-**** **** 这样的格式
  static mblLabelFunc(str, data) {
    if (data.lob === 'SE' || data.lob === 'SI' || data.lob === 'AI') return str
    const oldStr = str.trim().replace('-', '')
    if (!str) return ''
    return this.mawbNoLabelFun(str)
  }
  // 客户状态
  static customerStatusCodeToColumnLabelFun(str) {
    if (!str) str = 0
    const customerTypes = CrmCustomerConstants.CUSTOMER_STATUS
    const state = customerTypes.find(p => parseInt(p.code) === parseInt(str))
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 公司类型编码转表格公司类型
  static companyTypeCodeToColumnLabelFun(str) {
    if (!str) str = 0
    // 客户类型 CARGO-25396 客户类型、客户接触渠道改为基础数据维护
    let customerTypes = CrmCustomerConstants.CUSTOMER_TYPE
    customerTypes = customerTypes.concat(getSpecificBasicDataFromCache(cacheKeys.basic_data_CrmCustomerType))
    const state = customerTypes.find(p => parseInt(p.code) === parseInt(str))
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 公司来源编码转表格公司来源
  static sourceTypeCodeToColumnLabelFun(str) {
    if (!str) str = 0
    const sourceTypeGrids = CrmCustomerConstants.SOURCE_TYPE_GRID
    const state = sourceTypeGrids.find(p => parseInt(p.code) === parseInt(str))
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 偏好海港
  static likeSeaPortCode(value) {
    const values = []
    if (!StrUtils.isEmpty(value)) {
      const codes = value.split(',')
      for (const code in codes) {
        const englishName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', codes[code], 'englishName')
        if (englishName) values.push(englishName)
      }
    }
    return values.join(',')
  }
  // 英文名匹配海港
  static matchSeaPortCode(value) {
    if (!StrUtils.isEmpty(value)) {
      const englishNameList = value.split(',')
      for (const englishName in englishNameList) {
        const port = getFilterCacheList(cacheKeys.basic_data_Seaport, (item) => {
          return (englishName === item.englishName)
        })
        if (port && port?.length) {
          return port
        }
      }
    }
    return ''
  }
  // 偏好空港
  static likeAirPortCode(value) {
    const values = []
    if (!StrUtils.isEmpty(value)) {
      const codes = value.split(',')
      for (const code in codes) {
        const englishName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', codes[code], 'englishName')
        if (englishName) values.push(englishName)
      }
    }
    return values.join(',')
  }
  // 偏好航线
  static likeAirlineCode(value) {
    const isZh = $store.getters.language === 'zh'
    const values = []
    if (!StrUtils.isEmpty(value)) {
      const codes = value.split(',')
      for (const code in codes) {
        if (isZh) {
          const name = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', codes[code], 'name')
          if (name) values.push(name)
        } else {
          const englishName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', codes[code], 'nameEnglish')
          if (englishName) values.push(englishName)
        }
      }
    }
    return values.join(',')
  }

  // 未跟进天数超过365 展示超过一年
  static formatUnAskDays(days) {
    if (parseInt(days) > 365) {
      return lang.t('CargoMsg.Cargo_MoreThan1Year')
    } else {
      return days.toString()
    }
  }
  // 事件主题转换单元格函数
  static eventTitleCodeToColumnLabelFun(str) {
    if (!str) str = ''
    const customerTypes = CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS
    const state = customerTypes.find(p => p.code === str)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 事件类型转换单元格函数
  static eventStatusCodeToColumnLabelFun(str) {
    if (!str) str = ''
    const customerTypes = CrmCustomerConstants.CUSTOMER_EVENT_STATUSS
    const state = customerTypes.find(p => p.code === str)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 主单状态标签
  static MAWBStateLabelFunction(value) {
    let state = null
    for (const arr of AirExportConstants.MASTER_WAYBILL_STATES) {
      if (parseInt(arr.code) === parseInt(value)) {
        state = arr
        break
      }
    }
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 主单来源标签
  static MAWBSourceLabelFunction(value) {
    let state = null
    for (const arr of AirExportConstants.MASTER_WAYBILL_SOURCE) {
      if (parseInt(arr.code) === parseInt(value)) {
        state = arr
        break
      }
    }
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 主单可用标签
  static MAWBAvailabilityLabelFunction(value) {
    let state = null
    for (const arr of AirExportConstants.MASTER_WAYBILL_AVAILABLE) {
      if (parseInt(arr.code) === parseInt(value)) {
        state = arr
        break
      }
    }
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 获取港口
   */
  static getSeaport(code) {
    const seaport = getFilterCacheList(cacheKeys.basic_data_Seaport, (item) => {
      return (code === item.code)
    })
    return seaport[0]
  }
  static getCitySeaport() {
    const city = getFilterCacheList(cacheKeys.basic_data_Seaport, (item) => {
      return item.cityName !== '' && item.cityName
    })
    const citySeaports = []
    const cityMap = {}
    city.forEach(p => {
      const label = p.cityCode + p.cityName
      if (!cityMap[label]) {
        citySeaports.push({
          name: p.cityName + ',' + p.countryCode,
          code: p.cityCode
        })
      }
      cityMap[label] = {
        code: p.cityCode
      }
    })
    return citySeaports
  }

  static getCityAirport() {
    const city = getFilterCacheList(cacheKeys.basic_data_Airport, (item) => {
      return item.cityName !== '' && item.cityName
    })
    const cityAirports = []
    const cityMap = {}
    city.forEach(p => {
      const label = p.cityCode + p.cityName
      if (!cityMap[label]) {
        cityAirports.push({
          name: p.cityName + ',' + p.countryCode,
          code: p.cityCode
        })
      }
      cityMap[label] = {
        code: p.cityCode
      }
    })
    return cityAirports
  }

  static seaportCityLabelFunc(value) {
    const citySeaports = getFilterCacheList(cacheKeys.basic_data_Seaport, (item) => {
      return item.cityName !== '' && item.cityName && item.code === value
    })
    if (citySeaports.length > 0) {
      return citySeaports[0].cityName + ',' + citySeaports[0].countryCode
    }
    return ''
  }

  static airportCityLabelFunc(value) {
    const cityAirports = getFilterCacheList(cacheKeys.basic_data_Airport, (item) => {
      return item.cityName !== '' && item.cityName && item.code === value
    })
    if (cityAirports.length > 0) {
      return cityAirports[0].cityName + ',' + cityAirports[0].countryCode
    }
    return ''
  }

  /**
   * 生，失效日期类型
   */
  static priceFclDateTypeLabelFunction(type) {
    const priceFclDataType = PriceFclDataType.getPriceFclDataTypeByCode(type)
    return priceFclDataType === null ? '' : $store.getters.language === 'zh' ? priceFclDataType.chineseName : priceFclDataType.englishName
  }

  /**
   * 特价状态
   */
  static saleStateLabelFunction(type) {
    const saleState = SpecialPriceSaleState.getPriceSaleStateByCode(type)
    return saleState === null ? '' : $store.getters.language === 'zh' ? saleState.chineseName : saleState.englishName
  }

  static priceDateTypeColumnLabelFunc(value) {
    if (value !== null) {
      switch (value) {
        case 'M':
          return lang.t('Pricing.M')
        case 'F':
          return lang.t('Pricing.F')
      }
    }
    return value
  }

  /**
   * 凭证状态
   */
  static voucherStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FinanceInterfaceConstants.VOUCHER_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 推送状态
   */
  static pushStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FinanceInterfaceConstants.PUSH_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 归档状态
   */
  static archiveableLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ARCHIVEABLE_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 获取合作伙伴指定参数
   * @param value
   * @param targetField
   * @param sourceField
   * @returns {string|*|string}
   */
  static companyLabelFun(value = '', targetField, sourceField) {
    if (StrUtils.isEmpty(value)) return ''
    const companys = this.getBasicDataCacheList(cacheKeys.basic_data_Company, item => item[sourceField] === value)
    const company = companys ? companys[0] : null
    if (company) {
      return company[targetField] || ''
    }
    return ''
  }
  static boolLabelFunc(value) {
    return value ? 'Y' : 'N'
  }

  /**
   * 港口地区
   * @param value
   * @returns {Promise<*[]>}
   */
  static seaportCountryLabelFunc(value) {
    const countryCode = this.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'countryCode')
    return this.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', countryCode, 'name')
  }

  /**
   * 空运港口地区
   * @param value
   * @returns {Promise<*[]>}
   */
  static airportCountryLabelFunc(value) {
    const countryCode = this.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'countryCode')
    return this.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', countryCode, 'name')
  }

  static cargoTypeLabelFunc(str) {
    if (!str) str = ''
    const sourceTypeGrids = getSpecificBasicDataFromCache(cacheKeys.basic_data_CargoType)
    const state = sourceTypeGrids.find(p => String(p.code) === String(str))
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 港口区域
   * @param value
   * @returns {Promise<*[]>}
   */
  static podRegionLabFunc(value) {
    if (!value) {
      return ''
    }
    const countryCode = this.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'region')
    return this.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', countryCode, 'name')
  }
  /**
   * 获取多个合作伙伴指定参数
   * @param values
   * @param targetField
   * @param sourceField
   * @returns {string}
   */
  static moreCompanyLabelFun(values = '', targetField, sourceField) {
    if (!StrUtils.isEmpty(values)) {
      const rs = []
      const params = values.split(',')
      for (const value in params) {
        if (params[value] === '') {
          continue
        }
        rs.push(this.companyLabelFun(Number(params[value]), targetField, sourceField))
      }
      return rs.join()
    }
    return ''
  }
  static otherChargeItemMeasureLabFun(value = '') {
    const state = CommonState.getStateByCode(AirExportConstants.OTHER_CHARGE_ITEM_MEASURE, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  static officeLabelFunc(value = 0) {
    const office = getFilterCacheList(cacheKeys.basic_data_Office, (item) => {
      return item.officeId === Number(value)
    })
    if (office) {
      if ($store.getters.language === 'zh') {
        return office.chineseName || ''
      } else {
        return office.englishName || ''
      }
    }
    return ''
  }

  static officeLabelFormatFunc(value = 0, format) {
    if (!value) return ''
    const office = getFilterCacheList(cacheKeys.basic_data_Office, (item) => {
      return item.officeId === Number(value)
    })
    if (office) {
      return `[` + office[0].code + `]` + office[0].chineseName
    }
    return ''
  }
  static invoiceRemarkLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BRANCH_REMARK_CONFIG)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static jobTypeLabelFunc(jobType, data) {
    if (!data) return ''
    switch (jobType) {
      case 0:
        return lang.t('Pricing.jobTypeExport')
      case 1:
        return lang.t('Pricing.jobTypeImport')
      default:
        return lang.t('Pricing.jobTypeExport')
    }
  }

  static IsBookedLabelFunc(value) {
    return value ? i18n.t('Message.Yes') : i18n.t('Message.No')
  }
  // 投保-保单-出单状态
  static orderStatusLabelFunc(value) {
    const state = CommonState.getStateByCode(InsuranceConstants.ORDER_GENERATE_STATUS, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  static chargeTypeLabelFunc(chargeType, data) {
    if (!data) return ''
    switch (chargeType) {
      case 0:
        return lang.t('Pricing.LocalCharge')
      case 1:
        return lang.t('Pricing.DesCharge')
      case 2:
        return lang.t('Pricing.Surcharge')
      default:
        return ''
    }
  }
  // 业务类型 海运进口
  static containerTypeLabFun(value) {
    const state = CommonState.getStateByCode(SystemConstants.CONTAINER_LOAD_TYPE, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 文件大小转换
  static fileSizeColumnLabel(value) {
    if (value !== '' && !isNaN(value)) {
      return (value / 1024).toFixed(2) + ' KB'
    }
    return ''
  }

  static booleanColumnLabelFunc(value) {
    if (!value) return ''
    if (value) {
      return '√'
    } else {
      return ''
    }
  }

  static dateColumnLabelFunc(value) {
    const result = value || ''

    if (result !== '') {
      return result.split(' ')[0]
    }
    return result
  }

  // 是否需要更新
  static isNeedColumnLabelFunc(value) {
    return value === 1 ? '是' : ''
  }

  // 顺延周期
  static postponeTypeColumnLabelFunc(item, value) {
    if (item['postpone'] && parseInt(item['postpone']) !== 1) return '' // 非到期顺延
    let labelDesc = ''
    if (item['postponeType'] === 1) {
      labelDesc = i18n.t('CargoMsg.Cargo_1Year')
    } else if (item['postponeType'] === 2) {
      labelDesc = i18n.t('CargoMsg.Cargo_2Years')
    } else if (item['postponeType'] === 3) {
      labelDesc = i18n.t('CargoMsg.Cargo_3Years')
    } else if (item['postponeType'] === 9) {
      const state = CommonState.getStateByCode(ContractConstants.UNIT_TYPE, value)
      labelDesc = item['postponeLimited'].toString() + ' ' + this.label(state)
    }
    return labelDesc
  }

  // 结算类型
  static contractAgreementColumnLabelFunc(item, value) {
    let labelDesc = ''
    if (item['creditDateType'] > 0 || item['dateLimited'] > 0) {
      labelDesc = i18n.t('Partners.settlementNotByBill')
    } else {
      labelDesc = i18n.t('Message.ByTicket')
    }
    return labelDesc
  }

  // 结算方式
  static creditDateTypeColumnLabelFunc(item, value) {
    const state = CommonState.getStateByCode(ContractConstants.CREDITDATETYPE_TYPE, value)
    let labelDesc = ''
    if (item['creditDateType'] > 0) {
      labelDesc = i18n.t('CargoMsg.Cargo_FixedDateMonthly')
    } else {
      labelDesc = this.label(state)
    }
    return labelDesc
  }

  // 账期周期/付款账期
  static dateLimitedColumnLabelFunc(itemValue, value) {
    const state = CommonState.getStateByCode(ContractConstants.UNIT_TYPE, value)
    const labelDesc = itemValue + ' ' + this.label(state)
    return labelDesc
  }

  // 合同协议 合同类型 合同状态 日期类型 公用
  static contractColumnLabelFunc(arrays, value) {
    const state = CommonState.getStateByCode(arrays, value)
    return this.label(state)
  }

  static label(state) {
    if (!state) return ''
    return $store.getters.language === 'zh' ? state['chineseName'] : state['englishName']
  }

  // 单证流转 - 文件状态
  static fileStatusLabelFunc(code) {
    const state = CommonState.getStateByCode(SystemConstants.FILE_STATUS, code)
    if (!state) {
      return i18n.t('Message.UnKnownStatus')
    }
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 结算公司
  static settleDepartmentPrefixLabelFunc(value) {
    const departments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, (item) => {
      return item.jobNoPrefix && item.jobNoPrefix === value
    })
    if (departments && departments.length > 0) {
      return $store.getters.language === 'zh' ? departments[0].chineseName : departments[0].englishName
    } else {
      return ''
    }
  }

  // 结算公司
  static settleDepartmentAllrefixLabelFunc(value) {
    const departments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department_All, (item) => {
      return item.jobNoPrefix && item.jobNoPrefix === value
    })
    if (departments && departments.length > 0) {
      return $store.getters.language === 'zh' ? departments[0].chineseName : departments[0].englishName
    } else {
      return ''
    }
  }

  // 更改费用申请状态
  static changeChargeStateLabFun(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_STATES, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 判责审核结果
  static changeChargeJudgedutyLabFun(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_JUDGEDUTY, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 商务审核结果
  static changeChargeBusinessauditLabFun(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_BUSINESSAUDIT, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 关账判定
  static changeChargeJudgeclosedLabFun(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_JUDGECLOSED, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 申请类型
  static changeChargeActionTypeLabFun(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_ACTIONTYPE, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  /**
   * 换行显示
   * @param value
   * @param separator 分隔符
   * @returns {string}
   */
  static lineFeed(value, separator) {
    if (StrUtils.isEmpty(value)) {
      return ''
    }
    const array = value.split(separator)
    let resultStr = ''
    for (let i = 0; i < array.length; i++) {
      resultStr += array[i]
      if (i !== array.length - 1) {
        resultStr += '<br/>'
      }
    }
    return resultStr
  }

  /**
   * 获取单元格渲染后的数据值
   * @param api 表格api
   * @param data 行数据
   * @param field 列
   * @returns {*}
   */
  static getCellRenderValue(api, data, field) {
    const colDef = api.getColumn(field).colDef
    const params = { data: data, value: data[field], colDef }
    return colDef.cellRenderer(params)
  }
  static receivableInvoiceStateLabelFunction(value) {
    const state = CommonState.getStateByCode(BillingConstants.BILLING_INVOICE_STATES, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  static userToolTipLabel(value) {
    if (!value) return ''
    const user = User.getUserByIdSync(value)
    if (user) {
      return 'phone:' + user.phone + '\nEmail:' + user.email
    }
    return ''
  }
  static priceTierLabelFunc(priceTier) {
    if (!priceTier) return ''
    switch (priceTier) {
      case 99:
        return 'Tier 3'
      case 1:
        return 'Tier 1'
      case 2:
        return 'Tier 2'
      default:
        return ''
    }
  }
  // HBL提单方式
  static releaseTypeLabelFunction(type) {
    const isZh = $store.getters.language === 'zh'
    let text = ''
    switch (Number(type)) {
      case 1:
        text = isZh ? 'ORIGINAL' : 'ORIGINAL'
        break
      case 2:
        text = isZh ? 'SURRENDERED' : 'SURRENDERED'
        break
      case 3:
        text = isZh ? 'SEA WAYBILL' : 'SEA WAYBILL'
        break
    }
    if (!text) {
      const cacheList = getFilterCacheList(basicCacheKeys.basic_data_BlMode, (item) => {
        return item.blType === BlModeType.HBL.code
      })
      if (cacheList && cacheList.length > 0) {
        for (const blMode of cacheList) {
          if (blMode.serialNumber === Number(type)) {
            text = blMode.name
            break
          }
        }
      }
    }
    return text
  }
  // 红冲状态
  static offsetStateLabFun(value) {
    const isZh = $store.getters.language === 'zh'
    if (value > 0) {
      return isZh ? '是' : 'Yes'
    } else {
      return isZh ? '否' : 'No'
    }
  }
  // 费用锁定状态
  static chargeLockedStatusLabelFunc(value) {
    const isZh = $store.getters.language === 'zh'
    if (value > 0) {
      return isZh ? '已锁定' : 'Locked'
    } else {
      return isZh ? '未锁定' : 'Not Locked'
    }
  }
  // 是否签约
  static loadContractsLabelFunc(value) {
    return value ? lang.t('Message.ContSigned').replace('(', '').replace(')', '') : lang.t('Message.ContUnsigned').replace('(', '').replace(')', '')
  }

  // 港口个性化
  static getPortLabel(sourceField = '', sourceValue, sourceData, autoKey) {
    if (!sourceData.lob) return ''
    let key = TYPE_NAMES.basic_data_Seaport
    if (sourceData.lob === 'AE' || sourceData.lob === 'AI') key = TYPE_NAMES.basic_data_Airport
    if (sourceData.lob === 'RE' || sourceData.lob === 'RI') key = TYPE_NAMES.basic_data_RailwayStation
    return CustomLableUtils.getLabel(key, sourceField, sourceValue, autoKey)
  }
  static sendStatusLabelFunc(data) {
    const isZh = $store.getters.language === 'zh'
    if (data.makeType === 1 && data.sendStatus === 1) {
      return isZh ? '已发送' : 'Sent'
    } else {
      return isZh ? '未发送' : 'Not sent'
    }
  }
  // 关账类型
  static closingAccountTypeLabel(value) {
    const state = CommonState.getStateByCode(SystemConstants.CLOSING_ACCOUNT_TYPES, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 费用来源
  static chargeSourceLabel(value) {
    const state = CommonState.getStateByCode(SystemConstants.CHARGE_SOURCES, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 根据job获取下单状态(CARGO-19533)
  static getOrderState(job) {
    if (!job.externalBusinessStatus) return
    let externalBusinessStatus = ''
    switch (job.externalBusinessStatus) {
      case 1:
        externalBusinessStatus = i18n.t('Message.PendingOrder')
        break
      case 2:
        externalBusinessStatus = i18n.t('Message.OrderPlaced')
        break
      case 3:
        externalBusinessStatus = i18n.t('Message.ReceivedOrder')
        break
      case 4:
        externalBusinessStatus = i18n.t('SeaExport.Completed')
        break
      default:
        externalBusinessStatus = ''
    }
    return externalBusinessStatus
  }

  // 运输条款和整拼类型关联显示
  static shippingTermOperationTypeLabelFun(shippingTermOperationTypes) {
    if (!shippingTermOperationTypes || shippingTermOperationTypes.length === 0) return ''
    const isZh = $store.getters.language === 'zh'
    let text = ''
    if (shippingTermOperationTypes.length > 0) {
      const strs = []
      for (const item of shippingTermOperationTypes) {
        let state = ''
        let text = ''
        if (item.lob === 'SI') {
          state = CommonState.getStateByCode(ImportConstants._cargoTypeInputList, item.containerLoadType)
          text = lang.t('CargoMsg.Cargo_OceanImport')
        } else if (item.lob === 'SE') {
          state = CommonState.getStateByCode(ContainerLoadType.CONTAINERLOAD_TYPES, item.containerLoadType)
          text = lang.t('CargoMsg.Cargo_OceanExport')
        }
        if (state) {
          const name = isZh ? state.chineseName : state.englishName
          /* 判断其对立的主单、分单名称是否存在，若存在，合并成【*-主单/分单】格式 */
          const opposeIndex = strs.indexOf(text + '-' + name + '-' + this.getMblOrHblName(!item.mbl))
          if (opposeIndex >= 0) {
            strs[opposeIndex] = `${text}-${name}-${i18n.t('constant.BillType.MBL')}/${i18n.t('constant.BillType.HBL')}`
          } else {
            strs.push(text + '-' + name + '-' + this.getMblOrHblName(item.mbl))
          }
        }
      }
      text = strs.join(',')
    }
    return text
  }
  static getMblOrHblName(isMbl) {
    return isMbl ? i18n.t('constant.BillType.MBL') : i18n.t('constant.BillType.HBL')
  }
  // 业务中所有费用备注的集合转换
  static chargeRemarksLabelFunc(value) {
    if (value) {
      const remarks = value.split('@-@') // 分隔符固定，请勿随意修改
      if (remarks && remarks.length > 0) {
        let text = ''
        for (const remark of remarks) {
          if (text) {
            if (remark) {
              text = text + ',' + remark
            }
          } else {
            if (remark) {
              text = remark
            }
          }
        }
        return text
      }
    }
  }
  // 航线：铁路航线与其他四大业务
  static routeLabelFunction(data) {
    if (data && data.lob) {
      if (data.lob === 'RE' || data.lob === 'RI') {
        const cacheList = ColumnUtils.getBasicDataCacheList(basicCacheKeys.basic_data_RailwayLine, (item) => {
          if (item.code === data['transportLine']) {
            return true
          }
        })
        if (cacheList && cacheList.length) {
          return $store.getters.language === 'zh' ? cacheList[0].name : cacheList[0].nameEnglish
        }
      } else if (data.lob === SystemConstants.SE.code || data.lob === SystemConstants.AE.code ||
          data.lob === SystemConstants.AI.code || data.lob === SystemConstants.SI.code) {
        return $store.getters.language === 'zh' ? data['transportLine'] : data['transportLineEnglishName']
      }
    }
    return ''
  }
  // 业务中所有费用发票号的集合转换
  static chargeInvoiceNoLabelFunc(value) {
    if (value) {
      const invoiceNos = value.split(',') // 分隔符固定，请勿随意修改
      if (invoiceNos && invoiceNos.length > 0) {
        let text = ''
        for (const invoiceNo of invoiceNos) {
          if (text) {
            if (invoiceNo) {
              text = text + ',' + invoiceNo
            }
          } else {
            if (invoiceNo) {
              text = invoiceNo
            }
          }
        }
        return text
      }
    }
  }
  // 财务模块使用
  static routeLabelFunctionForBill(data) {
    if (data && data.jobLob) {
      if (data.jobLob === 'RE' || data.jobLob === 'RI') {
        const cacheList = ColumnUtils.getBasicDataCacheList(basicCacheKeys.basic_data_RailwayLine, (item) => {
          if (item.code === data['jobTransportLine']) {
            return true
          }
        })
        if (cacheList && cacheList.length) {
          return $store.getters.language === 'zh' ? cacheList[0].name : cacheList[0].nameEnglish
        }
      } else if (data.jobLob === 'SE' || data.jobLob === 'AE' || data.jobLob === 'SI' || data.jobLob === 'AI') {
        return $store.getters.language === 'zh' ? data['jobTransportLine'] : data['jobTransportLineEnglishName'] || ''
      }
    }
    return ''
  }
  // 应收\应付费用是否录入
  static chargeInputLabelFunction(value) {
    const realValue = value ? 1 : 0
    const state = CommonState.getStateByCode(SystemConstants.CHARGE_INPUT_LIST, Number(realValue))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 委托单位转换
  static customerLabelFunc(data) {
    return $store.getters.language === 'zh' ? data.customerChineseName : data.customerEnglishName
  }
  //
  static chargeLockedStatus(data) {
    const isZh = $store.getters.language === 'zh'
    const state = ChargeConstants.getCommonState(data, ChargeConstants.CHARGE_LOCKED_STATES)
    if (state) {
      return isZh ? state.chineseName : state.englishName
    }
    return isZh ? '状态未知' : 'Status unknown'
  }
  /**
   * soNo /n替换,
   */
  static soNoLabelFunc2(value) {
    if (!value) return ''
    return ColumnUtils.soNoLabelFunc(value ? value.split('\n').join(',') : '')
  }
  // SoNo去重显示
  static soNoLabelFunc(value) {
    if (!value) return ''
    let text = ''
    if (value) {
      const soNos = value.split(',')
      if (soNos && soNos.length > 0) {
        for (const item of soNos) {
          const soNoList = item.split('\n')
          if (soNoList && soNoList.length > 0) {
            for (const soNo of soNoList) {
              if (soNo) {
                if (text) {
                  if (text.indexOf(soNo) === -1) {
                    text = text + ',' + soNo
                  }
                } else {
                  text = soNo
                }
              }
            }
          }
        }
      }
    }
    return text
  }
  // 承运人
  static carrierLabelFunc(data, value) {
    if (!value) return ''
    if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'SI' || data.lob === 'SE')) {
      return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', value, 'auto_5')
    } else if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'AI' || data.lob === 'AE')) {
      return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', value, 'auto_6')
    }
    return ''
  }
  // 账单确认状态
  static billingConfirmStateLabFun(value) {
    const isZh = $store.getters.language === 'zh'
    if (!value) {
      return isZh ? BillingConstants.BILLING_NORMAL.chineseName : BillingConstants.BILLING_NORMAL.englishName
    }
    return isZh ? BillingConstants.BILLING_VERIFIED.chineseName : BillingConstants.BILLING_VERIFIED.englishName
  }
  // 付款申请单承运人转换
  static carrierForBillPaymentLabelFunc(data) {
    return $store.getters.language === 'zh' ? data.carrierChineseName : data.carrierEnglishName
  }
  //
  static wareHouseRegionLabelFunc(data) {
    if (!data || data.length === 0) return ''
    const isZH = $store.getters.language === 'zh'
    let text = ''
    for (const item of data) {
      if (!item.deleted) {
        if (isZH) {
          text = text + item.regionName + ','
        } else {
          text = text + item.regionEnglishName + ','
        }
      }
    }
    return text ? text.substr(0, text.length - 1) : ''
  }
  // 委托单位客户级别转换
  static customerTypeLabelFunc(data) {
    if (!data) return ''
    return $store.getters.language === 'zh' ? data.customerTypeChineseName : data.customerTypeEnglishName
  }
  /**
   * 五大业务公用-整拼类型、操作模式、委托类型
   */
  static loadTypeLabelFunction(data, column) {
    const fieldName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    let state = null
    if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'SI')) {
      state = CommonState.getStateByCode(ImportConstants._cargoTypeInputList, data[column])
    } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'AE') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'AE') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'AE')) {
      state = CommonState.getStateByCode(AirExportConstants.BUSINESS_MODELS, Number(data[column]))
    } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'AI') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'AI') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'AI')) {
      state = CommonState.getStateByCode(ImportConstants._cargoTypeAirInputList, Number(data[column]))
    } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'IE')) {
      state = CommonState.getStateByCode(ContainerLoadType.IE_TYPES, Number(data[column]))
    } else { // 铁路、海出一样的
      state = ContainerLoadType.getContainerLoadTypeByCode(data[column])
    }
    return !state ? '' : state[fieldName]
  }
  // 时间转String
  static unBerthPlanDateLabelFunc(value) {
    const date = this.dateMinutesLabelFunc(value)
    return date ? String(date) : ''
  }
  // 订舱代理转换
  static bookingAgentLabelFunc(data) {
    if (!data) return ''
    return $store.getters.language === 'zh' ? data.bookingAgentChineseName : data.bookingAgentEnglishName
  }
  // 整箱运价目的区域
  static regionForPriceFclLabelFunc(data) {
    if (data && data.pod) {
      const ports = getFilterCacheList(cacheKeys.basic_data_Seaport, (item) => { return item.code === data.pod })
      if (ports && ports.length > 0) {
        return $store.getters.language === 'zh' ? ports[0].regionCnName : ports[0].regionEnName
      }
    }
    return ''
  }
  // 空运运价目的区域
  static regionForPriceAirLabelFunc(data) {
    if (data && data.pod) {
      const ports = getFilterCacheList(cacheKeys.basic_data_Airport, (item) => { return item.code === data.pod })
      if (ports && ports.length > 0) {
        return $store.getters.language === 'zh' ? ports[0].regionCnName : ports[0].regionEnName
      }
    }
    return ''
  }
  // 收付款方式显示列转换
  static receiveTypeFunc(value) {
    const state = CommonState.getStateByCode(ClearingConstants.AMOUNT_RECEIVE_TYPES, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 水单状态显示列转换
  static cashTransferStateFunc(value) {
    const state = CommonState.getStateByCode(ClearingConstants.CASH_TRANSFER_STATES, Number(value))
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }
  // 运价截关日转换
  static closingDayFunc(value) {
    if (StrUtils.isEmpty(value) || !value) return ''
    if (String(value).indexOf(',') >= 0) {
      return String(value).replaceAll(',', '/')
    }
    return String(value)
  }

  /**
   * EAS费用状态
   * @param value
   */
  static easChargeStateLabFun(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.ALL_EAS_CHARGE_STATES)
    return !state ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 放行信息转换
   */
  static releaseDateLabelFunc(data, fieldName) {
    if (data != null) {
      const wharfReleaseState = data['wharfReleaseState']
      if (fieldName === 'wharfReleaseDate' && wharfReleaseState === 'D') {
        return 'R'
      }
      // alert(wharfReleaseRtate)
      const value = data[fieldName]
      if (value) {
        return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
      }
    }
    return 'N'
  }

  /**
   * 仓库类型
   * @param value
   * @returns {string|*}
   */
  static warehouseTypeLabFun(value) {
    const isZh = $store.getters.language === 'zh'
    const state = SystemConstants.getCommonState(value, SystemConstants.WARE_HOUSE_TYPE_LIST)
    return state === null ? (isZh ? '状态未知' : 'Status unknown') : (isZh ? state.chineseName : state.englishName)
  }
  // 分摊方式
  static shareSchemeFunc(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.SHARE_CHARGE_SCHEMES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 客户接触渠道
  static customerContactChannelLabelFun(str) {
    if (!str) str = 0
    // 客户类型 CARGO-25396 客户类型、客户接触渠道改为基础数据维护
    let sourceTypeGrids = CrmCustomerConstants.CUSTOMER_CONTACT_CHANNEL_GRID
    sourceTypeGrids = sourceTypeGrids.concat(getSpecificBasicDataFromCache(cacheKeys.basic_data_CustomerContactChannel))
    const state = sourceTypeGrids.find(p => parseInt(p.code) === parseInt(str))
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 启用状态
  static enableStatusLabelFunction(value) {
    const isZh = $store.getters.language === 'zh'
    let text = ''
    if (value) {
      text = isZh ? '启用' : 'Enabled'
    } else {
      text = isZh ? '禁用' : 'Disabled'
    }
    return text
  }

  /**
   * 付款申请-自定义岗位处理
   * @param value
   */
  static getUserDefinedLabel(value) {
    if (!value) return ''
    const curArr = value.split(',')
    const realArr = []
    if (curArr && curArr.length > 0) {
      for (const cur of curArr) {
        if (!cur) continue
        const label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(cur), 'chineseName')
        realArr.push(label)
      }
    }
    return realArr.length > 0 ? realArr.join(',') : ''
  }

  /**
   * 到货方式
   */
  static LoadingTermLabFun(value) {
    if (!value) return ''
    const isZh = $store.getters.language === 'zh'
    const state = SystemConstants.getCommonState(value, AirExportConstants.SUFFY_TYPES)
    return state === null ? (isZh ? '状态未知' : 'Status unknown') : (isZh ? state.chineseName : state.englishName)
  }

  /**
   * EDI类型
   * @param data
   * @returns {string}
   */
  static ediTypeLabelFunc(isXy, data) {
    if (data.type) {
      const isZh = $store.getters.language === 'zh'
      // CARGO-32971 星亚的status和通讯回执A的值一致导致类型无法显示
      if (isXy && Number(data.type) === EdiType.E2_OPEN) {
        let e2openType = ''
        if (data.status === 6) {
          e2openType = isZh ? EdiState.ORIGINAL.chineseName : EdiState.ORIGINAL.englishName
        } else if (data.status === 5) {
          e2openType = isZh ? EdiState.UPDATE.chineseName : EdiState.UPDATE.englishName
        } else if (data.status === 1) {
          e2openType = isZh ? EdiState.DELETE.chineseName : EdiState.DELETE.englishName
        }
        return e2openType + '-' + data.sendType
      } else {
        const ediType = EdiType.getEdiTypeByCode(Number(data.type))
        if (ediType) {
          return isZh ? ediType.chineseName : ediType.englishName
        }
      }
    }
    return ''
  }

  /**
   * EDI发送状态
   * @param value
   * @returns {string|*}
   */
  static ediStateLabelFunc(isXy, data) {
    if (!data.status) return lang.t('CargoMsg.Cargo_Other')
    if (isXy && data.type === EdiType.E2_OPEN) { // E2Open
      return data.sendVersion ? lang.t('SeaExport.SentSuccessfully') : lang.t('SeaExport.sendFailed')
    } else {
      const ediState = EdiState.getEdiStateByStatus(Number(data.status))
      if (ediState) {
        return $store.getters.language === 'zh' ? ediState.chineseName : ediState.englishName
      }
    }
    return lang.t('CargoMsg.Cargo_Other')
  }

  /**
   * OC支付状态
   * @param value
   */
  static ocPaymentStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OCPAYMENT_STATUS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * OC付款方式
   * @param value
   */
  static ocPaymentMethodLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OCPAYMENT_METHOD)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * OC是否处理
   */
  static ocProcessedLabelFunc(value) {
    let yes = 'Processed'
    let no = 'Not processed'
    if ($store.getters.language === 'zh') {
      yes = '已处理'
      no = '未处理'
    }
    return value ? yes : no
  }

  /**
   * 多值名称转换
   * @param list CommonState数据源
   * @param values 多数据值
   * @param splitStr 分隔符
   * @param isNumber 是否数字
   * @returns {string|[]}
   */
  static constantsNameByMultiNumberValue(list, values, splitStr, isNumber = false) {
    if (!values) {
      return ''
    }
    const data = isNumber ? commonUtil.splitToNumberArray(values, splitStr) : values.split(splitStr)
    if (!data || data.length === 0) {
      return ''
    }
    const result = []
    for (const item of data) {
      const name = CommonState.getNameByCode(list, item)
      result.push(name)
    }
    return result
  }
  static ltsChargeStateFunc(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.ALL_LTS_STATUS)
    return state === null ? $store.getters.language === 'zh' ? '未同步' : 'Not sent' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 出库方式
  static deliveryModeLabelFun(deliveryMode = 0) {
    const state = CommonState.getStateByCode(FbaJobConstants.DELIVERY_MODES, deliveryMode)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  // 出库状态
  static deliveryStatusLabelFun(status = 0) {
    const state = CommonState.getStateByCode(FbaJobConstants.DELIVERY_STATUS, status)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  /**
   * 国外仓状态
   */
  static outWarehouseStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.OVERSEA_WAREHOUSE_STATUS)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 核单结果
   */
  static checklistResultLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHECKLIST_STATUS)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * fba下单预审状态
   */
  static verifyStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.VERIFY_STATES)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * fba下单提交状态
   */
  static submitStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.SUBMIT_STATES)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * fba下单运输方式
   */
  static shippingTypeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.SHIPPING_TYPES)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * OC异常说明
   * @param value
   */
  static ocAbnormalStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OCABNORMAL_STATE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 计算方式
  static calcMethodLabelFunc(chargeType) {
    const state = SystemConstants.getCommonState(chargeType, FbaJobConstants.CALC_METHOD)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 目的地
  static podLabelFunc(data, warehouseCodes) {
    if (!data || !warehouseCodes) return ''
    if (warehouseCodes) {
      const warehouseCodeArr = warehouseCodes.split(',')
      let warehouse = null
      const rs = []
      for (const cpy in warehouseCodeArr) {
        const warehouseCode = warehouseCodeArr[cpy]
        warehouse = !StrUtils.isEmpty(warehouseCode) ? getObjectByCache(basicCacheKeys.basic_data_OverseaWarehouse, 'warehouseCode', warehouseCode) : null
        if (warehouse && warehouse.warehouseCode) rs.push(warehouse.warehouseCode)
      }
      if (rs.length > 0) return rs.join()
    }
    return ''
  }
  // 报价对象
  static QuotationObjectLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.QUOTATION_OBJECTS)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 附加费类型
  static ChargeTypeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, FbaJobConstants.SURCHARGE_TYPES)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 费用同步进行
   * @param value
   */
  static chargeSyncProgrssLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.SYNC_PROGRESS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 费用同步撤回状态
   * @param value
   */
  static chargeSyncRecallStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.SYNC_RECALL_STATE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 金蝶云星空同步状态
   * @param value
   */
  static jdyxkSyncStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.JDYXK_SYNC_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 业务金蝶云星空同步状态
   * @param value
   */
  static jobJdyxkSyncStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.JOB_JDYXK_SYNC_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 转换提单签发状态
  static constantsBillLadingIssuingStatus(value) {
    switch (value) {
      case 0:
        return i18n.t('Message.NotIssued')
      case 12:
        return i18n.t('Message.Issued')
      case 7:
        return i18n.t('Message.Retrieved')
      case 8:
        return i18n.t('Message.Accepted')
      case 9:
        return i18n.t('Message.Claimed')
      case 13:
        return i18n.t('Message.ChangeOrder')
    }
  }

  /**
   * 进位规则
   */
  static carryRuleLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CARRY_RULES)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 协作业务类型
  static businessTypeLabelFunc(value) {
    const values = []
    if (!StrUtils.isEmpty(value)) {
      const codes = value.split(',')
      for (const code of codes) {
        const chineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CooperationType, 'code', code, 'chineseName')
        if (chineseName) values.push(chineseName)
      }
    }
    return values.join(' | ')
  }

  /**
   * 协作状态
   */
  static cooperateStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.COOPERATE_STATUS)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 业务/费用状态
   */
  static businessStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BUSINESS_STATUS)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 生成列名为"客商类型"的内容，其内容由多个字段以','拼接而成
   * @param data
   * @returns {string}
   */
  static generateCustomerSupplierTypeContent(data) {
    const list = []
    if (data.customer) {
      list.push(lang.t('Payment.customer'))
    }
    if (data.bookingAgent) {
      list.push(lang.t('SeaExport.BookingAgent') + '/' + lang.t('SeaExport.BillExchangeAgent'))
    }
    if (data.seaCmpAgent) {
      list.push(lang.t('SeaExport.CarrierAgent'))
    }
    if (data.overseaAgent) {
      list.push(lang.t('Payment.destinationAgent'))
    }
    if (data.designationAgent) {
      list.push(lang.t('queryJob.nominatedAgent'))
    }
    if (data.localAgent) {
      list.push(lang.t('SeaExport.LocalAgent'))
    }
    if (data.settlementAgent) {
      list.push(lang.t('Payment.settlementAgent'))
    }
    if (data.seaCmp) {
      list.push(lang.t('SeaExport.ShippingCompany'))
    }
    if (data.airCmp) {
      list.push(lang.t('SeaExport.AirlineCompany'))
    }
    if (data.customsBroker) {
      list.push(lang.t('SeaExport.CustomsBroker'))
    }
    if (data.warehouse) {
      list.push(lang.t('SeaExport.Warehouse'))
    }
    if (data.truckCmp) {
      list.push(lang.t('Partners.isTruckCmp'))
    }
    if (data.shipper) {
      list.push(lang.t('Message.Shipper'))
    }
    if (data.consignee) {
      list.push(lang.t('Message.Consignee'))
    }
    if (data.notify) {
      list.push(lang.t('Message.Notify'))
    }
    if (data.portAgent) {
      list.push(lang.t('Partners.portAgent'))
    }
    if (data.forwardingAgent) {
      list.push(lang.t('Partners.forwardingAgent'))
    }
    if (data.loadingPlaceCompany) {
      list.push(lang.t('Partners.loadingPlaceCompany'))
    }
    if (data.signBillPlaceCompany) {
      list.push(lang.t('Partners.signBillPlaceCompany'))
    }
    if (data.dischargePortCompany) {
      list.push(lang.t('Partners.dischargePortCompany'))
    }
    if (data.destinationPortCompany) {
      list.push(lang.t('Partners.destinationPortCompany'))
    }
    if (data.tradersSign) {
      list.push(lang.t('Partners.traders'))
    }
    if (data.factorySign) {
      list.push(lang.t('Partners.Factory') + '/' + lang.t('Order.Producer'))
    }
    if (data.other) {
      list.push(lang.t('Message.Other'))
    }
    if (data.terminalCompany) {
      list.push(lang.t('Message.TerminalCompany'))
    }
    return list.join(',')
  }
  // 账期
  static AccountPeriodLabelFunc(data) {
    if (data.creditDateLimited >= 0) {
      switch (data.termUnit) {
        case 0:
          return data.creditDateLimited + lang.t('Partners.day')
        case 1:
          return data.creditDateLimited + lang.t('Partners.week')
        case 2:
          return data.creditDateLimited + lang.t('Partners.month')
      }
    }
    return ''
  }
  // 信控日期类型（业务维度）
  static creditDateTypeLabelFunc(value) {
    if (typeof value === 'number') {
      switch (value) {
        case 0:
          return lang.t('Partners.monthlySettlement')
        case -1:
          return lang.t('Partners.monthlySettlement')
        case -2:
          return lang.t('CargoMsg.Cargo_SettleByWeekly')
        case -3:
          return lang.t('Partners.space5')
        case -4:
          return lang.t('Partners.dailySettlement')
        default:
          return lang.t('CargoMsg.Cargo_FixedDateMonthly')
      }
    }
    return ''
  }
  // 信控日期类型（合作伙伴维度，多个生效合同时，以'/'拼接）
  static creditDateTypeMultiLabelFunc(company) {
    if (company.normalRuleContactExist) {
      let text = ''
      company.contractList.forEach(contract => {
        const value = contract.creditDateType
        if (typeof value === 'number') {
          switch (value) {
            case -1:
              text = text + lang.t('Partners.monthlySettlement')
              break
            case -2:
              text = text + lang.t('CargoMsg.Cargo_SettleByWeekly')
              break
            case -3:
              text = text + lang.t('Partners.space5')
              break
            case -4:
              text = text + lang.t('Partners.dailySettlement')
              break
            default:
              text = text + lang.t('CargoMsg.Cargo_FixedDateMonthly')
              break
          }
        }
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    const value = company.creditDateType
    if (typeof value === 'number') {
      switch (value) {
        case -1:
          return lang.t('Partners.monthlySettlement')
        case -2:
          return lang.t('CargoMsg.Cargo_SettleByWeekly')
        case -3:
          return lang.t('Partners.space5')
        case -4:
          return lang.t('Partners.dailySettlement')
        default:
          return lang.t('CargoMsg.Cargo_FixedDateMonthly')
      }
    }
    return ''
  }
  // CARGO-31303，USA REPORT界面中前端科目代码需要展示为8位
  static accountNoLabelItemRenderer(value) {
    if (value) {
      let result = value + ''
      switch (result.length) {
        case 4:
          result += '.00.00'
          break
        case 7:
          result += '.00'
          break
      }
      return result
    }
    return ''
  }

  /**
   * 操作要求操作类型
   */
  static operationRequirementTypeFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OPERATION_REQUIREMENT_TYPES)
    if (!state) return '类型未知'
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static showTypeLabelFunc(value, list) {
    const state = SystemConstants.getCommonState(value, list)
    if (!state) return value
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 放货方式
   */
  static releaseTypeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ImportConstants._importReleaseTypes)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 结算类型
  static creditDateTypeColumnLabelFunc2(item) {
    if (item.normalRuleContactExist) {
      let text = ''
      item.contractList.forEach(contract => {
        if (contract['creditDateLimited'] === 0 && [CREDITDATETYPE_MONTH2.code, CREDITDATETYPE_MONTH.code, CREDITDATETYPE_WEEK.code, CREDITDATETYPE_HALFMONTH.code, CREDITDATETYPE_DAY2.code].indexOf(contract['creditDateType']) !== -1) {
          text = text + i18n.t('Message.ByTicket')
        } else {
          text = text + i18n.t('Partners.settlementNotByBill')
        }
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    let labelDesc = ''
    if (item['creditDateLimited'] === 0 && [CREDITDATETYPE_MONTH2.code, CREDITDATETYPE_MONTH.code, CREDITDATETYPE_WEEK.code, CREDITDATETYPE_HALFMONTH.code, CREDITDATETYPE_DAY2.code].indexOf(item['creditDateType']) !== -1) {
      labelDesc = i18n.t('Message.ByTicket')
    } else {
      labelDesc = i18n.t('Partners.settlementNotByBill')
    }
    return labelDesc
  }

  // 额度
  static creditLabelFunc(data) {
    if (data.credit) {
      return `${data.credit}${data.currency}`
    } else {
      return ''
    }
  }

  /**
   * 英文版转账单类型
   * @param value
   * @returns {VueI18n.LocaleMessageArray}
   */
  static getBillType(value) {
    const isZh = $store.getters.language === 'zh'
    if (!isZh) {
      if (value === '国内账单') {
        value = i18n.t('SeaExport.InternalBillInfo')
      } else if (value === '国外账单') {
        value = i18n.t('SeaExport.OverseaBillInfo')
      } else if (value === '代理分成账单') {
        value = i18n.t('SeaExport.AgentIntoBills')
      }
    }
    return value
  }

  // // 多分公司label
  // static officesLabelFuncWithAll(tenantId, officeIds, allOffice) {
  //   if (!officeIds || officeIds.length === 0) {
  //     return ''
  //   }
  //   let officeNames = []
  //   const isZh = $store.getters.language === 'zh'
  //   officeIds.forEach(officeId => {
  //     if (officeId === 0) {
  //       const officeName = isZh ? '全部' : 'ALL'
  //       officeNames = [...officeNames, officeName]
  //     } else {
  //       const office = allOffice.find(item => item.tenantId === tenantId && item.officeId === officeId)
  //       if (office) {
  //         officeNames = [...officeNames, isZh ? office.chineseName : office.englishName]
  //       }
  //     }
  //   })
  //   return officeNames.join(',')
  // }

  // 表单label（eg: 付款单据）
  static workflowTypeLabelFunc(type) {
    const state = SystemConstants.getCommonState(type, WorkflowConstants.WORKFLOW_TYPES)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 显示列增加序号
  static addSerialNumber(rowData) {
    rowData.forEach((item, index) => {
      item.serialNumber = index + 1
    })
  }

  static sortChanged(params, columnDefs, rowData) {
    let serialNumber = 0
    const nodes = params.api.rowModel.rowsToDisplay
    nodes.forEach(node => {
      const row = rowData.filter(row => {
        return row.id === node.data.id
      })[0]
      row.serialNumber = ++serialNumber
    })
    // columnDefs.forEach(column => {
    //   delete column.colId
    // })
    params.api.refreshCells({ force: true })
  }

  /**
   * 运输工具类型
   */
  static typeOfTransportFunction(value) {
    const state = SystemConstants.getCommonState(value, InvoiceConstant.INVOICE_CARGO_TRANSPORT)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  特定约束类型
   */
  static specificConstraintType(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  全电红字申请状态
   */
  static feiRedApplicationStatus(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.RED_OFFSET_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   *  红冲原因
   */
  static fedFlushReason(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.RED_OFFSET_REASON_ALL)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 账单结算类型
   */
  static billSettlementTypeLableFun(value) {
    const state = BillingConstants.getCommonState(value, BillingConstants.SETTLEMENT_TYPE_STATES)
    if (!state) {
      return ''
    }
    return $store.getters.isZh ? state.chineseName : state.englishName
  }

  /**
   * 账单结算类型（多个，用逗号隔开）
   */
  static billSettlementTypesLableFun(value) {
    if (!value) {
      return
    }
    const strs = value.split(',')
    const newValues = []
    for (const str of strs) {
      newValues.push(this.billSettlementTypeLableFun(Number(str)))
    }
    return newValues.join(',')
  }

  /**
   * 订舱EDI发送通道
   */
  static bookingEdiSendingChannelLabelFunc(value) {
    if (!value) return ''
    const state = ChargeItemTarget.getChargeItemTargetByCode2(value, ChargeItemTarget.MODEL_TYPES)
    if (!state) return ''
    return $store.getters.isZh ? state.chineseName : state.englishName
  }

  /**
   * 预配状态
   */
  static provisioningStatusLabelFunc(value) {
    let state = null
    for (const arr of SeaExportConstants.PROVISIONING_STATUS) {
      if (parseInt(arr.code) === parseInt(value)) {
        state = arr
        break
      }
    }
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 凭证录入-会计科目
   */
  static accountTitleColumnLabelFunc(accountTitleCollection = [], accountingEntry) {
    if (accountingEntry && accountTitleCollection) {
      const accountTitle = accountTitleCollection.find(title => title.accountTitle === accountingEntry.accountTitle)
      if (!accountTitle) return ''
      let msg = accountTitle.accountTitle + ' ' + accountTitle.accountTitleName
      const auxiliaryStr = this.fillVoFromAuxiliary(accountingEntry, accountTitle)
      if (auxiliaryStr) {
        msg += ' \n' + auxiliaryStr
      }
      return msg
    }
    return ''
  }
  static fillVoFromAuxiliary(accountingEntry, accountTitle) {
    if (accountTitle) {
      let auxiliaryStr = ''
      if (accountTitle && accountTitle.auxiliary) {
        if (accountTitle.auxiliaryCustomer) {
          if (auxiliaryStr) {
            auxiliaryStr += '/'
          }
          if (accountingEntry.accountClient) {
            const customer = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', accountingEntry.accountClient, 'chineseName')
            if (!StrUtils.isEmpty(customer)) auxiliaryStr += customer
          }
        }
        if (accountTitle.auxiliarySupplier) {
          if (auxiliaryStr) {
            auxiliaryStr += '/'
          }
          if (accountingEntry.accountClient) {
            const supplier = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', accountingEntry.accountClient, 'chineseName')
            if (!StrUtils.isEmpty(supplier)) auxiliaryStr += supplier
          }
        }
        if (accountTitle.auxiliaryDepartment) {
          if (auxiliaryStr) {
            auxiliaryStr += '/'
          }
          if (accountingEntry.department) {
            const department = ColumnUtils.departmentLabelNewFunc(accountingEntry.department)
            if (!StrUtils.isEmpty(department)) auxiliaryStr += department
          }
        }
        if (accountTitle.auxiliarySales) {
          if (auxiliaryStr) {
            auxiliaryStr += '/'
          }
          if (accountingEntry.sales) {
            const sales = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', accountingEntry.sales, 'chineseName')
            if (!StrUtils.isEmpty(sales)) auxiliaryStr += sales
          }
        }
        if (accountTitle.auxiliaryProjectNumber) {
          if (auxiliaryStr) {
            auxiliaryStr += '/'
          }
          if (accountingEntry.projectNumber) {
            auxiliaryStr += accountingEntry.projectNumber
          }
        }
        this.auxiliaryString = auxiliaryStr
        return auxiliaryStr
      }
    }
  }

  /**
   * 获取分公司显示内容
   */
  static getOfficeLabel(sourceField, sourceValue) {
    if (!sourceValue) return ''
    const item = getObjectByCache(basicCacheKeys.basic_data_Office_All, sourceField, sourceValue)
    if (!item) return ''
    const configs = $store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === 'auto_office')
    const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    switch (label) {
      case 'chineseName':
        return item.chineseName
      case 'englishName':
        return item.englishName
      default:
        return item.code
    }
  }

  static paymentTermLabelFunc(value) {
    if (!value) return ''
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_PaymentTerm, 'code', value, 'auto_paymentTerm') || ''
  }

  // 合作伙伴角色
  static companyRoleLabelFunction(value, type) {
    if (!value) {
      return ''
    }
    const ids = (value instanceof Array) ? value : value.split(',')
    const label = []
    for (const id of ids) {
      label.push(ColumnUtils.resolveColumnLabel(type, 'code', id, 'chineseName'))
    }
    return label.join(';')
  }

  // 智能托书来源
  static intelligentDocumentSourceLabelFunction(value) {
    const state = CommonState.getStateByCode(SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_LIST, Number(value))
    if (!state) return ''
    return $store.getters.isZh ? state.chineseName : state.englishName
  }

  static getIncoTermIsFobOrCif(type) {
    const incoTerms = getCacheListByKey(basicCacheKeys.basic_data_IncoTerm)
    for (const incoTerm of incoTerms) {
      if (incoTerm.code === type) {
        return type
      }
    }
    return ''
  }

  /**
   * 申请维度 label
   * @param data
   */
  static applicationDimensionLabel(value) {
    const state = SystemConstants.getCommonState(value, WorkflowConstants.APPLICATION_DIMENSIONS)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 审批状态
   */
  static approvalStatusLabelFun(value) {
    const state = BillingConstants.getCommonState(value, SystemConstants.BPM_STATES)
    if (!state) {
      return ''
    }
    return $store.getters.isZh ? state.chineseName : state.englishName
  }

  /**
   * 结算类型 label
   * @param data
   */
  static settlemtTypeLabel(value) {
    return value === 1 ? i18n.t('Partners.settlementByBill') : i18n.t('Partners.settlementNotByBill')
  }

  /**
   * 信号旗接口
   */
  static xhqInterfaceLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.XHQ_INTERFACE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * API接口数据流向
   */
  static apiDataFlowDirectionLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.API_DATA_FLOW_DIRECTION)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 费用确认来源
   */
  static chargeConfirmSourceLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_CONFIRM_SYNC_SOURCE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 指定货代理邮件对单发送状态
   */
  static mailSendStatusLabelFunc(value) {
    return Number(value) === 1 ? i18n.t('CargoMsg.Cargo_Sent') : i18n.t('CargoMsg.Cargo_NotSent')
  }

  /**
   * 是否处理
   */
  static processedLabelFunc(value) {
    let yes = 'Processed'
    let no = 'Not processed'
    if ($store.getters.language === 'zh') {
      yes = '已处理'
      no = '未处理'
    }
    return value ? yes : no
  }

  /**
   * 生成列名为"合作伙伴类型"的内容，其内容由多个字段以','拼接而成
   */
  static generatePartnerTypeContent(data) {
    const list = []
    if (data.ifCustomer) {
      list.push(lang.t('Payment.customer'))
    }
    if (data.ifSupplier) {
      list.push(lang.t('Order.Supplier'))
    }
    return list.join(',')
  }

  // 提单类型
  static customOrderFormTypeFunc(doc) {
    const orderFormTypeList = getCacheListByKey(basicCacheKeys.basic_data_OrderFormType)
    if (!orderFormTypeList || orderFormTypeList.length === 0) {
      doc.issuerBL = 'UBI'
    } else {
      doc.issuerBL = orderFormTypeList[0].code
    }
  }

  // 公用
  static columnLabelFunc(arrays, value) {
    if (!value && value !== 0) return ''
    const state = CommonState.getStateByCode(arrays, value)
    return this.label(state)
  }

  static fieldCellStyle(arChargeBefore, arChargeAfter, apChargeBefore, apChargeAfter, ar, params) {
    const fields = params.colDef.field
    const data = params.data
    const [chargeBefore, chargeAfter] = ar ? [arChargeBefore, arChargeAfter] : [apChargeBefore, apChargeAfter]
    const lengthBefore = chargeBefore.length
    const lengthAfter = chargeAfter.length
    if (lengthBefore === 0 || lengthAfter === 0) {
      return false
    }
    const before = chargeBefore.find(p => p.uuid === data.originalChargeUuid)
    const after = chargeAfter.find(p => p.uuid === data.uuid)
    return before && after && before[fields] !== after[fields]
  }

  static fieldCellStyle2(list1, list2, params, isNumber) {
    const fields = params.colDef.field
    const data = params.data
    const lengthBefore = list1.length
    const lengthAfter = list2.length
    if (lengthBefore === 0 || lengthAfter === 0) {
      return false
    }
    const before = list1.find(p => p.uuid === data.originalChargeUuid)
    const after = list2.find(p => p.uuid === data.uuid)
    if (isNumber) {
      return before && after && before[fields] !== Number(after[fields])
    } else {
      return before && after && before[fields] !== after[fields]
    }
  }

  /**
   * 外部推送费用确认来源
   */
  static chargeConfirmSourceOutLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_PUSH_SOURCE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 外部费用同步状态
   * @param value
   */
  static chargeConfirmStateLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_CONFIRM_SYNC_STATUS_OUT)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 应收应付
   */
  static arApLabelFunc(value) {
    return value ? i18n.t('Message.Receivable') : i18n.t('Message.Payable')
  }

  /**
   * Payment Method: 杰贝越南税控
   */
  static paymentMethodVietnamLabelFun(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.PAYMENT_METHOD_VIETNAM)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * Invoice Status: 杰贝越南税控
   */
  static invoiceStatusVietnamLabelFun(value) {
    const state = InvoiceConstant.getCommonState(value, InvoiceConstant.INVOICE_STATUS_VIETNAM)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 精谕放货状态
   */
  static jyReleaseStatusLabelFunc(value) {
    const state = JyWarehouseConstants.getNameByCode(value, JyWarehouseConstants.RELEASE_STATE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 精谕Api名称
   */
  static jyInterfaceLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.JY_INTERFACE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 发送通道
   */
  static vgmChannelLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SeaExportConstants.SEND_CHANNELS)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 中邮接口发送状态
   * @param value
   */
  static zyInterfacePushStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.ZY_INTERFACE_PUSH_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 中邮-国内/全程 选择
   */
  static resolveFullOrInside(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.FULL_OR_INSIDE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 上海虹迈对接用友同步状态
   * @param value
   */
  static hmYongYouSyncStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, ChargeConstants.HM_YONGYOU_SYNC_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 中邮-根据费用映射获取对应税率
  static getTaxRateFromMapping(chargeItemId, saleProductCode, fullOrInside) {
    const chargeMappingResult = getFilterCacheList(TYPE_NAMES.basic_data_ChargeMapping, (mapping) => {
      return mapping.chargeItemId === chargeItemId && mapping.saleProductCode === saleProductCode && mapping.fullOrInside === fullOrInside
    })
    if (chargeMappingResult.length === 1) {
      return chargeMappingResult[0].taxRate
    } else {
      return 0
    }
  }

  // 根据字段值解析为转换后的值
  static resolveSpecificField(result = [], sourceField = '', sourceValue, targetField, isNeedObject) {
    let targetValue = ''
    if (!result || !sourceValue) {
      return targetValue
    }
    if (sourceField && targetField) {
      const entity = result.find(item => {
        return item[sourceField] === sourceValue
      })
      if (entity) {
        if (isNeedObject) {
          targetValue = entity
        } else {
          targetValue = entity[targetField] || ''
        }
      }
    }
    return targetValue
  }

  static checkFieldUpdate(chargeBefore, chargeAfter, params, isNumber) {
    const fields = params.colDef.field
    const lengthBefore = chargeBefore.length
    const lengthAfter = chargeAfter.length
    if (lengthBefore === 0 || lengthAfter === 0) {
      return false
    }
    const before = chargeBefore.find(p => p.uuid === params.uuid)
    const after = chargeAfter.find(p => p.uuid === params.uuid)
    if (isNumber) {
      return before && after && before[fields] !== Number(after[fields])
    } else {
      return before && after && before[fields] !== after[fields]
    }
  }

  // 更改费用申请状态
  static changeChargeStateLabFunBpm(value) {
    const state = CommonState.getStateByCode(ChangeChargeConstant.CHANGE_CHARGE_STATES_BPM, value)
    if (state) {
      if ($store.getters.language === 'zh') {
        return state.chineseName || ''
      } else {
        return state.englishName || ''
      }
    }
    return ''
  }

  /**
   * 自定义字段 选择
   */
  static resolveCustomField(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CUSTOM_FIELDS)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订舱代理级别 选择
   */
  static resolveBookingAgentLevel(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BOOKING_AGENT_LEVEL)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static resolveCarrierType(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CARRIER_TYPE)
    return !state ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 业务类型（合同规则）
   */
  static jobBussStateLabelContractRuleFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CONTRACT_RULE_VALUES_LOBS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  // 账期【从 SYS_CREDIT_INFO_STATISTIC 查询】
  static AccountPeriodCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        if (creditInfo.creditDateLimited >= 0) {
          switch (creditInfo.termUnit) {
            case 0:
              text = text + creditInfo.creditDateLimited + lang.t('Partners.day')
              break
            case 1:
              text = text + creditInfo.creditDateLimited + lang.t('Partners.week')
              break
            case 2:
              text = text + creditInfo.creditDateLimited + lang.t('Partners.month')
              break
          }
        }
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 信控日期类型（业务维度）【从 SYS_CREDIT_INFO_STATISTIC 查询】
  static creditDateTypeCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        if (typeof creditInfo.creditDateType === 'number') {
          switch (creditInfo.creditDateType) {
            case -1:
              text = text + lang.t('Partners.monthlySettlement')
              break
            case -2:
              text = text + lang.t('CargoMsg.Cargo_SettleByWeekly')
              break
            case -3:
              text = text + lang.t('Partners.space5')
              break
            case -4:
              text = text + lang.t('Partners.dailySettlement')
              break
            default:
              text = text + lang.t('CargoMsg.Cargo_FixedDateMonthly')
              break
          }
        }
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 结算类型 （发票、账单 需要进行去重，已和产品确认）
  static settlementTypeCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    if (data.creditInfos && data.creditInfos.length > 0) {
      const settlementTypeSet = new Set()
      data.creditInfos.forEach(creditInfo => {
        if (creditInfo['creditDateLimited'] === 0 && [CREDITDATETYPE_MONTH2.code, CREDITDATETYPE_MONTH.code, CREDITDATETYPE_WEEK.code, CREDITDATETYPE_HALFMONTH.code, CREDITDATETYPE_DAY2.code].indexOf(creditInfo['creditDateType']) !== -1) {
          if (!settlementTypeSet.has(i18n.t('Message.ByTicket'))) {
            settlementTypeSet.add(i18n.t('Message.ByTicket'))
          }
        } else {
          if (!settlementTypeSet.has(i18n.t('Partners.settlementNotByBill'))) {
            settlementTypeSet.add(i18n.t('Partners.settlementNotByBill'))
          }
        }
      })
      const list = Array.from(settlementTypeSet).sort((a, b) => a - b)
      return list.join('/')
    }
    return ''
  }
  // 额度
  static creditCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        text = text + `${creditInfo.credit}${creditInfo.currency}`
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 使用额度
  static creditUsedCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        text = text + ColumnUtils.number2ColumnLabelFunc(creditInfo.usedAmount)
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 超期
  static dateExceededCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        text = text + ColumnUtils.booleanLabelFunction(creditInfo.dateExceeded)
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 超额
  static amountExceededCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        text = text + ColumnUtils.booleanLabelFunction(creditInfo.amountExceeded)
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return ''
  }
  // 收付日期
  static incomePayDateCommonLabelFunc(data) {
    if (!data) {
      return ''
    }
    let text = ''
    if (data.creditInfos && data.creditInfos.length > 0) {
      data.creditInfos.forEach(creditInfo => {
        text = text + ColumnUtils.dateLabelFunc(creditInfo.incomePayDate)
        text = text + '/'
      })
      return text.slice(0, -1)
    }
    return data.paymentTerm ? ColumnUtils.dateLabelFunc(data.paymentTerm) : data.paymentTerm
  }

  // 结算类型（合作伙伴、信控业务管理 不进行去重，已和产品确认）
  static settlementTypeLabFun(company) {
    const settlementTypes = []
    company.contractList.forEach(contract => {
      if (contract['creditDateLimited'] === 0 && [CREDITDATETYPE_MONTH2.code, CREDITDATETYPE_MONTH.code, CREDITDATETYPE_WEEK.code, CREDITDATETYPE_HALFMONTH.code, CREDITDATETYPE_DAY2.code].indexOf(contract['creditDateType']) !== -1) {
        settlementTypes.push(i18n.t('Message.ByTicket'))
      } else {
        settlementTypes.push(i18n.t('Partners.settlementNotByBill'))
      }
    })
    const list = Array.from(settlementTypes)
    return list.join('/')
  }

  /**
   * 名单同步状态(中邮)
   */
  static AdvancePaymentStateLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ADVANCEPAYMENT_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 余额变动类型(中邮)
   */
  static AdvancePaymentChangeTypeLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ADVANCEPAYMENT_CHANGETYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 客户结算方式(中邮)
   */
  static AdvancePaymentCustSettlementLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ADVANCEPAYMENT_CUSTSETTLEMENTS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 业务类型(中邮)
   */
  static AdvancePaymentOrderTypeLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ADVANCEPAYMENT_ORDERTYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 中邮-全程/国内
  static fullOrInsideLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.FULL_OR_INSIDE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 太平-拓客方式
  static CustomerExpandModesLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CUSTOMER_EXPAND_MODES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 业务模式
   */
  static containerLoadTypeLabelFunctionForAllBusiness(data, column) {
    const fieldName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    // console.log('containerLoadTypeLabelFunction data[column]', data[column])
    if (Object.prototype.hasOwnProperty.call(data, column)) {
      if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'SI') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'SI')) {
        const state = CommonState.getStateByCode(ImportConstants._cargoTypeInputList, data[column])
        return !state ? '' : state[fieldName]
      } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'IE') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'IE') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'IE')) {
        const state = CommonState.getStateByCode(ContainerLoadType.IE_TYPES, data[column])
        return !state ? '' : state[fieldName]
      } else if ((Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'AE') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'AE') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'AE') ||
          (Object.prototype.hasOwnProperty.call(data, 'lob') && data['lob'] === 'AI') || (Object.prototype.hasOwnProperty.call(data, 'LOB') && data['LOB'] === 'AI') || (Object.prototype.hasOwnProperty.call(data, 'jobLob') && data['jobLob'] === 'AI')) {
        const state = CommonState.getStateByCode(AirExportConstants.BUSINESS_MODELS, Number(data[column]))
        return !state ? '' : state[fieldName]
      } else {
        const loadType = ContainerLoadType.getContainerLoadTypeByCode(data[column])
        return !loadType ? '' : loadType[fieldName]
      }
    }
    return ''
  }

  // 抄录提单补充信息
  static euBolInfoFormat(data, field) {
    let result = ''
    if (field === 'shipper') {
      result += lang.t('SeaExport.PostalInformation') + ': ' + data.shipperPostalInfo + '\n'
      result += lang.t('SeaExport.ShipperStreetNumber') + ': ' + data.shipperStreetNo + '\n'
      result += lang.t('SeaExport.ShipperStreetName') + ': ' + data.shipperStreetName + '\n'
      result += lang.t('SeaExport.EORICode') + ': ' + data.shipperIdNumber + '\n'
      result += lang.t('SeaExport.ShipperZipCode') + ': ' + data.shipperPostalCode + '\n'
    } else if (field === 'consignee') {
      result += lang.t('SeaExport.PostalInformation') + ': ' + data.consigneePostalInfo + '\n'
      result += lang.t('SeaExport.ConsigneeStreetNumber') + ': ' + data.consigneeStreetNo + '\n'
      result += lang.t('SeaExport.ConsigneeStreetName') + ': ' + data.consigneeStreetName + '\n'
      result += lang.t('SeaExport.EORICode') + ': ' + data.consigneeId + '\n'
      result += lang.t('SeaExport.ConsigneeZipCode') + ': ' + data.consigneePostalCode + '\n'
    } else if (field === 'notify') {
      result += lang.t('SeaExport.PostalInformation') + ': ' + data.notifyPostalInfo + '\n'
      result += lang.t('SeaExport.NotifyStreetNumber') + ': ' + data.notifyStreetNo + '\n'
      result += lang.t('SeaExport.NotifyStreetName') + ': ' + data.notifyStreetName + '\n'
      result += lang.t('SeaExport.EORICode') + ': ' + data.notifyCodeForManifest + '\n'
      result += lang.t('SeaExport.notifyingPhone') + ': ' + data.notifyPhone + '\n'
      result += lang.t('SeaExport.NotifyZipCode') + ': ' + data.notifyPostalCode + '\n'
    } else if (field === 'actualShipper') {
      result += lang.t('SeaExport.ShipperName') + ': ' + data.actualShipperName + '\n'
      result += lang.t('SeaExport.ShipperAddress') + ': ' + data.actualShipperAddress + '\n'
      result += lang.t('SeaExport.PostalInformation') + ': ' + data.actualShipperPostalInfo + '\n'
      result += lang.t('SeaExport.ShipperStreetNumber') + ': ' + data.actualShipperStreetNo + '\n'
      result += lang.t('SeaExport.ShipperStreetName') + ': ' + data.actualShipperStreetName + '\n'
      result += lang.t('SeaExport.EORICode') + ': ' + data.actualShipperCodeForManifest + '\n'
      result += lang.t('SeaExport.ShipperZipCode') + ': ' + data.actualShipperPostalCode + '\n'
    } else if (field === 'actualConsignee') {
      result += lang.t('SeaExport.ConsigneeName') + ': ' + data.actualConsigneeName + '\n'
      result += lang.t('SeaExport.ConsigneeAddress') + ': ' + data.actualConsigneeAddress + '\n'
      result += lang.t('SeaExport.PostalInformation') + ': ' + data.actualConsigneePostalInfo + '\n'
      result += lang.t('SeaExport.ConsigneeStreetNumber') + ': ' + data.actualConsigneeStreetNo + '\n'
      result += lang.t('SeaExport.ConsigneeStreetName') + ': ' + data.actualConsigneeStreetName + '\n'
      result += lang.t('SeaExport.EORICode') + ': ' + data.actualConsigneeIdNumber + '\n'
      result += lang.t('SeaExport.ConsigneeZipCode') + ': ' + data.actualConsigneeCodeForManifest + '\n'
    }
    return result
  }
  /**
   * ocr模板状态
   */
  static ocrTemplateStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OCR_TEMPLATE_STATUS)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * ocr模板调用状态
   */
  static ocrTemplateCallStatusLabelFunc(value) {
    const state = ClearingConstants.getCommonState(value, SystemConstants.OCR_TEMPLATE_CALL_STATUS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * ocr 企业 调用状态
   */
  static ocrEnterpriseStatusWithDateLabelFunc(value) {
    const state = ClearingConstants.getCommonState(value, SystemConstants.OCR_ENTERPRISE_STATUS_WITH_DATE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static shipperToSellerMap = new Map([
    ['shipperLine1', 'sellerName'],
    ['shipperLine3', 'sellerAddress1'],
    ['shipperLine4', 'sellerAddress2'],
    ['shipperStreetNo', 'sellerStreetNo'],
    ['shipperCountry', 'sellerCountry'],
    ['shipperCity', 'sellerCity'],
    ['shipperPostalcode', 'sellerPostalcode'],
    ['shipperProvince', 'sellerProvince'],
    ['shipperEmail', 'sellerEmail'],
    ['shipperTel', 'sellerTel'],
    ['shipperContactName', 'sellerContactName'],
    ['shipperTypeOfPerson', 'sellerTypeOfPerson'],
    ['shipperEori', 'sellerEori']
  ])

  static consigneeToBuyerMap = new Map([
    ['consigneeLine1', 'buyerName'],
    ['consigneeLine3', 'buyerAddress1'],
    ['consigneeLine4', 'buyerAddress2'],
    ['consigneeStreetNo', 'buyerStreetNo'],
    ['consigneeCountry', 'buyerCountry'],
    ['consigneeCity', 'buyerCity'],
    ['consigneePostalcode', 'buyerPostalcode'],
    ['consigneeProvince', 'buyerProvince'],
    ['consigneeEmail', 'buyerEmail'],
    ['consigneeTel', 'buyerTel'],
    ['consigneeContactName', 'buyerContactName'],
    ['consigneeTypeOfPerson', 'buyerTypeOfPerson'],
    ['consigneeEori', 'buyerEori']
  ])

  static afrLabelFunc(value) {
    return ColumnUtils.afrMap.get(value) || value
  }
  static aciLabelFunc(value) {
    return ColumnUtils.aciMap.get(value) || value
  }
  static ensAiLabelFunc(value) {
    return ColumnUtils.ensAiMap.get(value) || value
  }
  static amsAiLabelFunc(value) {
    return ColumnUtils.amsAiMap.get(value) || value
  }
  static afrAiLabelFunc(value) {
    return ColumnUtils.afrAiMap.get(value) || value
  }
  static aciMap = new Map([
    ['Import', '直达加拿大'],
    ['Foreign cargo remaining on-board', '货物途径加拿大']
  ])

  static ensAiMap = new Map([
    ['ENS No', '分单号'],
    ['MRN No', 'MRN编号'],
    ['Transmit Status', '发送状态'],
    ['Customs Status', '海关状态'],
    ['Filing Type', '报文类型'],
    ['Carrier', '船公司'],
    ['Declarant', '申报人'],
    ['Memberstate', '第一欧盟入境国'],
    ['Declare Type', '运输类型'],
    ['MB/L NO', 'MBL主单号'],
    ['Payment Method', '付款方式'],
    ['Place of Loading', '起运港'],
    ['Place of Discharge', '目的港'],
    ['Shipper', '真实发货人'],
    ['name', '抬头'],
    ['Address1', '地址1'],
    ['Address2', '地址2'],
    ['No.', '门牌号'],
    ['ZIP', '邮编'],
    ['City', '城市'],
    ['Country', '国家'],
    ['Tel', '电话'],
    ['E-mail', '邮箱'],
    ['Type', '类型'],
    ['Consignee', '真实收货人'],
    ['Seller', '真实卖家'],
    ['Buyer', '真实买家'],
    ['No', '序号'],
    ['Container No', '箱号'],
    ['Container Size', '箱型'],
    ['Container Type', '箱种'],
    ['Linked cargo', '关联品名'],
    ['Container owner', '箱属'],
    ['HSCODE', 'HSCODE'],
    ['Linked Container', '关联箱号'],
    ['Quantity', '件数'],
    ['unit type', '包装单位'],
    ['Gross weight', '毛重'],
    ['Marks', '唛头'],
    ['Description', '品名'],
    ['UN CODE', 'UN CODE'],
    ['CUS No', 'CUS No'],
    ['SupplementaryDeclarantEORI', '补充申报人EORI'],
    ['SupplementaryDeclarantType', '下层申报类型'],
    ['Customer Information', '客户信息'],
    ['Real Shipper', '真实发货人'],
    ['Title', '抬头'],
    ['Name', '名称'],
    ['Address', '地址'],
    ['House Number', '门牌号'],
    ['State', '省份'],
    ['Zip', '邮编'],
    ['Fax', '传真'],
    ['Real Consignee', '真实收货人'],
    ['Notify Party', '通知人名称'],
    ['Cargo Information', '货物信息'],
    ['Unit Type', '包装'],
    ['Packing Unit', '包装单位'],
    ['Net Weight', '净重'],
    ['Volume', '体积'],
    ['County of Origin', '原产国'],
    ['Place of Receipt', '提单发货地'],
    ['Cargo Type', '货物类型'],
    ['Dangerous Cargo Code', '危险品代码'],
    ['IMDG Class', '危险品等级'],
    ['Commodity Decription', '英文品名'],
    ['Shipping Information', '运输信息'],
    ['Synchronise Booking', '同步订舱信息'],
    ['Vessel', '船名'],
    ['Vessel Code', '船名代码'],
    ['Voyage', '航次'],
    ['Vessel country flag', '船国籍'],
    ['Call Sign', '船舶呼号'],
    ['Place of Loading', '提单起运港'],
    ['Port of Loading', '起运港'],
    ['Place of Discharge', '提单卸货港'],
    ['Other', '其他信息'],
    ['Add', '新增'],
    ['Add Description', '增加品名'],
    ['Query HS Code', '查询HS Code'],
    ['Query CUS No', '查询CUS No'],
    ['Correlative Container No', '关联箱号'],
    ['Import Container No', '导入箱号'],
    ['Add Container No', '增加箱号'],
    ['Ai Recognition', 'Ai识别'],
    ['Synchronise HB/L', '同步HB/L信息'],
    ['Import HB/L', '导入HBL'],
    ['Add HB/L', '增加分单'],
    ['Nvocc SCAC', '无船承运人SCAC'],
    ['Carrier SCAC', '船公司SCAC'],
    ['Sender Account', '发送账号'],
    ['House Container Information', '装箱信息'],
    ['Goods', '品名'],
    ['HS CODE', 'HS 编号'],
    ['Seal No', '封号'],
    ['Container Code', '箱编码'],
    ['Container Height', '箱高度'],
    ['Job No', '业务编号'],
    ['Send Status', '发送状态'],
    ['Receipt', '查看回执'],
    ['Last', '最后一票'],
    ['Import only', '导入不发送'],
    ['Send', '发送'],
    ['Error', '错误信息'],
    ['Template Download', '下载模板'],
    ['Import Template', '导入Excel'],
    ['Query Status', '查看状态'],
    ['Remark (max 300 letters)', '备注（最大300）'],
    ['Destination Agent', '目的港代理'],
    ['Declare Type', '申报类型'],
    ['Transport Type', '运输类型'],
    ['Import', '直达美国'],
    ['Foreign cargo remaining on-board', '货物途径美国'],
    ['Consignment Type', '整拼类型'],
    ['ETA', '到港时间'],
    ['Port Of Destination', '目的港'],
    ['First Port of Call', '第一个停靠港'],
    ['ETA First Port Of Call', '第一个停靠港停靠日期'],
    ['Remark', '备注'],
    ['Send State', '发送状态'],
    ['Send State Update Time', '发送状态更新时间'],
    ['Receipt Status', '回执状态'],
    ['Customs Status Update Time', '海关状态更新时间'],
    ['Cancellation status', '取消状态'],
    ['AFR NO', 'AFR号码'],
    ['ACI NO', 'ACI号码'],
    ['HB/L NO', 'HB/L 号码'],
    ['ETD', '开航日期'],
    ['ETA', '到港日期'],
    ['Shipment Type', '运输类型'],
    ['B/L Type', '提单类型'],
    ['Last Foreign Port', '最后一个境外港口'],
    ['Hts Code', '海关编码'],
    ['Customer Delivery Info', '客户发运信息'],
    ['Real Seller', '真实卖家'],
    ['Buyer', '买方'],
    ['Real Buyer', '真实买家'],
    ['Manufacturer', '制作商'],
    ['Container Stuffing Location', '集装箱装箱地点'],
    ['Consolidator', '拼箱人'],
    ['Container Ship to', '集装箱船运至'],
    ['Packing Point', '装箱点'],
    ['Importer', '进口商'],
    ['Code', '代码'],
    ['ID Type', '证件类型'],
    ['ID Number', '证件号码'],
    ['County Of Origin', '原产国'],
    ['Area Code', '区号'],
    ['POD', '提单卸货港'],
    ['Booking party', '订舱人'],
    ['Container ShipTo Party', '集装箱船运至收货人'],
    ['Second Notify Party', '第二通知人名称'],
    ['Customer Type', '客户类型'],
    ['HTS CODE', 'HTS 号码'],
    ['Description of Goods', '货物描述'],
    ['Solution', '建议方案'],
    ['Time', '时间'],
    ['Copy Last Time', '复制上一票'],
    ['Copy By File NO', '按提单号复制'],
    ['Operation Requirement', '操作要求'],
    ['Place Of Delivery', '提单交货地'],
    ['paperless_in_bond_participant', '无纸化保税参与者'],
    ['General Cargo', '普通货物'],
    ['Dangerous Cargo', '危险品'],
    ['Hazardous code', '危险品代码'],
    ['Flashpoint', '闪点'],
    ['DestinationCountry', '目的地国家'],
    ['DestinationCity', '目的地城市'],
    ['Deliv.Mode', '运输条款'],
    ['Disch Sub Loc', '卸货子位置（仓库、堆场）'],
    ['Dest Sub Loc', '目的地子位置（城市、港口）'],
    ['Contact Name', '联系人'],
    ['ENS Declaration Type', 'ENS申报类型'],
    ['Message Type', '报文类型'],
    ['Carrier EORI', '船公司EORI'],
    ['Carrier Company', '船公司'],
    ['ENS Declaration Information', 'ENS申报信息'],
    ['Related Information', '关联方信息'],
    ['Port Information', '港口信息'],
    ['Declarant EORI', '申报人EORI'],
    ['Declarant', '申报人'],
    ['Substratum Declarant', '下层申报人'],
    ['First EU country of entry', '第一欧盟入境国'],
    ['Buyer and Seller Information', '买方和卖方信息'],
    ['Type Of Person', '人员类型'],
    ['Type', '类型'],
    ['EORI', 'EORI代码'],
    ['ADDRESS EORI', 'EORI'],
    ['IMO', 'IMO'],
    ['RouteCountry', '途径国家'],
    ['ColoadInSelfFilingIndicator', '下层是否自申报'],
    ['SupplementaryDeclarant', '补充申报公司名称'],
    ['SupplementaryDeclarant eori', '下层申报人EORI'],
    ['Eori', '补充申报公司EORI'],
    ['BlType', '提单类型'],
    ['SupplementaryDeclarant Type', '下层申报类型'],
    ['Street No', '街道'],
    ['Charges Payment Method', '费用支付方式'],
    ['Notify', '通知人'],
    ['CUS Code', 'CUS 代码'],
    ['Representative type', '代表人类型'],
    ['Send Success', '发送海关成功'],
    ['Rejected', '发送海关失败'],
    ['Status Notification', '通知状态'],
    ['Correlative No', '序号'],
    ['Linked Cargo Information No', '关联货物信息序号'],
    ['Linked Cargo Goods', '关联品名'],
    ['Representative', '代表人'],
    ['NATURAL', '自然人'],
    ['LEGAL', '法人'],
    ['Coload In Self Filing Indicator', '下家同行是否自行申报'],
    ['ASSOCIATION', '个人协会']

  ])

  static afrMap = new Map([
    ['HblInfo', '分单信息'],
    ['Hbl No', '分单号'],
    ['MRN No', 'MRN编号'],
    ['Customer Information', '客户信息'],
    ['Shipper', '发货人'],
    ['Real Shipper', '真实发货人'],
    ['Title', '抬头'],
    ['Name', '名称'],
    ['Address', '地址'],
    ['House Number', '门牌号'],
    ['Country', '国家'],
    ['State', '省份'],
    ['City', '城市'],
    ['Zip', '邮编'],
    ['Fax', '传真'],
    ['Tel', '电话'],
    ['Consignee', '收货人'],
    ['Real Consignee', '真实收货人'],
    ['Notify Party', '通知人名称'],
    ['Cargo Information', '货物信息'],
    ['Quantity', '件数'],
    ['Unit Type', '包装'],
    ['Packing Unit', '包装单位'],
    ['Gross Weight', '毛重'],
    ['Net Weight', '净重'],
    ['Volume', '体积'],
    ['County of Origin', '原产国'],
    ['Place of Receipt', '提单发货地'],
    ['Cargo Type', '货物类型'],
    ['Dangerous Cargo Code', '危险品代码'],
    ['IMDG Class', '危险品等级'],
    ['Commodity Decription', '英文品名'],
    ['Marks', '唛头'],
    ['Shipping Information', '运输信息'],
    ['Synchronise Booking', '同步订舱信息'],
    ['Vessel', '船名'],
    ['Vessel Code', '船名代码'],
    ['Voyage', '航次'],
    ['Vessel country flag', '船国籍'],
    ['Call Sign', '船舶呼号'],
    ['Place of Loading', '提单起运港'],
    ['Port of Loading', '起运港'],
    ['Place of Discharge', '提单卸货港'],
    ['Other', '其他信息'],
    ['Add', '新增'],
    ['Add Description', '增加品名'],
    ['Query HS Code', '查询HS Code'],
    ['Query CUS No', '查询CUS No'],
    ['Correlative Container No', '关联箱号'],
    ['Import Container No', '导入箱号'],
    ['Add Container No', '增加箱号'],
    ['Ai Recognition', 'Ai识别'],
    ['Synchronise HB/L', '同步HB/L信息'],
    ['Import HB/L', '导入HBL'],
    ['Add HB/L', '增加分单'],
    ['MB/L Number', 'MBL主单号'],
    ['Delete', '删除'],
    ['Nvocc SCAC', '无船承运人SCAC'],
    ['Carrier SCAC', '船公司SCAC'],
    ['Sender Account', '发送账号'],
    ['House Container Information', '装箱信息'],
    ['Container Size', '箱型'],
    ['Container No', '箱号'],
    ['Goods', '品名'],
    ['HS CODE', 'HS 编号'],
    ['Seal No', '封号'],
    ['Container Owner', '箱所属'],
    ['Container Code', '箱编码'],
    ['Container Type', '箱种'],
    ['Container Height', '箱高度'],
    ['Job No', '业务编号'],
    ['Send Status', '发送状态'],
    ['Receipt', '查看回执'],
    ['Last', '最后一票'],
    ['Import only', '导入不发送'],
    ['Send', '发送'],
    ['Error', '错误信息'],
    ['Template Download', '下载模板'],
    ['Import Template', '导入Excel'],
    ['Query Status', '查看状态'],
    ['Call Sign', '船舶呼号'],
    ['Remark (max 300 letters)', '备注（最大300）'],
    ['Destination Agent', '目的港代理'],
    ['Declare Type', '申报类型'],
    ['Transport Type', '运输类型'],
    ['Import', '直达美国'],
    ['Foreign cargo remaining on-board', '货物途径美国'],
    ['Consignment Type', '整拼类型'],
    ['ETA', '到港时间'],
    ['Place of Discharge', '提单卸货港'],
    ['Port Of Destination', '目的港'],
    ['First Port of Call', '第一个停靠港'],
    ['ETA First Port Of Call', '第一个停靠港停靠日期'],
    ['Remark', '备注'],
    ['Send State', '发送状态'],
    ['Send State Update Time', '发送状态更新时间'],
    ['Receipt Status', '回执状态'],
    ['Customs Status', '海关状态'],
    ['Customs Status Update Time', '海关状态更新时间'],
    ['Cancellation status', '取消状态'],
    ['AFR NO', 'AFR号码'],
    ['ACI NO', 'ACI号码'],
    ['HB/L NO', 'HB/L 号码'],
    ['ETD', '开航日期'],
    ['ETA', '到港日期'],
    ['Shipment Type', '运输类型'],
    ['B/L Type', '提单类型'],
    ['Last Foreign Port', '最后一个境外港口'],
    ['Hts Code', '海关编码'],
    ['Customer Delivery Info', '客户发运信息'],
    ['Seller', '卖方'],
    ['Real Seller', '真实卖家'],
    ['Buyer', '买方'],
    ['Manufacturer', '制作商'],
    ['Container Stuffing Location', '集装箱装箱地点'],
    ['Consolidator', '拼箱人'],
    ['Container Ship to', '集装箱船运至'],
    ['Packing Point', '装箱点'],
    ['Importer', '进口商'],
    ['Code', '代码'],
    ['Name', '名称'],
    ['ID Type', '证件类型'],
    ['ID Number', '证件号码'],
    ['County Of Origin', '原产国'],
    ['Area Code', '区号'],
    ['POD', '提单卸货港'],
    ['Booking party', '订舱人'],
    ['Container ShipTo Party', '集装箱船运至收货人'],
    ['Second Notify Party', '第二通知人名称'],
    ['Customer Type', '客户类型'],
    ['HTS CODE', 'HTS 号码'],
    ['Description of Goods', '货物描述'],
    ['Solution', '建议方案'],
    ['Description', '品名'],
    ['Time', '时间'],
    ['Copy Last Time', '复制上一票'],
    ['Copy By File NO', '按提单号复制'],
    ['AI Recognition', 'AI识别'],
    ['Operation Requirement', '操作要求'],
    ['Place Of Delivery', '提单交货地'],
    ['paperless_in_bond_participant', '无纸化保税参与者'],
    ['General Cargo', '普通货物'],
    ['Dangerous Cargo', '危险品'],
    ['Chemical Cargo', '化工品'],
    ['Hazardous code', '危险品代码'],
    ['Flashpoint', '闪点'],
    ['DestinationCountry', '目的地国家'],
    ['DestinationCity', '目的地城市'],
    ['Sender Account', '申报账户'],
    ['Deliv.Mode', '运输条款'],
    ['Disch Sub Loc', '卸货子位置（仓库、堆场）'],
    ['Dest Sub Loc', '目的地子位置（城市、港口）'],
    ['Cargo Information', '货物信息'],
    ['Contact Name', '联系人'],
    ['ENS Declaration Type', 'ENS申报类型'],
    ['Message Type', '报文类型'],
    ['Carrier EORI', '船公司EORI'],
    ['Carrier Company', '船公司'],
    ['ENS Declaration Information', 'ENS申报信息'],
    ['Related Information', '关联方信息'],
    ['Port Information', '港口信息'],
    ['Declarant EORI', '申报人EORI'],
    ['Declarant', '申报人'],
    ['Substratum Declarant', '下层申报人'],
    ['Memberstate', '进入欧盟的第一个国家'],
    ['First EU country of entry', '第一欧盟入境国'],
    ['Seller', '卖方'],
    ['Buyer', '买方'],
    ['Real Buyer', '真实买家'],
    ['Email', '邮箱'],
    ['Type Of Person', '人员类型'],
    ['Type', '类型'],
    ['EORI', 'EORI代码'],
    ['ADDRESS EORI', 'EORI'],
    ['IMO', 'IMO'],
    ['RouteCountry', '途径国家'],
    ['ColoadInSelfFilingIndicator', '下层是否自申报'],
    ['SupplementaryDeclarant', '补充申报公司名称'],
    ['SupplementaryDeclarant eori', '下层申报人EORI'],
    ['Eori', '补充申报公司EORI'],
    ['BlType', '提单类型'],
    ['SupplementaryDeclarant Type', '下层申报类型'],
    ['Street No', '街道'],
    ['HS CODE', 'HS 编码'],
    ['Commodity Decription', '品名'],
    ['UN Danger Code', '危险品代码'],
    ['Charges Payment Method', '费用支付方式'],
    ['Payment Method', '付款方式'],
    ['Buyer and Seller Information', '买方和卖方信息'],
    ['ZIP', '邮编'],
    ['Notify', '通知人'],
    ['CUS Code', 'CUS 代码'],
    ['Representative type', '代表人类型'],
    ['Send Success', '发送海关成功'],
    ['Rejected', '发送海关失败'],
    ['Status Notification', '通知状态'],
    ['Correlative No', '序号'],
    ['Linked Cargo Information No', '关联货物信息序号'],
    ['Linked Cargo Goods', '关联品名'],
    ['Address1', '地址1'],
    ['Address2', '地址2'],
    ['Representative', '代表人'],
    ['Carrier', '承运人'],
    ['NATURAL', '自然人'],
    ['LEGAL', '法人'],
    ['Coload In Self Filing Indicator', '下家同行是否自行申报'],
    ['ASSOCIATION', '个人协会']
  ])

  static amsAiMap = new Map([
    ['HblInfo', '分单信息'],
    ['Sending and receiving messages', '收发通信息'],
    ['HB/L NO', '分单号'],
    ['Transmit Status', '发送状态'],
    ['Customs Status', '海关状态'],
    ['Carrier', '船公司'],
    ['MB/L NO', 'MBL主单号'],
    ['Place of Loading', '起运港'],
    ['Place of Discharge', '目的港'],
    ['Shipper', '发货人信息'],
    ['name', '抬头'],
    ['Address1', '地址1'],
    ['Address2', '地址2'],
    ['ZIP', '邮编'],
    ['City', '城市'],
    ['Country', '国家'],
    ['Consignee', '收货人信息'],
    ['No', '序号'],
    ['Container No', '箱号'],
    ['Quantity', '件数'],
    ['Gross Weight', '毛重'],
    ['Marks', '唛头'],
    ['State', '州/省'],
    ['Unit Type', '包装'],
    ['Volume', '体积'],
    ['VesselFlag', '船籍'],
    ['Port Information', '港口信息'],
    ['Import Container No', '导入箱号'],
    ['Add Container No', '增加箱号'],
    ['Ai Recognition', 'Ai识别'],
    ['Import HB/L', '导入HBL'],
    ['Add HB/L', '增加分单'],
    ['SCAC CODE', '无船承运人SCAC'],
    ['House Container Information', '装箱信息'],
    ['Description', '品名'],
    ['Declare Type', '运输类型'],
    ['Shippment Type', '装运类型'],
    ['First Port of Call', '抵美第一港口'],
    ['Last Foreign Port', '抵美前最后港口'],
    ['Copy Last Time', '复制上一票'],
    ['Copy By File NO', '按提单号复制'],
    ['Operation Requirement', '操作要求'],
    ['UN CODE', '危险品代码'],
    ['Delete', '删除'],
    ['Shippment Type', '装运类型'],
    ['Hazardous code', '危险品代码']
  ])

  static afrAiMap = new Map([
    ['HblInfo', '分单信息'],
    ['Sending and receiving messages', '收发通信息'],
    ['HB/L NO', '分单号'],
    ['Transmit Status', '发送状态'],
    ['Customs Status', '海关状态'],
    ['Carrier', '船公司'],
    ['MB/L NO', 'MBL主单号'],
    ['Place of Loading', '起运港'],
    ['Place of Receipt', '发货地'],
    ['Place of Discharge', '卸货地'],
    ['Place of Delivery', '交货地'],
    ['Shipper', '发货人信息'],
    ['Consignee', '收货人信息'],
    ['Notify', '通知人信息'],
    ['name', '抬头'],
    ['Address1', '地址1'],
    ['Address2', '地址2'],
    ['ZIP', '邮编'],
    ['Tel', '电话'],
    ['Country', '国家'],
    ['No', '序号'],
    ['Container No', '箱号'],
    ['Quantity', '件数'],
    ['Gross Weight', '毛重'],
    ['Marks', '唛头'],
    ['Unit Type', '包装'],
    ['Volume', '体积'],
    ['VesselFlag', '船籍'],
    ['Port Information', '港口信息'],
    ['Import Container No', '导入箱号'],
    ['Cargo Information', '货物信息'],
    ['Add Container No', '增加箱号'],
    ['Ai Recognition', 'Ai识别'],
    ['VesselCallSign', '船舶呼号'],
    ['Issue Departure Notice', '发送离港通知'],
    ['Import HB/L', '导入HBL'],
    ['Add HB/L', '增加分单'],
    ['SCAC CODE', '无船承运人Code'],
    ['House Container Information', '装箱信息'],
    ['Description', '品名'],
    ['Declare Type', '运输类型'],
    ['Shippment Type', '装运类型'],
    ['Danger Class', '危险品分类'],
    ['SPC CODE', '特殊货物编码'],
    ['Copy Last Time', '复制上一票'],
    ['Copy By File NO', '按提单号复制'],
    ['Operation Requirement', '操作要求'],
    ['UN CODE', '危险品代码'],
    ['Delete', '删除'],
    ['Sent', '已发送'],
    ['Not sent', '未发送'],
    ['Container Size', '箱型'],
    ['Container Type', '箱种'],
    ['Seal No', '封号'],
    ['Container owner', '箱属'],
    ['Add Description', '增加品名'],
    ['Copy to the notifier', '复制到通知人'],
    ['UN CODE', '危险品代码']
  ])

  static airLineLabelFunction(data, field) {
    if (data && data[field]) {
      let lob = ''
      if (data.hasOwnProperty('lob') && data.lob) {
        lob = data.lob
      } else if (data.hasOwnProperty('LOB') && data.LOB) {
        lob = data.LOB
      }
      if (lob) {
        if ([SystemConstants.RE.code, SystemConstants.RI.code].includes(lob)) {
          const railwayLine = getObjectByCache(basicCacheKeys.basic_data_RailwayLine, 'code', data[field])
          if (railwayLine) {
            return $store.getters.language === 'zh' ? railwayLine.name : railwayLine.nameEnglish
          }
        } else {
          const region = getObjectByCache(basicCacheKeys.basic_data_Region, 'code', data[field])
          if (region) {
            return $store.getters.language === 'zh' ? region.name : region.nameEnglish
          }
        }
      } else {
        return data[field]
      }
    }
    return ''
  }

  // 去wht金额
  static notWhtAmountLabel(charge) {
    if (charge) {
      const localAmount = charge.localAmount
      const whtTaxLocalAmount = charge.whtTaxLocalAmount
      const notWhtAmount = Number(localAmount) - Number(whtTaxLocalAmount)
      return NumberUtils.ToFixed2(notWhtAmount, 2)
    }
    return 0
  }

  /**
   * 智能托书邮箱接收类型
   */
  static emailPurposeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.EMAIL_PARSING_TYPE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订舱状态 label
   * @param data
   */
  static jobBookingState(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.JOB_BOOKING_STATES_NEW)
    if (!state) return ''
    return $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订舱状态 label 合并状态
   *
   * 调用异常 模版匹配失败 校验错误 统一为 发送订舱失败
   * @param data
   */
  static jobBookingStateNew(value) {
    if ([JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code].includes(Number(value))) {
      return ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_FAIL.code)
    }
    return ColumnUtils.jobBookingState(value)
  }

  /**
   * 托书-订舱状态 label
   * @param data
   */
  static multiJobBookingState(data) {
    const labels = []
    if (data.intelligentDocumentItems && data.intelligentDocumentItems.length > 0) {
      data.intelligentDocumentItems.forEach(item => {
        labels.push(this.jobBookingStateNew(item.bookingState))
      })
    }
    const list = Array.from(labels)
    return list.join('/')
  }

  /**
   * 托书-订舱状态 label
   * @param data
   */
  static multiJobNo(data) {
    const labels = []
    if (data.intelligentDocumentItems && data.intelligentDocumentItems.length > 0) {
      data.intelligentDocumentItems.forEach(item => {
        labels.push(item.jobNo)
      })
    } else if (data.jobNo) {
      labels.push(data.jobNo)
    }
    const list = Array.from(labels)
    return list.join(';')
  }
  /**
   * 操作分公司
   */
  static branchIdsLabelFunction(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject) {
    const label = []
    const branchIdList = commonUtil.split(sourceValue, ',', true)
    for (const branchId of branchIdList) {
      const str = ColumnUtils.resolveColumnLabel(cacheKey, sourceField, branchId, targetField, isNeedObject)
      if (label.indexOf(str) === -1) {
        label.push(str)
      }
    }
    return label.length > 0 ? label.join(',') : ''
  }
  // 分摊性质
  static allocationNatureFunc(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.ALLOCATION_NATURES)
    return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 自定义业务类型
   */
  static customJobTypeLabelFunction(data, column) {
    const customJobTypes = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType)
    const fieldName = $store.getters.language === 'zh' ? 'name' : 'englishName'
    const label = []
    if (Object.prototype.hasOwnProperty.call(data, column)) {
      const customJobType = Object.prototype.hasOwnProperty.call(data, column) ? data[column].split(',') : []
      const lob = Object.prototype.hasOwnProperty.call(data, 'lob') ? data['lob'] : ''
      const containerLoadType = Object.prototype.hasOwnProperty.call(data, 'containerLoadType') ? data['containerLoadType'] : ''
      if (lob) {
        for (const item of customJobTypes) {
          if (item.grade === 0 && item.active === true && item.type === lob && (containerLoadType === '' || (containerLoadType !== '' && item.containerLoadType === containerLoadType)) &&
              customJobType.indexOf(item.code) !== -1) {
            if (label.indexOf(item[fieldName]) === -1) {
              label.push(item[fieldName])
            }
          }
        }
      }
    }
    return label.length > 0 ? label.join(',') : ''
  }

  static storageLocationColumnUtils(value) {
    const list = getCacheListByKey(basicCacheKeys.basic_data_LocationConfiguration).filter(p => p.uuid === value)
    if (list && list.length > 0) {
      const data = list[0]
      return data.locationCode + '(' + ColumnUtils.showTypeLabelFunc(data.locationStatus, LOCATION_STATE_LIST) + ')'
    }
    return ''
  }

  /**
   * 获取回执配置-船公司
   */
  static receiptCarrierLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.RECEIPT_CARRIERS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 获取回执配置-渠道
   */
  static receiptChannelLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.RECEIPT_CHANNELS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 获取回执配置-标题
   */
  static receiptTitleLabelFunc(data) {
    const operator = SystemConstants.getCommonState(data.titleOperator, SystemConstants.RECEIPT_OPERATORS)
    const operatorName = operator === null ? '' : $store.getters.language === 'zh' ? operator.chineseName : operator.englishName
    return operatorName + (!data.title ? '' : data.title)
  }

  /**
   * 获取回执配置-正文
   */
  static receiptContentLabelFunc(data) {
    const operator = SystemConstants.getCommonState(data.contentOperator, SystemConstants.RECEIPT_OPERATORS)
    const operatorName = operator === null ? '' : $store.getters.language === 'zh' ? operator.chineseName : operator.englishName
    return operatorName + (!data.content ? '' : data.content)
  }

  /**
   * 保险-获取是否展示理赔链接
   */
  static isClaimVisible(params) {
    ColumnUtils.dateTimeLabelFunc()
    const isIssuedOrder = params.issuingState === InsuranceConstants.ISSUED_ORDER.code
    const isXNHB = params.insuranceAgent === InsuranceConstants.XNHB.code
    const isKEBAO = params.insuranceAgent === InsuranceConstants.KEBAO.code
    return isIssuedOrder && (isXNHB || isKEBAO)
  }

  /**
   * 获取理赔链接
   */
  static async jumpToInsurance(params) {
    const insuranceAgent = params.insuranceAgent
    if (insuranceAgent === InsuranceConstants.XNHB.code) {
      const payload = { uuid: params.uuid, jobUuid: params.jobUuid, branchId: params.branchId,
        insuranceAgent: insuranceAgent, policyNo: params.policyNo, insureType: params.insureType }
      // 发起投保
      this.loading = getLoading4Cxt(this)
      await getClaimJumpUrl(payload).then(res => {
        if (res.ok) {
          // 跳转小牛
          window.open(res.data)
        } else {
          this.$message(res.data.message)
        }
      }).finally(() => {
        this.loading.close()
      })
    } else if (insuranceAgent === InsuranceConstants.KEBAO.code) {
      // 跳转恪保保险
      window.open('https://www.claim.yunsafer.com/#/claim/claim')
    }
  }

  /**
   * 订舱发送方式
   */
  static bookingSendMethodLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BOOKING_SEND_METHODS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订舱传输方式
   */
  static bookingTransportModeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.TRANSPORT_MODES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 订舱失败原因
   */
  static bookingErrorCodeLabelFunc(data) {
    if (BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL.code === data.bookingErrorCode) {
      return this.getEdiTemplateValidLabelFunc(data.bookingErrorMsg)
    } else if (BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.code === data.bookingErrorCode) {
      return ($store.getters.language === 'zh' ? BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.chineseName : BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.englishName)
    } else {
      const state = SystemConstants.getCommonState(data.bookingErrorCode, SystemConstants.BOOKING_ERROR_CODES)
      if (state !== null) {
        return $store.getters.language === 'zh' ? state.chineseName : state.englishName
      }
      return this.jobBookingState(data.bookingState)
    }
  }

  /**
   * edi 模板校验 label
   */
  static getEdiTemplateValidLabelFunc(dataMsg) {
    const modelMap = ModelMap['ProperyLabelMap']
    const errorMsgArr = dataMsg ? dataMsg.split(';') : null
    const finalMessage = []
    const suffixMsg = i18n.t('SeaExport.ItIsEmpty')
    if (errorMsgArr && errorMsgArr.length > 0) {
      errorMsgArr.forEach(errorMsg => {
        const modelField = errorMsg.split('.')
        if (modelField && modelField.length > 0) {
          const model = modelMap[modelField[0]]
          if (model) {
            finalMessage.push(model[modelField[1]] + suffixMsg)
          }
        } else {
          finalMessage.push(errorMsg)
        }
      })
    }
    if (finalMessage.length > 0) {
      return finalMessage.join(' ; ')
    } else {
      return dataMsg
    }
  }

  static bookingExportStatusLabelFunc(value) {
    return value === SystemConstants.EDI_STATUS_EXPORT_SUCCESS ? $store.getters.language === 'zh' ? '已导出' : 'Exported' : $store.getters.language === 'zh' ? '未导出' : 'Not exported'
  }

  // 订舱模式
  static BookingModeLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BOOKING_MODES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 订舱渠道
  static BookingChannelLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.BOOKING_CHANNELS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // 回执配置
  static ReceiptConfigLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.RECEIPT_CONFIGS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 退款状态
   */
  static returnApplyStateLabelFun(value) {
    const state = ClearingConstants.getCommonState(value, ClearingConstants.BANK_SLIP_RETURN_APPLY_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  // soNo
  static containerSoNoLabelFun(data) {
    if (data) {
      if (data.containerDataType === CONTAINER_DATA_TYPE_POITEMS.code) {
        return data.soNo
      }
      if (data.poItems && data.poItems.length > 0) {
        const soNos = []
        for (const poItem of data.poItems) {
          if (poItem.soNo) {
            soNos.push(poItem.soNo)
          }
        }
        return soNos.join(',')
      }
      // 无【关单信息】的业务，【关单号】取自己
      return data.soNo ? data.soNo.replace(/\n/g, ',') : ''
    }
  }

  /**
   * 针对于 空出 计费重量(实)进行特殊处理
   */
  static dealAirExportChargeWeightActual(data) {
    if (data) {
      if (data.jobLob === SystemConstants.AE.code) {
        return ColumnUtils.formatNumber(data.cWeight.toString(), 3)
      } else {
        return ColumnUtils.formatNumber(data.chargeWeight.toString(), 3)
      }
    }
  }
  /**
   * 针对于 空出 计费重量(委)进行特殊处理
   */
  static dealAirExportChargeWeightContract(data) {
    if (data) {
      if (data.jobLob === SystemConstants.AE.code) {
        return ColumnUtils.formatNumber(data.chargeWeight.toString(), 3)
      } else {
        return ColumnUtils.formatNumber('0', 3)
      }
    }
  }

  /**
   * 针对于 空进 件数(实)进行特殊处理
   */
  static dealAirImportNumberOfItemsActual(data) {
    if (data) {
      if (data.jobLob === SystemConstants.AI.code) {
        return ColumnUtils.numberColumnLabelFunc(data.quantityContract)
      } else {
        return ColumnUtils.numberColumnLabelFunc(data.quantityActual)
      }
    }
  }
  /**
   * 针对于 空进 体积(实)进行特殊处理
   */

  static dealAirImportVolumeActual(data) {
    if (data) {
      if (data.jobLob === SystemConstants.AI.code) {
        return ColumnUtils.formatNumber(data.cubageContract.toString(), 3)
      } else {
        return ColumnUtils.formatNumber(data.cubageActual.toString(), 3)
      }
    }
  }

  /**
   * 港前、干线、尾程审核状态
   * @param value
   * @returns {*|string|string}
   */
  static priceJobStateLabelFunc(planner, value) {
    if (!planner || planner <= 0) return ''
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, PRICE_JOB_STATES)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }

  /**
   * 针对于 空进 毛重(实)进行特殊处理
   */
  static dealAirImportWeightActual(data) {
    if (data) {
      if (data.jobLob === SystemConstants.AI.code) {
        return ColumnUtils.number3ColumnLabelFunc(data.weightContract.toString(), 3)
      } else {
        return ColumnUtils.number3ColumnLabelFunc(data.weightActual.toString(), 3)
      }
    }
  }

  /**
   * 处理体积（委）
   * @param data
   * @returns {string|number|string|*}
   */
  static dealVolumeContract(data) {
    if (data) {
      return ColumnUtils.number3ColumnLabelFunc(data.cubageContract)
    }
  }

  /**
   * 处理毛重（委）
   * @param data
   * @returns {string|number|string|*}
   */
  static dealWeightContract(data) {
    if (data) {
      return ColumnUtils.number3ColumnLabelFunc(data.weightContract)
    }
  }

  /**
   * 件数（委）
   * @param data
   * @returns {string|number|string|*}
   */
  static dealQuantityContract(data) {
    if (data) {
      return ColumnUtils.numberColumnLabelFunc(data.quantityContract)
    }
  }

  /**
   * 简道云发送状态
   */
  static jdySendStatusLabelFunc(value) {
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, SystemConstants.JDY_STATUS)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }

  /**
   * 业务推送状态
   */
  static jobPushStatusLabelFunc(value) {
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, SystemConstants.JOB_PUSH_STATUS)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }
  static chargePushStatusLabelFunc(value) {
    if (value === '' || value === null) return ''
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_PUSH_STATUS)
    return state ? ($store.getters.language === 'zh' ? state.chineseName : state.englishName) : ''
  }

  /**
   * 单号业务类型
   */
  static NumberConfigBusinessTypeLabelFunc(value, configs) {
    const state = SystemConstants.getCommonStateNoLowerCase(value, configs)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 大包货物类型
   */
  static bigBagGoodsType(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ALL_BIG_BAG_GOODS_TYPE)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 履约类型
   */
  static fulfillmentLabel(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.ALL_FULFILLMENT_LABEL)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 指令类型
   */
  static instructionTypeLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.INSTRUCTION_TYPES)
    return state === null ? '' : $store.getters.language === SystemConstants.ZH.code ? state.chineseName : state.englishName
  }

  /**
   * 包含 5大业务类型 + fba、ie 业务类型
   */
  static fbaIeJobLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.SOP_CONFIG_LOBS)
    return state === null ? $store.getters.language === SystemConstants.ZH.code ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 应收费用确认状态
   * @param value
   */
  static chargeConfirmStateArLabFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_CONFIRM_STATE_AR)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
  /**
   * 应付费用确认状态
   * @param value
   */
  static chargeConfirmStateApLabFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.CHARGE_CONFIRM_STATE_AP)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 包含 5大业务类型 + fba、ie 业务类型
   */
  static fbaIeJobsLabelFunc(values) {
    const labels = []
    if (values && values.length > 0) {
      values.forEach(value => {
        const state = SystemConstants.getCommonState(value, SystemConstants.SOP_CONFIG_LOBS)
        const label = state === null ? $store.getters.language === SystemConstants.ZH.code ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
        labels.push(label)
      })
    }
    return labels.join(',')
  }

  /**
   * 指令来源
   */
  static instructionSourceLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.INSTRUCTION_SOURCES)
    return state === null ? '' : $store.getters.language === SystemConstants.ZH.code ? state.chineseName : state.englishName
  }

  /**
   * 租户名称
   */
  static tenantsLabelFunc(tenantIds, tenants) {
    const tenantLabels = []
    if (tenants && tenants.length > 0 && tenantIds && tenantIds.length > 0) {
      for (const tenantId of tenantIds) {
        const tenant = tenants.find(p => p.id === tenantId + '')
        if (tenant) {
          tenantLabels.push($store.getters.language === SystemConstants.ZH.code ? tenant.name : tenant.englishName)
        }
      }
    }
    return tenantLabels.join(',')
  }

  /**
   * 指令名称
   */
  static instructionNameLabelFunc(data) {
    if ($store.getters.language === SystemConstants.ZH.code) {
      return data.chineseName
    }
    if ($store.getters.language === SystemConstants.EN.code) {
      return data.englishName || data.chineseName
    }
    if ($store.getters.language === SystemConstants.JA.code) {
      return data.japaneseName || data.chineseName
    }
    return data.englishName || data.chineseName
  }

  /**
   * 指令执行结果
   */
  static instructionExecuteStatusLabelFunc(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.INSTRUCTION_EXECUTE_RESULTS)
    return state === null ? '' : $store.getters.language === SystemConstants.ZH.code ? state.chineseName : state.englishName
  }

  /**
   * 最后操作指令执行情况
   */
  static latestInstructionRecordLabelFunc(latestInstructionRecord) {
    if (latestInstructionRecord) {
      return '【' + this.instructionNameLabelFunc(latestInstructionRecord) + '】' +
          this.instructionExecuteStatusLabelFunc(latestInstructionRecord.executeStatus) + ', ' +
          this.dateTimeLabelFunc(latestInstructionRecord.dateCreated)
    }
    return ''
  }
  /**
   * 锁定类型
   */
  static LockTypeLabel(value) {
    const numberValue = value ? 1 : 0
    const state = SystemConstants.getCommonState(numberValue, SystemConstants.LOCK_TYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 账期
   */
  static getAccountPeriod(info) {
    if (!info) return ''
    if (info.termUnit === 0) {
      return (info.creditDateLimited ? info.creditDateLimited : 0) + '天'
    }

    if (info.termUnit === 1) {
      return (info.creditDateLimited ? info.creditDateLimited : 0) + '周'
    }

    if (info.termUnit === 2) {
      return (info.creditDateLimited ? info.creditDateLimited : 0) + '月'
    }

    return (info.creditDateLimited ? info.creditDateLimited : 0)
  }
  /**
   * 自定义业务类型
   */
  static getCustomJobTypeLabelFunc(cacheKey, sourceField = '', sourceValue) {
    const label = []
    const splitList = commonUtil.split(sourceValue, ',', false)
    for (const sourceValue of splitList) {
      const value = ColumnUtils.resolveColumnLabel(cacheKey, sourceField, sourceValue, $store.getters.language === SystemConstants.ZH.code ? 'name' : 'englishName')
      if (value && label.indexOf(value) === -1) {
        label.push(value)
      }
    }
    return label.length > 0 ? label.join(',') : ''
  }

  /**
   * 成本类型
   */
  static resolveCostType(code, isZh) {
    if (!code) {
      return ''
    }
    const state = SystemConstants.getCommonState(code, ChargeConstants.COLUMNS_COST_TYPES)
    if (state === null) {
      return ''
    }
    return isZh ? state.chineseName : state.englishName
  }
  /**
   * 集装器类型
   */
  static getAirplaneContainerTypeLabel(data) {
    const label = []
    if (data.voyageBoards && data.voyageBoards.length > 0) {
      data.voyageBoards.forEach(voyageBoard => {
        label.push(voyageBoard.airplaneContainerCode + '*' + voyageBoard.airplaneContainerCount)
      })
    }
    return label.join(';')
  }
  /**
   * 集装器类型 数量
   */
  static getBoardCountLabel(data) {
    let count = 0
    if (data.voyageBoards && data.voyageBoards.length > 0) {
      data.voyageBoards.forEach(voyageBoard => {
        count += Number(voyageBoard.airplaneContainerCount)
      })
    }
    return count
  }
  static getRegionLabel(data) {
    return data.provinceName + data.cityName + data.districtsName + data.townName
  }

  /**
   * 保函类型解析
   */
  static resolveColumnByGuaranteeType(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.GUARANTEE_TYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 获取密度
   */
  static getDensityLabel(data) {
    const weightAssembly = isNaN(data.weightAssembly) ? 0 : data.weightAssembly
    const cubageAssembly = isNaN(data.cubageAssembly) ? 0 : data.cubageAssembly
    if (cubageAssembly) {
      return this.number3ColumnLabelFunc(NumberUtils.ToFixed2(weightAssembly / cubageAssembly, 3))
    } else {
      return this.number3ColumnLabelFunc(0)
    }
  }

  static number3ColumnLabelFunc2(value) {
    return value ? this.number3ColumnLabelFunc(value) : 0.000
  }
  /**
   * 拼装信息label
   */
  static getAssemblyInfoLabel(value1, value2, value3) {
    const label = this.number3ColumnLabelFunc2(value1) + '/' + this.number3ColumnLabelFunc2(value2)
    if (value2 < value3) {
      return `<span style="color:red;">` + label + `</span>`
    }
    return label
  }

  /**
   * 拼装信息label
   */
  static getNotAssemblyInfoLabel(value1, value2, value3) {
    return this.number3ColumnLabelFunc2(value1) + '/' + this.number3ColumnLabelFunc2(value2) + '/' + this.number3ColumnLabelFunc2(value3)
  }

  // 企业微信账号状态
  static rpaAccountEnabledLabelFunc(value) {
    const isZh = $store.getters.language === 'zh'
    if (value) {
      return isZh ? '在线' : 'Online'
    }
    return isZh ? '离线' : 'Offline'
  }

  /**
   * 获取密度
   */
  static getDensityLabel(data) {
    const weightAssembly = isNaN(data.weightAssembly) ? 0 : data.weightAssembly
    const cubageAssembly = isNaN(data.cubageAssembly) ? 0 : data.cubageAssembly
    if (cubageAssembly) {
      return this.number3ColumnLabelFunc(NumberUtils.ToFixed2(weightAssembly / cubageAssembly, 3))
    } else {
      return this.number3ColumnLabelFunc(0)
    }
  }

  static number3ColumnLabelFunc2(value) {
    return value ? this.number3ColumnLabelFunc(value) : 0.000
  }
  /**
   * 拼装信息label
   */
  static getAssemblyInfoLabel(value1, value2, value3) {
    const label = this.number3ColumnLabelFunc2(value1) + '/' + this.number3ColumnLabelFunc2(value2)
    if (value2 < value3) {
      return `<span style="color:red;">` + label + `</span>`
    }
    return label
  }

  /**
   * 拼装信息label
   */
  static getNotAssemblyInfoLabel(value1, value2, value3) {
    return this.number3ColumnLabelFunc2(value1) + '/' + this.number3ColumnLabelFunc2(value2) + '/' + this.number3ColumnLabelFunc2(value3)
  }

  /**
   * 对账状态
   * @param value
   */
  static reconciliationStateLabelFunc(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.RECONCILIATION_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 对账调整状态
   * @param value
   */
  static reconciliationAdjustStateLabelFunc(value) {
    const state = ChargeConstants.getCommonState(value, ChargeConstants.RECONCILIATION_ADJUST_STATES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 发票抬头
   */
  static getInvoiceTitleLabel(uuid, ourInvoiceTitleArray) {
    if (ourInvoiceTitleArray && ourInvoiceTitleArray.length > 0) {
      const title = ourInvoiceTitleArray.find(p => p.uuid === uuid)
      if (title) {
        return title.invoiceTitle
      }
    }
    return ''
  }

  /**
   * 起运港信息label
   */
  static getPolLabel(data) {
    if (data.portType === SystemConstants.PORT_TYPE_SEAPORT.code) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', data.pol, 'englishName')
    }
    return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', data.pol, 'englishName')
  }

  /**
   * 起运港信息label
   */
  static getSeaAirPortLabel(value) {
    const res = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'englishName')
    if (res) {
      return res
    }
    return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'englishName')
  }

  /**
   * 起运港信息label
   */
  static getSeaAirPortLabels(value) {
    if (value) {
      const label = []
      for (const item of value.split(',')) {
        let itemLabel = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', item, 'englishName')
        if (itemLabel) {
          label.push(itemLabel)
          continue
        }
        itemLabel = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', item, 'englishName')
        if (itemLabel) {
          label.push(itemLabel)
        }
      }
      return label.join(',')
    }
    return ''
  }

  /**
   * 目的港信息label
   */
  static getPodLabel(data) {
    if (data.pod) {
      let basicPort = TYPE_NAMES.basic_data_Seaport
      if (data.portType === SystemConstants.PORT_TYPE_AIRPORT.code) {
        basicPort = TYPE_NAMES.basic_data_Airport
      }
      const label = []
      for (const item of data.pod.split(',')) {
        const itemLabel = ColumnUtils.resolveColumnLabel(basicPort, 'code', item, 'englishName')
        if (itemLabel) {
          label.push(itemLabel)
        }
      }
      return label.join(',')
    }
    return ''
  }

  /**
   * 配送地址label
   */
  static getDeliveryAddressLabel(data) {
    if (data.priceRegions && data.priceRegions.length > 0) {
      const label = []
      for (const item of data.priceRegions) {
        const itemLabel = []
        itemLabel.push(lang.t('CargoMsg.Cargo_DeliveryAddressType') + ' : ' + this.showTypeLabelFunc(item.deliveryAddressType, SystemConstants.DELIVERY_ADDRESS_TYPES))
        if (item.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code) {
          if (item.postalCodeStr) {
            itemLabel.push(lang.t('SeaExport.ZIP') + ' : ' + item.postalCodeStr)
          }
          if (item.address) {
            itemLabel.push(lang.t('SeaExport.Addr') + ' : ' + item.address)
          }
          if (item.provinceName) {
            itemLabel.push(lang.t('CargoMsg.Cargo_Province') + ' : ' + item.provinceName)
            if (item.cityName) {
              itemLabel.push(lang.t('CargoMsg.Cargo_city') + ' : ' + item.cityName)
              if (item.districtsName) {
                itemLabel.push(lang.t('CargoMsg.Cargo_District') + ' : ' + item.districtsName)
                if (item.townName) {
                  itemLabel.push(lang.t('CargoMsg.Cargo_StreetTownship') + ' : ' + item.townName)
                }
              }
            }
          }
        } else {
          if (item.warehouseCode) {
            itemLabel.push(lang.t('CargoMsg.Cargo_WarehouseCode2') + ' : ' + item.warehouseCode)
          }
        }
        label.push(itemLabel.join(' , '))
      }
      return label.join(' ; ')
    }
    return ''
  }

  /**
   * 获取箱型label
   */
  static getEqSizeLabel(data, field) {
    if (data.byEqSizeChargingItems && data.byEqSizeChargingItems.length > 0) {
      let value = 0
      data.byEqSizeChargingItems.forEach(chargeItem => {
        if (chargeItem[field]) {
          value += Number(chargeItem[field])
        }
      })
      return value === 0 ? '' : NumberUtils.ToFixed2(value, 2)
    }
    return ''
  }

  /**
   * 航交所运价批次预警类型
   */
  static openPriceWarningTypesLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OPEN_PRICE_WARNING_TYPES)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 获取第一条运价的币种label
   */
  static getFirstPriceCurrency(data) {
    if (data.byEqSizeChargingItems && data.byEqSizeChargingItems.length > 0) {
      return data.byEqSizeChargingItems[0].currency
    }
    if (data.notByEqSizeChargingItems && data.notByEqSizeChargingItems.length > 0) {
      return data.notByEqSizeChargingItems[0].currency
    }
    return ''
  }

  /**
   * 货好时间
   */
  static getCargoReadyTimeLabel(data) {
    if (data.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code) {
      return this.showTypeLabelFunc(data.cargoReadyTimeRange, SystemConstants.CARGO_READY_TIME_RANGES)
    } else {
      return this.dateLabelFunc(data.cargoReadyTimeDate)
    }
  }

  static airPriceLabel(value) {
    if (value === 0) return 0
    if (!value) {
      return ''
    }
    if (value === PriceConstant.TACT) return 'TACT'
    if (value === PriceConstant.NIL) return 'NIL'
    return Number(value).toFixed(2)
  }

  static eqPriceLabel(value) {
    if (value === 0) return 0
    if (!value || value < 0) {
      return ''
    }
    return Number(value).toFixed(2)
  }

  /**
   * 航交所运价批次状态
   */
  static OpenPriceBatchStateLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OPEN_PRICE_BATCHS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 航交所运价RPA状态
   */
  static OpenPriceRpaStateLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OPEN_PRICE_RPAS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  static OpenPriceWarningStateLabelFun(value) {
    const state = SystemConstants.getCommonState(value, SystemConstants.OPEN_PRICE_WARNINGS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }

  /**
   * 验证结果
   */
  static CheckRuleResultLabelFun(value) {
    const state = SystemConstants.getCommonState(value || 'EMPTY', SystemConstants.CHECK_RESULTS)
    return state === null ? '' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
  }
}
export default ColumnUtils
